//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class BIMDataValidatorClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    loginMicrosoft(body: AuthMicrosoftRequest | undefined, cancelToken?: CancelToken): Promise<AuthResponse> {
        let url_ = this.baseUrl + "/Auth/loginMicrosoft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginMicrosoft(_response);
        });
    }

    protected processLoginMicrosoft(response: AxiosResponse): Promise<AuthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthResponse.fromJS(resultData200);
            return Promise.resolve<AuthResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    loginLocal(body: AuthLocalRequest | undefined, cancelToken?: CancelToken): Promise<AuthResponse> {
        let url_ = this.baseUrl + "/Auth/loginLocal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginLocal(_response);
        });
    }

    protected processLoginLocal(response: AxiosResponse): Promise<AuthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthResponse.fromJS(resultData200);
            return Promise.resolve<AuthResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    signupMicrosoft(body: SignupMicrosoftRequest | undefined, cancelToken?: CancelToken): Promise<SignupResponse> {
        let url_ = this.baseUrl + "/Auth/signupMicrosoft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignupMicrosoft(_response);
        });
    }

    protected processSignupMicrosoft(response: AxiosResponse): Promise<SignupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SignupResponse.fromJS(resultData200);
            return Promise.resolve<SignupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SignupResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshToken(body: RefreshTokenRequest | undefined, cancelToken?: CancelToken): Promise<RefreshTokenResponse> {
        let url_ = this.baseUrl + "/Auth/refreshToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<RefreshTokenResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RefreshTokenResponse.fromJS(resultData200);
            return Promise.resolve<RefreshTokenResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RefreshTokenResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    hashOfPassword(body: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Auth/hashOfPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHashOfPassword(_response);
        });
    }

    protected processHashOfPassword(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    getAppLogo( cancelToken?: CancelToken): Promise<GetAppLogoResponse> {
        let url_ = this.baseUrl + "/Auth/GetAppLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAppLogo(_response);
        });
    }

    protected processGetAppLogo(response: AxiosResponse): Promise<GetAppLogoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAppLogoResponse.fromJS(resultData200);
            return Promise.resolve<GetAppLogoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAppLogoResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUserInfo( cancelToken?: CancelToken): Promise<GetUserInfoResponse> {
        let url_ = this.baseUrl + "/Auth/GetUserInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserInfo(_response);
        });
    }

    protected processGetUserInfo(response: AxiosResponse): Promise<GetUserInfoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserInfoResponse.fromJS(resultData200);
            return Promise.resolve<GetUserInfoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserInfoResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUserTenants(userId: number, cancelToken?: CancelToken): Promise<GetUserTenantsResponse> {
        let url_ = this.baseUrl + "/Auth/GetUserTenants/{UserId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{UserId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserTenants(_response);
        });
    }

    protected processGetUserTenants(response: AxiosResponse): Promise<GetUserTenantsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserTenantsResponse.fromJS(resultData200);
            return Promise.resolve<GetUserTenantsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserTenantsResponse>(null as any);
    }

    /**
     * @return Success
     */
    isAuthed( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Auth/IsAuthed";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsAuthed(_response);
        });
    }

    protected processIsAuthed(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProject(body: CreateProjectRequest | undefined, cancelToken?: CancelToken): Promise<CreateProjectResponse> {
        let url_ = this.baseUrl + "/Curve/CreateProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProject(_response);
        });
    }

    protected processCreateProject(response: AxiosResponse): Promise<CreateProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateProjectResponse.fromJS(resultData200);
            return Promise.resolve<CreateProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateProjectResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProject(body: UpdateProjectRequest | undefined, cancelToken?: CancelToken): Promise<UpdateProjectResponse> {
        let url_ = this.baseUrl + "/Curve/UpdateProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProject(_response);
        });
    }

    protected processUpdateProject(response: AxiosResponse): Promise<UpdateProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateProjectResponse.fromJS(resultData200);
            return Promise.resolve<UpdateProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateProjectResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteProject(body: DeleteProjectRequest | undefined, cancelToken?: CancelToken): Promise<DeleteProjectResponse> {
        let url_ = this.baseUrl + "/Curve/DeleteProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProject(_response);
        });
    }

    protected processDeleteProject(response: AxiosResponse): Promise<DeleteProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteProjectResponse.fromJS(resultData200);
            return Promise.resolve<DeleteProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteProjectResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRoute(body: CreateRouteRequest | undefined, cancelToken?: CancelToken): Promise<CreateRouteResponse> {
        let url_ = this.baseUrl + "/Curve/CreateRoute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRoute(_response);
        });
    }

    protected processCreateRoute(response: AxiosResponse): Promise<CreateRouteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateRouteResponse.fromJS(resultData200);
            return Promise.resolve<CreateRouteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateRouteResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRoute(body: UpdateRouteRequest | undefined, cancelToken?: CancelToken): Promise<UpdateRouteResponse> {
        let url_ = this.baseUrl + "/Curve/UpdateRoute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRoute(_response);
        });
    }

    protected processUpdateRoute(response: AxiosResponse): Promise<UpdateRouteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateRouteResponse.fromJS(resultData200);
            return Promise.resolve<UpdateRouteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateRouteResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteRoute(body: DeleteRouteRequest | undefined, cancelToken?: CancelToken): Promise<DeleteRouteResponse> {
        let url_ = this.baseUrl + "/Curve/DeleteRoute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRoute(_response);
        });
    }

    protected processDeleteRoute(response: AxiosResponse): Promise<DeleteRouteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteRouteResponse.fromJS(resultData200);
            return Promise.resolve<DeleteRouteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteRouteResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateCurves(body: CreateOrUpdateCurvesRequest | undefined, cancelToken?: CancelToken): Promise<CreateOrUpdateCurvesResponse> {
        let url_ = this.baseUrl + "/Curve/CreateOrUpdateCurves";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateCurves(_response);
        });
    }

    protected processCreateOrUpdateCurves(response: AxiosResponse): Promise<CreateOrUpdateCurvesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateOrUpdateCurvesResponse.fromJS(resultData200);
            return Promise.resolve<CreateOrUpdateCurvesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateOrUpdateCurvesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importMultiCurvesNew(body: ImportMultiCurvesNewRequest | undefined, cancelToken?: CancelToken): Promise<ImportMultiCurvesNewResponse> {
        let url_ = this.baseUrl + "/Curve/ImportMultiCurvesNew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportMultiCurvesNew(_response);
        });
    }

    protected processImportMultiCurvesNew(response: AxiosResponse): Promise<ImportMultiCurvesNewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportMultiCurvesNewResponse.fromJS(resultData200);
            return Promise.resolve<ImportMultiCurvesNewResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportMultiCurvesNewResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteCurve(body: DeleteCurveRequest | undefined, cancelToken?: CancelToken): Promise<DeleteCurveResponse> {
        let url_ = this.baseUrl + "/Curve/DeleteCurve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCurve(_response);
        });
    }

    protected processDeleteCurve(response: AxiosResponse): Promise<DeleteCurveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteCurveResponse.fromJS(resultData200);
            return Promise.resolve<DeleteCurveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteCurveResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProjectsForTenant( cancelToken?: CancelToken): Promise<GetProjectsForTenantResponse> {
        let url_ = this.baseUrl + "/Curve/GetProjectsForTenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectsForTenant(_response);
        });
    }

    protected processGetProjectsForTenant(response: AxiosResponse): Promise<GetProjectsForTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectsForTenantResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectsForTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectsForTenantResponse>(null as any);
    }

    /**
     * @return Success
     */
    getCurvesForRoute(id: number, cancelToken?: CancelToken): Promise<GetCurvesForRouteResponse> {
        let url_ = this.baseUrl + "/Curve/GetCurvesForRoute/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurvesForRoute(_response);
        });
    }

    protected processGetCurvesForRoute(response: AxiosResponse): Promise<GetCurvesForRouteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCurvesForRouteResponse.fromJS(resultData200);
            return Promise.resolve<GetCurvesForRouteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCurvesForRouteResponse>(null as any);
    }

    /**
     * @return Success
     */
    getRoutesForProject(id: number, cancelToken?: CancelToken): Promise<GetRoutesForProjectResponse> {
        let url_ = this.baseUrl + "/Curve/GetRoutesForProject/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoutesForProject(_response);
        });
    }

    protected processGetRoutesForProject(response: AxiosResponse): Promise<GetRoutesForProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRoutesForProjectResponse.fromJS(resultData200);
            return Promise.resolve<GetRoutesForProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRoutesForProjectResponse>(null as any);
    }

    /**
     * @return Success
     */
    getStandards( cancelToken?: CancelToken): Promise<GetDataStandardsResponse> {
        let url_ = this.baseUrl + "/Data/GetStandards";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStandards(_response);
        });
    }

    protected processGetStandards(response: AxiosResponse): Promise<GetDataStandardsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDataStandardsResponse.fromJS(resultData200);
            return Promise.resolve<GetDataStandardsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDataStandardsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createStandard(body: CreateDataStandardRequest | undefined, cancelToken?: CancelToken): Promise<CreateDataStandardResponse> {
        let url_ = this.baseUrl + "/Data/CreateStandard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateStandard(_response);
        });
    }

    protected processCreateStandard(response: AxiosResponse): Promise<CreateDataStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateDataStandardResponse.fromJS(resultData200);
            return Promise.resolve<CreateDataStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateDataStandardResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyStandard(body: CopyDataStandardRequest | undefined, cancelToken?: CancelToken): Promise<CopyDataStandardResponse> {
        let url_ = this.baseUrl + "/Data/CopyStandard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyStandard(_response);
        });
    }

    protected processCopyStandard(response: AxiosResponse): Promise<CopyDataStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CopyDataStandardResponse.fromJS(resultData200);
            return Promise.resolve<CopyDataStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CopyDataStandardResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStandard(body: UpdateDataStandardRequest | undefined, cancelToken?: CancelToken): Promise<UpdateDataStandardResponse> {
        let url_ = this.baseUrl + "/Data/UpdateStandard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStandard(_response);
        });
    }

    protected processUpdateStandard(response: AxiosResponse): Promise<UpdateDataStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateDataStandardResponse.fromJS(resultData200);
            return Promise.resolve<UpdateDataStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateDataStandardResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteStandard(id: number, cancelToken?: CancelToken): Promise<EmptyResponse> {
        let url_ = this.baseUrl + "/Data/DeleteStandard/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteStandard(_response);
        });
    }

    protected processDeleteStandard(response: AxiosResponse): Promise<EmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmptyResponse.fromJS(resultData200);
            return Promise.resolve<EmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyResponse>(null as any);
    }

    /**
     * @return Success
     */
    getGroupsForStandard(standardId: number, cancelToken?: CancelToken): Promise<GetGroupsForStandardResponse> {
        let url_ = this.baseUrl + "/Data/GetGroupsForStandard/{StandardId}";
        if (standardId === undefined || standardId === null)
            throw new Error("The parameter 'standardId' must be defined.");
        url_ = url_.replace("{StandardId}", encodeURIComponent("" + standardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGroupsForStandard(_response);
        });
    }

    protected processGetGroupsForStandard(response: AxiosResponse): Promise<GetGroupsForStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetGroupsForStandardResponse.fromJS(resultData200);
            return Promise.resolve<GetGroupsForStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetGroupsForStandardResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createGroupForStandard(body: CreateGroupForStandardRequest | undefined, cancelToken?: CancelToken): Promise<CreateEntityResponse> {
        let url_ = this.baseUrl + "/Data/CreateGroupForStandard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGroupForStandard(_response);
        });
    }

    protected processCreateGroupForStandard(response: AxiosResponse): Promise<CreateEntityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateEntityResponse.fromJS(resultData200);
            return Promise.resolve<CreateEntityResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateEntityResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateGroupForStandard(body: UpdateGroupForStandardRequest | undefined, cancelToken?: CancelToken): Promise<UpdateResponse> {
        let url_ = this.baseUrl + "/Data/UpdateGroupForStandard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGroupForStandard(_response);
        });
    }

    protected processUpdateGroupForStandard(response: AxiosResponse): Promise<UpdateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateResponse.fromJS(resultData200);
            return Promise.resolve<UpdateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteGroupForStandard(groupId: number, cancelToken?: CancelToken): Promise<EmptyResponse> {
        let url_ = this.baseUrl + "/Data/DeleteGroupForStandard/{GroupId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{GroupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteGroupForStandard(_response);
        });
    }

    protected processDeleteGroupForStandard(response: AxiosResponse): Promise<EmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmptyResponse.fromJS(resultData200);
            return Promise.resolve<EmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateSingleFilter(body: FilterElementsRequest | undefined, cancelToken?: CancelToken): Promise<EmptyResponse> {
        let url_ = this.baseUrl + "/Data/ValidateSingleFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateSingleFilter(_response);
        });
    }

    protected processValidateSingleFilter(response: AxiosResponse): Promise<EmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmptyResponse.fromJS(resultData200);
            return Promise.resolve<EmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPairer(body: CreatePairerRequest | undefined, cancelToken?: CancelToken): Promise<CreateEntityResponse> {
        let url_ = this.baseUrl + "/Data/CreatePairer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePairer(_response);
        });
    }

    protected processCreatePairer(response: AxiosResponse): Promise<CreateEntityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateEntityResponse.fromJS(resultData200);
            return Promise.resolve<CreateEntityResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateEntityResponse>(null as any);
    }

    /**
     * @return Success
     */
    deletePairer(id: number, cancelToken?: CancelToken): Promise<EmptyResponse> {
        let url_ = this.baseUrl + "/Data/DeletePairer/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePairer(_response);
        });
    }

    protected processDeletePairer(response: AxiosResponse): Promise<EmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmptyResponse.fromJS(resultData200);
            return Promise.resolve<EmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deletePairers(body: DeletePairersRequest | undefined, cancelToken?: CancelToken): Promise<EmptyResponse> {
        let url_ = this.baseUrl + "/Data/DeletePairers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePairers(_response);
        });
    }

    protected processDeletePairers(response: AxiosResponse): Promise<EmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmptyResponse.fromJS(resultData200);
            return Promise.resolve<EmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRule(body: CreateValidationsRuleRequest | undefined, cancelToken?: CancelToken): Promise<CreateEntityResponse> {
        let url_ = this.baseUrl + "/Data/CreateRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRule(_response);
        });
    }

    protected processCreateRule(response: AxiosResponse): Promise<CreateEntityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateEntityResponse.fromJS(resultData200);
            return Promise.resolve<CreateEntityResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateEntityResponse>(null as any);
    }

    /**
     * @return Success
     */
    getPairerDetail(id: number, cancelToken?: CancelToken): Promise<GetPairerDetailResponse> {
        let url_ = this.baseUrl + "/Data/GetPairerDetail/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPairerDetail(_response);
        });
    }

    protected processGetPairerDetail(response: AxiosResponse): Promise<GetPairerDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPairerDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetPairerDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPairerDetailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateModel(body: ValidateModelRequest | undefined, cancelToken?: CancelToken): Promise<ValidateModelResponse> {
        let url_ = this.baseUrl + "/Data/ValidateModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateModel(_response);
        });
    }

    protected processValidateModel(response: AxiosResponse): Promise<ValidateModelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateModelResponse.fromJS(resultData200);
            return Promise.resolve<ValidateModelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateModelResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateModelTreeResultLarge(body: ValidateModelAndReturnByPairersRequest | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Data/ValidateModelTreeResultLarge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateModelTreeResultLarge(_response);
        });
    }

    protected processValidateModelTreeResultLarge(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateModelTreeResult(body: ValidateModelAndReturnByPairersRequest | undefined, cancelToken?: CancelToken): Promise<ValidateModelAndReturnByPairersResponse> {
        let url_ = this.baseUrl + "/Data/ValidateModelTreeResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateModelTreeResult(_response);
        });
    }

    protected processValidateModelTreeResult(response: AxiosResponse): Promise<ValidateModelAndReturnByPairersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateModelAndReturnByPairersResponse.fromJS(resultData200);
            return Promise.resolve<ValidateModelAndReturnByPairersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateModelAndReturnByPairersResponse>(null as any);
    }

    /**
     * @return Success
     */
    getPairersListForGroupId(groupId: number, cancelToken?: CancelToken): Promise<GetPairerListForGroupIdResponse> {
        let url_ = this.baseUrl + "/Data/GetPairersListForGroupId/{GroupId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{GroupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPairersListForGroupId(_response);
        });
    }

    protected processGetPairersListForGroupId(response: AxiosResponse): Promise<GetPairerListForGroupIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPairerListForGroupIdResponse.fromJS(resultData200);
            return Promise.resolve<GetPairerListForGroupIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPairerListForGroupIdResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteValidationsRule(id: number, cancelToken?: CancelToken): Promise<EmptyResponse> {
        let url_ = this.baseUrl + "/Data/DeleteValidationsRule/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteValidationsRule(_response);
        });
    }

    protected processDeleteValidationsRule(response: AxiosResponse): Promise<EmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmptyResponse.fromJS(resultData200);
            return Promise.resolve<EmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateValidationsRule(body: UpdateValidationsRuleRequest | undefined, cancelToken?: CancelToken): Promise<UpdateResponse> {
        let url_ = this.baseUrl + "/Data/UpdateValidationsRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateValidationsRule(_response);
        });
    }

    protected processUpdateValidationsRule(response: AxiosResponse): Promise<UpdateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateResponse.fromJS(resultData200);
            return Promise.resolve<UpdateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyValidationRules(body: CopyValidationRulesRequest | undefined, cancelToken?: CancelToken): Promise<CopyValidationRulesResponse> {
        let url_ = this.baseUrl + "/Data/CopyValidationRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyValidationRules(_response);
        });
    }

    protected processCopyValidationRules(response: AxiosResponse): Promise<CopyValidationRulesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CopyValidationRulesResponse.fromJS(resultData200);
            return Promise.resolve<CopyValidationRulesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CopyValidationRulesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyPairers(body: CopyPairersRequest | undefined, cancelToken?: CancelToken): Promise<CopyPairersResponse> {
        let url_ = this.baseUrl + "/Data/CopyPairers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyPairers(_response);
        });
    }

    protected processCopyPairers(response: AxiosResponse): Promise<CopyPairersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CopyPairersResponse.fromJS(resultData200);
            return Promise.resolve<CopyPairersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CopyPairersResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePairer(body: UpdatePairerRequest | undefined, cancelToken?: CancelToken): Promise<UpdateResponse> {
        let url_ = this.baseUrl + "/Data/UpdatePairer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePairer(_response);
        });
    }

    protected processUpdatePairer(response: AxiosResponse): Promise<UpdateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateResponse.fromJS(resultData200);
            return Promise.resolve<UpdateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMutliPairerByIds(body: GetMultiPairerByIdsRequest | undefined, cancelToken?: CancelToken): Promise<GetMultiPairerByIdsResponse> {
        let url_ = this.baseUrl + "/Data/GetMutliPairerByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMutliPairerByIds(_response);
        });
    }

    protected processGetMutliPairerByIds(response: AxiosResponse): Promise<GetMultiPairerByIdsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMultiPairerByIdsResponse.fromJS(resultData200);
            return Promise.resolve<GetMultiPairerByIdsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMultiPairerByIdsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getMutliPairerByGroupId(groupId: number, cancelToken?: CancelToken): Promise<GetMultiPairerByGroupIdResponse> {
        let url_ = this.baseUrl + "/Data/GetMutliPairerByGroupId/{GroupId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{GroupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMutliPairerByGroupId(_response);
        });
    }

    protected processGetMutliPairerByGroupId(response: AxiosResponse): Promise<GetMultiPairerByGroupIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMultiPairerByGroupIdResponse.fromJS(resultData200);
            return Promise.resolve<GetMultiPairerByGroupIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMultiPairerByGroupIdResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPairerOrGroup(body: CreateOrGroupRequest | undefined, cancelToken?: CancelToken): Promise<CreateEntityResponse> {
        let url_ = this.baseUrl + "/Data/CreatePairerOrGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePairerOrGroup(_response);
        });
    }

    protected processCreatePairerOrGroup(response: AxiosResponse): Promise<CreateEntityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateEntityResponse.fromJS(resultData200);
            return Promise.resolve<CreateEntityResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateEntityResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRuleInPairerOrGroup(body: CreateValidationRuleInOrGroupRequest | undefined, cancelToken?: CancelToken): Promise<CreateEntityResponse> {
        let url_ = this.baseUrl + "/Data/CreateRuleInPairerOrGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRuleInPairerOrGroup(_response);
        });
    }

    protected processCreateRuleInPairerOrGroup(response: AxiosResponse): Promise<CreateEntityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateEntityResponse.fromJS(resultData200);
            return Promise.resolve<CreateEntityResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateEntityResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteOrGroup(id: number, cancelToken?: CancelToken): Promise<EmptyResponse> {
        let url_ = this.baseUrl + "/Data/DeleteOrGroup/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOrGroup(_response);
        });
    }

    protected processDeleteOrGroup(response: AxiosResponse): Promise<EmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmptyResponse.fromJS(resultData200);
            return Promise.resolve<EmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveMultiPairer(body: SaveMultiPairerRequest | undefined, cancelToken?: CancelToken): Promise<SaveMultiPairerResponse> {
        let url_ = this.baseUrl + "/Data/SaveMultiPairer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveMultiPairer(_response);
        });
    }

    protected processSaveMultiPairer(response: AxiosResponse): Promise<SaveMultiPairerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveMultiPairerResponse.fromJS(resultData200);
            return Promise.resolve<SaveMultiPairerResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveMultiPairerResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOrGroup(body: UpdateOrGroupRequest | undefined, cancelToken?: CancelToken): Promise<UpdateOrGroupResponse> {
        let url_ = this.baseUrl + "/Data/UpdateOrGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrGroup(_response);
        });
    }

    protected processUpdateOrGroup(response: AxiosResponse): Promise<UpdateOrGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateOrGroupResponse.fromJS(resultData200);
            return Promise.resolve<UpdateOrGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateOrGroupResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteOrGroupRuleSet(body: DeleteOrGroupRuleSetRequest | undefined, cancelToken?: CancelToken): Promise<DeleteOrGroupRuleSetResponse> {
        let url_ = this.baseUrl + "/Data/DeleteOrGroupRuleSet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOrGroupRuleSet(_response);
        });
    }

    protected processDeleteOrGroupRuleSet(response: AxiosResponse): Promise<DeleteOrGroupRuleSetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteOrGroupRuleSetResponse.fromJS(resultData200);
            return Promise.resolve<DeleteOrGroupRuleSetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteOrGroupRuleSetResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProjectData(body: UpdateProjectDataRequest | undefined, cancelToken?: CancelToken): Promise<UpdateProjectDataResponse> {
        let url_ = this.baseUrl + "/Data/UpdateProjectData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProjectData(_response);
        });
    }

    protected processUpdateProjectData(response: AxiosResponse): Promise<UpdateProjectDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateProjectDataResponse.fromJS(resultData200);
            return Promise.resolve<UpdateProjectDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateProjectDataResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDataStandardForTreePairing(standardId: number, cancelToken?: CancelToken): Promise<GetDataStandardForTreePairingResponse> {
        let url_ = this.baseUrl + "/Data/GetDataStandardForTreePairing/{StandardId}";
        if (standardId === undefined || standardId === null)
            throw new Error("The parameter 'standardId' must be defined.");
        url_ = url_.replace("{StandardId}", encodeURIComponent("" + standardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDataStandardForTreePairing(_response);
        });
    }

    protected processGetDataStandardForTreePairing(response: AxiosResponse): Promise<GetDataStandardForTreePairingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDataStandardForTreePairingResponse.fromJS(resultData200);
            return Promise.resolve<GetDataStandardForTreePairingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDataStandardForTreePairingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addMicrostationPairingPairer(body: AddMicrostationPairingPairerRequest | undefined, cancelToken?: CancelToken): Promise<AddMicrostationPairingPairerResponse> {
        let url_ = this.baseUrl + "/Data/AddMicrostationPairingPairer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddMicrostationPairingPairer(_response);
        });
    }

    protected processAddMicrostationPairingPairer(response: AxiosResponse): Promise<AddMicrostationPairingPairerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddMicrostationPairingPairerResponse.fromJS(resultData200);
            return Promise.resolve<AddMicrostationPairingPairerResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddMicrostationPairingPairerResponse>(null as any);
    }

    /**
     * @return Success
     */
    getMicrostationPairingPairers(mStnPairingId: number, pairerId: number, type: number, levelName: string, cancelToken?: CancelToken): Promise<GetMicrostationPairingPairersResponse> {
        let url_ = this.baseUrl + "/Data/GetMicrostationPairingPairers/{MStnPairingId}/{PairerId}/{Type}/{LevelName}";
        if (mStnPairingId === undefined || mStnPairingId === null)
            throw new Error("The parameter 'mStnPairingId' must be defined.");
        url_ = url_.replace("{MStnPairingId}", encodeURIComponent("" + mStnPairingId));
        if (pairerId === undefined || pairerId === null)
            throw new Error("The parameter 'pairerId' must be defined.");
        url_ = url_.replace("{PairerId}", encodeURIComponent("" + pairerId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{Type}", encodeURIComponent("" + type));
        if (levelName === undefined || levelName === null)
            throw new Error("The parameter 'levelName' must be defined.");
        url_ = url_.replace("{LevelName}", encodeURIComponent("" + levelName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMicrostationPairingPairers(_response);
        });
    }

    protected processGetMicrostationPairingPairers(response: AxiosResponse): Promise<GetMicrostationPairingPairersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMicrostationPairingPairersResponse.fromJS(resultData200);
            return Promise.resolve<GetMicrostationPairingPairersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMicrostationPairingPairersResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteMicrostationPairingPairer(pairingId: number, cancelToken?: CancelToken): Promise<DeleteMicrostationPairingPairerResponse> {
        let url_ = this.baseUrl + "/Data/DeleteMicrostationPairingPairer/{PairingId}";
        if (pairingId === undefined || pairingId === null)
            throw new Error("The parameter 'pairingId' must be defined.");
        url_ = url_.replace("{PairingId}", encodeURIComponent("" + pairingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMicrostationPairingPairer(_response);
        });
    }

    protected processDeleteMicrostationPairingPairer(response: AxiosResponse): Promise<DeleteMicrostationPairingPairerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteMicrostationPairingPairerResponse.fromJS(resultData200);
            return Promise.resolve<DeleteMicrostationPairingPairerResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteMicrostationPairingPairerResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDataStandardForTreeValRule(standardId: number, cancelToken?: CancelToken): Promise<GetDataStandardForTreeValRuleResponse> {
        let url_ = this.baseUrl + "/Data/GetDataStandardForTreeValRule/{StandardId}";
        if (standardId === undefined || standardId === null)
            throw new Error("The parameter 'standardId' must be defined.");
        url_ = url_.replace("{StandardId}", encodeURIComponent("" + standardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDataStandardForTreeValRule(_response);
        });
    }

    protected processGetDataStandardForTreeValRule(response: AxiosResponse): Promise<GetDataStandardForTreeValRuleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDataStandardForTreeValRuleResponse.fromJS(resultData200);
            return Promise.resolve<GetDataStandardForTreeValRuleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDataStandardForTreeValRuleResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMStnPairingsByLevels(body: GetMStnPairingsByLevelsRequest | undefined, cancelToken?: CancelToken): Promise<GetMStnPairingsByLevelsResponse> {
        let url_ = this.baseUrl + "/Data/GetMStnPairingsByLevels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMStnPairingsByLevels(_response);
        });
    }

    protected processGetMStnPairingsByLevels(response: AxiosResponse): Promise<GetMStnPairingsByLevelsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMStnPairingsByLevelsResponse.fromJS(resultData200);
            return Promise.resolve<GetMStnPairingsByLevelsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMStnPairingsByLevelsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMStnPairingsByRelevance(body: GetMStnPairingsByRelevanceRequest | undefined, cancelToken?: CancelToken): Promise<GetMStnPairingsByRelevanceResponse> {
        let url_ = this.baseUrl + "/Data/GetMStnPairingsByRelevance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMStnPairingsByRelevance(_response);
        });
    }

    protected processGetMStnPairingsByRelevance(response: AxiosResponse): Promise<GetMStnPairingsByRelevanceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMStnPairingsByRelevanceResponse.fromJS(resultData200);
            return Promise.resolve<GetMStnPairingsByRelevanceResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMStnPairingsByRelevanceResponse>(null as any);
    }

    /**
     * @return Success
     */
    getMStnPairingsLevelsName(mStnPairingId: number, cancelToken?: CancelToken): Promise<GetMStnPairingsLevelsNameResponse> {
        let url_ = this.baseUrl + "/Data/GetMStnPairingsLevelsName/{MStnPairingId}";
        if (mStnPairingId === undefined || mStnPairingId === null)
            throw new Error("The parameter 'mStnPairingId' must be defined.");
        url_ = url_.replace("{MStnPairingId}", encodeURIComponent("" + mStnPairingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMStnPairingsLevelsName(_response);
        });
    }

    protected processGetMStnPairingsLevelsName(response: AxiosResponse): Promise<GetMStnPairingsLevelsNameResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMStnPairingsLevelsNameResponse.fromJS(resultData200);
            return Promise.resolve<GetMStnPairingsLevelsNameResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMStnPairingsLevelsNameResponse>(null as any);
    }

    /**
     * @return Success
     */
    getMicrostationPairing( cancelToken?: CancelToken): Promise<GetMicrostationPairingResponse> {
        let url_ = this.baseUrl + "/Data/GetMicrostationPairing";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMicrostationPairing(_response);
        });
    }

    protected processGetMicrostationPairing(response: AxiosResponse): Promise<GetMicrostationPairingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMicrostationPairingResponse.fromJS(resultData200);
            return Promise.resolve<GetMicrostationPairingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMicrostationPairingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMicrostationPairing(body: CreateMicrostationPairingRequest | undefined, cancelToken?: CancelToken): Promise<CreateMicrostationPairingResponse> {
        let url_ = this.baseUrl + "/Data/CreateMicrostationPairing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMicrostationPairing(_response);
        });
    }

    protected processCreateMicrostationPairing(response: AxiosResponse): Promise<CreateMicrostationPairingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateMicrostationPairingResponse.fromJS(resultData200);
            return Promise.resolve<CreateMicrostationPairingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateMicrostationPairingResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteMicrostationPairing(pairingId: number, cancelToken?: CancelToken): Promise<DeleteMicrostationPairingResponse> {
        let url_ = this.baseUrl + "/Data/DeleteMicrostationPairing/{PairingId}";
        if (pairingId === undefined || pairingId === null)
            throw new Error("The parameter 'pairingId' must be defined.");
        url_ = url_.replace("{PairingId}", encodeURIComponent("" + pairingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMicrostationPairing(_response);
        });
    }

    protected processDeleteMicrostationPairing(response: AxiosResponse): Promise<DeleteMicrostationPairingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteMicrostationPairingResponse.fromJS(resultData200);
            return Promise.resolve<DeleteMicrostationPairingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteMicrostationPairingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMStnPairingsByRelevance2(body: GetMStnPairingsByRelevance2Request | undefined, cancelToken?: CancelToken): Promise<GetMStnPairingsByRelevance2Response> {
        let url_ = this.baseUrl + "/Data/GetMStnPairingsByRelevance2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMStnPairingsByRelevance2(_response);
        });
    }

    protected processGetMStnPairingsByRelevance2(response: AxiosResponse): Promise<GetMStnPairingsByRelevance2Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMStnPairingsByRelevance2Response.fromJS(resultData200);
            return Promise.resolve<GetMStnPairingsByRelevance2Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMStnPairingsByRelevance2Response>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMicrostationPairing(body: UpdateMicrostationPairingRequest | undefined, cancelToken?: CancelToken): Promise<UpdateMicrostationPairingResponse> {
        let url_ = this.baseUrl + "/Data/UpdateMicrostationPairing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMicrostationPairing(_response);
        });
    }

    protected processUpdateMicrostationPairing(response: AxiosResponse): Promise<UpdateMicrostationPairingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateMicrostationPairingResponse.fromJS(resultData200);
            return Promise.resolve<UpdateMicrostationPairingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateMicrostationPairingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addMicrostationAllAssign(body: AddMicrostationAllAssignRequest | undefined, cancelToken?: CancelToken): Promise<AddMicrostationAllAssignResponse> {
        let url_ = this.baseUrl + "/Data/AddMicrostationAllAssign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddMicrostationAllAssign(_response);
        });
    }

    protected processAddMicrostationAllAssign(response: AxiosResponse): Promise<AddMicrostationAllAssignResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddMicrostationAllAssignResponse.fromJS(resultData200);
            return Promise.resolve<AddMicrostationAllAssignResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddMicrostationAllAssignResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addMStnFeederItems(body: AddMStnFeederItemsRequest | undefined, cancelToken?: CancelToken): Promise<AddMStnFeederItemsResponse> {
        let url_ = this.baseUrl + "/Data/AddMStnFeederItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddMStnFeederItems(_response);
        });
    }

    protected processAddMStnFeederItems(response: AxiosResponse): Promise<AddMStnFeederItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddMStnFeederItemsResponse.fromJS(resultData200);
            return Promise.resolve<AddMStnFeederItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddMStnFeederItemsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMStnFeederItems(body: UpdateMStnFeederItemsRequest | undefined, cancelToken?: CancelToken): Promise<UpdateMStnFeederItemsResponse> {
        let url_ = this.baseUrl + "/Data/UpdateMStnFeederItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMStnFeederItems(_response);
        });
    }

    protected processUpdateMStnFeederItems(response: AxiosResponse): Promise<UpdateMStnFeederItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateMStnFeederItemsResponse.fromJS(resultData200);
            return Promise.resolve<UpdateMStnFeederItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateMStnFeederItemsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteMStnFeederItems(body: DeleteMStnFeederItemsRequest | undefined, cancelToken?: CancelToken): Promise<DeleteMStnFeederItemsResponse> {
        let url_ = this.baseUrl + "/Data/DeleteMStnFeederItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMStnFeederItems(_response);
        });
    }

    protected processDeleteMStnFeederItems(response: AxiosResponse): Promise<DeleteMStnFeederItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteMStnFeederItemsResponse.fromJS(resultData200);
            return Promise.resolve<DeleteMStnFeederItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteMStnFeederItemsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getMStnFeederItems(mStnPairingId: number, cancelToken?: CancelToken): Promise<GetMStnFeederItemsResponse> {
        let url_ = this.baseUrl + "/Data/GetMStnFeederItems/{MStnPairingId}";
        if (mStnPairingId === undefined || mStnPairingId === null)
            throw new Error("The parameter 'mStnPairingId' must be defined.");
        url_ = url_.replace("{MStnPairingId}", encodeURIComponent("" + mStnPairingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMStnFeederItems(_response);
        });
    }

    protected processGetMStnFeederItems(response: AxiosResponse): Promise<GetMStnFeederItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMStnFeederItemsResponse.fromJS(resultData200);
            return Promise.resolve<GetMStnFeederItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMStnFeederItemsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMStnFeederAllValRules(body: GetMStnFeederAllValRulesRequest | undefined, cancelToken?: CancelToken): Promise<GetMStnFeederAllValRulesResponse> {
        let url_ = this.baseUrl + "/Data/GetMStnFeederAllValRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMStnFeederAllValRules(_response);
        });
    }

    protected processGetMStnFeederAllValRules(response: AxiosResponse): Promise<GetMStnFeederAllValRulesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMStnFeederAllValRulesResponse.fromJS(resultData200);
            return Promise.resolve<GetMStnFeederAllValRulesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMStnFeederAllValRulesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDataStandardForTreeFeeder(body: GetDataStandardForTreeFeederRequest | undefined, cancelToken?: CancelToken): Promise<GetDataStandardForTreeFeederResponse> {
        let url_ = this.baseUrl + "/Data/GetDataStandardForTreeFeeder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDataStandardForTreeFeeder(_response);
        });
    }

    protected processGetDataStandardForTreeFeeder(response: AxiosResponse): Promise<GetDataStandardForTreeFeederResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDataStandardForTreeFeederResponse.fromJS(resultData200);
            return Promise.resolve<GetDataStandardForTreeFeederResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDataStandardForTreeFeederResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMStnFeederFromDGN(body: UpdateMStnFeederFromDGNRequest | undefined, cancelToken?: CancelToken): Promise<UpdateMStnFeederFromDGNResponse> {
        let url_ = this.baseUrl + "/Data/UpdateMStnFeederFromDGN";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMStnFeederFromDGN(_response);
        });
    }

    protected processUpdateMStnFeederFromDGN(response: AxiosResponse): Promise<UpdateMStnFeederFromDGNResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateMStnFeederFromDGNResponse.fromJS(resultData200);
            return Promise.resolve<UpdateMStnFeederFromDGNResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateMStnFeederFromDGNResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMStnFeederAutoValues(body: UpdateMStnFeederAutoValuesRequest | undefined, cancelToken?: CancelToken): Promise<UpdateMStnFeederAutoValuesResponse> {
        let url_ = this.baseUrl + "/Data/UpdateMStnFeederAutoValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMStnFeederAutoValues(_response);
        });
    }

    protected processUpdateMStnFeederAutoValues(response: AxiosResponse): Promise<UpdateMStnFeederAutoValuesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateMStnFeederAutoValuesResponse.fromJS(resultData200);
            return Promise.resolve<UpdateMStnFeederAutoValuesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateMStnFeederAutoValuesResponse>(null as any);
    }

    /**
     * @param excel (optional) 
     * @param xmls (optional) 
     * @return Success
     */
    getInitData(excel: FileParameter | undefined, xmls: FileParameter[] | undefined, cancelToken?: CancelToken): Promise<GetInitDataResponse> {
        let url_ = this.baseUrl + "/ETCS/GetInitData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excel === null || excel === undefined)
            throw new Error("The parameter 'excel' cannot be null.");
        else
            content_.append("Excel", excel.data, excel.fileName ? excel.fileName : "Excel");
        if (xmls === null || xmls === undefined)
            throw new Error("The parameter 'xmls' cannot be null.");
        else
            xmls.forEach(item_ => content_.append("Xmls", item_.data, item_.fileName ? item_.fileName : "Xmls") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInitData(_response);
        });
    }

    protected processGetInitData(response: AxiosResponse): Promise<GetInitDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetInitDataResponse.fromJS(resultData200);
            return Promise.resolve<GetInitDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInitDataResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDownloadLinkFromCorsServer(url: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/FileHelper/GetDownloadLinkFromCorsServer/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDownloadLinkFromCorsServer(_response);
        });
    }

    protected processGetDownloadLinkFromCorsServer(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importDataStandard(body: ImportDataStandardRequest | undefined, cancelToken?: CancelToken): Promise<ImportDataStandardResponse> {
        let url_ = this.baseUrl + "/Import/ImportDataStandard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportDataStandard(_response);
        });
    }

    protected processImportDataStandard(response: AxiosResponse): Promise<ImportDataStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportDataStandardResponse.fromJS(resultData200);
            return Promise.resolve<ImportDataStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportDataStandardResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportIDSFromStandard(body: IdsExportRequest | undefined, cancelToken?: CancelToken): Promise<ExportResult> {
        let url_ = this.baseUrl + "/Import/ExportIDSFromStandard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportIDSFromStandard(_response);
        });
    }

    protected processExportIDSFromStandard(response: AxiosResponse): Promise<ExportResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportResult.fromJS(resultData200);
            return Promise.resolve<ExportResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportResult>(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param chunk (optional) 
     * @param chunkNumber (optional) 
     * @param totalChunks (optional) 
     * @param key (optional) 
     * @param standardId (optional) 
     * @return Success
     */
    uploadIdsImportFile(fileName: string | undefined, chunk: FileParameter | undefined, chunkNumber: number | undefined, totalChunks: number | undefined, key: string | undefined, standardId: number | undefined, cancelToken?: CancelToken): Promise<UploadIdsImportFileResponse> {
        let url_ = this.baseUrl + "/Import/UploadIdsImportFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());
        if (chunk === null || chunk === undefined)
            throw new Error("The parameter 'chunk' cannot be null.");
        else
            content_.append("Chunk", chunk.data, chunk.fileName ? chunk.fileName : "Chunk");
        if (chunkNumber === null || chunkNumber === undefined)
            throw new Error("The parameter 'chunkNumber' cannot be null.");
        else
            content_.append("ChunkNumber", chunkNumber.toString());
        if (totalChunks === null || totalChunks === undefined)
            throw new Error("The parameter 'totalChunks' cannot be null.");
        else
            content_.append("TotalChunks", totalChunks.toString());
        if (key === null || key === undefined)
            throw new Error("The parameter 'key' cannot be null.");
        else
            content_.append("Key", key.toString());
        if (standardId === null || standardId === undefined)
            throw new Error("The parameter 'standardId' cannot be null.");
        else
            content_.append("StandardId", standardId.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadIdsImportFile(_response);
        });
    }

    protected processUploadIdsImportFile(response: AxiosResponse): Promise<UploadIdsImportFileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadIdsImportFileResponse.fromJS(resultData200);
            return Promise.resolve<UploadIdsImportFileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadIdsImportFileResponse>(null as any);
    }

    /**
     * @return Success
     */
    sendEmail( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Mail/SendEmail";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendEmail(_response);
        });
    }

    protected processSendEmail(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSelectorList(body: GetSelectorListRequest | undefined, cancelToken?: CancelToken): Promise<GetSelectorListResponse> {
        let url_ = this.baseUrl + "/Selector/GetSelectorList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectorList(_response);
        });
    }

    protected processGetSelectorList(response: AxiosResponse): Promise<GetSelectorListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSelectorListResponse.fromJS(resultData200);
            return Promise.resolve<GetSelectorListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSelectorListResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSelectorItems(body: GetSelectorItemsRequest | undefined, cancelToken?: CancelToken): Promise<GetSelectorItemsResponse> {
        let url_ = this.baseUrl + "/Selector/GetSelectorItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectorItems(_response);
        });
    }

    protected processGetSelectorItems(response: AxiosResponse): Promise<GetSelectorItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSelectorItemsResponse.fromJS(resultData200);
            return Promise.resolve<GetSelectorItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSelectorItemsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateSelectorItem(body: CreateOrUpdateSelectorItemRequest | undefined, cancelToken?: CancelToken): Promise<CreateOrUpdateSelectorItemResponse> {
        let url_ = this.baseUrl + "/Selector/CreateOrUpdateSelectorItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateSelectorItem(_response);
        });
    }

    protected processCreateOrUpdateSelectorItem(response: AxiosResponse): Promise<CreateOrUpdateSelectorItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateOrUpdateSelectorItemResponse.fromJS(resultData200);
            return Promise.resolve<CreateOrUpdateSelectorItemResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateOrUpdateSelectorItemResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateSelector(body: CreateOrUpdateSelectorRequest | undefined, cancelToken?: CancelToken): Promise<CreateOrUpdateSelectorResponse> {
        let url_ = this.baseUrl + "/Selector/CreateOrUpdateSelector";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateSelector(_response);
        });
    }

    protected processCreateOrUpdateSelector(response: AxiosResponse): Promise<CreateOrUpdateSelectorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateOrUpdateSelectorResponse.fromJS(resultData200);
            return Promise.resolve<CreateOrUpdateSelectorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateOrUpdateSelectorResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteSelector(body: DeleteSelectorRequest | undefined, cancelToken?: CancelToken): Promise<DeleteSelectorResponse> {
        let url_ = this.baseUrl + "/Selector/DeleteSelector";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSelector(_response);
        });
    }

    protected processDeleteSelector(response: AxiosResponse): Promise<DeleteSelectorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteSelectorResponse.fromJS(resultData200);
            return Promise.resolve<DeleteSelectorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteSelectorResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteSelectorItem(body: DeleteSelectorItemRequest | undefined, cancelToken?: CancelToken): Promise<DeleteSelectorItemResponse> {
        let url_ = this.baseUrl + "/Selector/DeleteSelectorItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSelectorItem(_response);
        });
    }

    protected processDeleteSelectorItem(response: AxiosResponse): Promise<DeleteSelectorItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteSelectorItemResponse.fromJS(resultData200);
            return Promise.resolve<DeleteSelectorItemResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteSelectorItemResponse>(null as any);
    }

    /**
     * @param xml (optional) 
     * @return Success
     */
    idsValidate(xml: FileParameter | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Test/IdsValidate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (xml === null || xml === undefined)
            throw new Error("The parameter 'xml' cannot be null.");
        else
            content_.append("Xml", xml.data, xml.fileName ? xml.fileName : "Xml");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIdsValidate(_response);
        });
    }

    protected processIdsValidate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    saveDSSFromThreeFiles( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Test/SaveDSSFromThreeFiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveDSSFromThreeFiles(_response);
        });
    }

    protected processSaveDSSFromThreeFiles(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    getGuid( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Test/GetGuid";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGuid(_response);
        });
    }

    protected processGetGuid(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    getEmptyGridFilterModel( cancelToken?: CancelToken): Promise<GridFilterModel> {
        let url_ = this.baseUrl + "/Test/GetEmptyGridFilterModel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmptyGridFilterModel(_response);
        });
    }

    protected processGetEmptyGridFilterModel(response: AxiosResponse): Promise<GridFilterModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GridFilterModel.fromJS(resultData200);
            return Promise.resolve<GridFilterModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GridFilterModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importDataStandardLocally(body: ImportDataStandardLocallyRequest | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Test/ImportDataStandardLocally";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportDataStandardLocally(_response);
        });
    }

    protected processImportDataStandardLocally(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDataFromModelTestEndpoint(body: GetDataFromModelRequest | undefined, cancelToken?: CancelToken): Promise<ValidationResponse> {
        let url_ = this.baseUrl + "/Test/GetDataFromModelTestEndpoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDataFromModelTestEndpoint(_response);
        });
    }

    protected processGetDataFromModelTestEndpoint(response: AxiosResponse): Promise<ValidationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidationResponse.fromJS(resultData200);
            return Promise.resolve<ValidationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidationResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateTiltTreeData(body: ValidateTiltTreeDataRequest | undefined, cancelToken?: CancelToken): Promise<ValidateTiltTreeDataResponse> {
        let url_ = this.baseUrl + "/TiltValidation/ValidateTiltTreeData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateTiltTreeData(_response);
        });
    }

    protected processValidateTiltTreeData(response: AxiosResponse): Promise<ValidateTiltTreeDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateTiltTreeDataResponse.fromJS(resultData200);
            return Promise.resolve<ValidateTiltTreeDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateTiltTreeDataResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateTiltPlugin(body: ValidationDesignSlopePluginRequest | undefined, cancelToken?: CancelToken): Promise<TiltValidationPluginResponse> {
        let url_ = this.baseUrl + "/TiltValidation/ValidateTiltPlugin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateTiltPlugin(_response);
        });
    }

    protected processValidateTiltPlugin(response: AxiosResponse): Promise<TiltValidationPluginResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TiltValidationPluginResponse.fromJS(resultData200);
            return Promise.resolve<TiltValidationPluginResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TiltValidationPluginResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateTiltVideo(body: TestVideoValidationSlopeRequest | undefined, cancelToken?: CancelToken): Promise<TiltValidationResponse> {
        let url_ = this.baseUrl + "/TiltValidation/ValidateTiltVideo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateTiltVideo(_response);
        });
    }

    protected processValidateTiltVideo(response: AxiosResponse): Promise<TiltValidationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TiltValidationResponse.fromJS(resultData200);
            return Promise.resolve<TiltValidationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TiltValidationResponse>(null as any);
    }

    /**
     * @return Success
     */
    validationVersion(versionId: number, cancelToken?: CancelToken): Promise<TiltValidationVersionResponse> {
        let url_ = this.baseUrl + "/TiltValidation/ValidationVersion/{VersionId}";
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{VersionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidationVersion(_response);
        });
    }

    protected processValidationVersion(response: AxiosResponse): Promise<TiltValidationVersionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TiltValidationVersionResponse.fromJS(resultData200);
            return Promise.resolve<TiltValidationVersionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TiltValidationVersionResponse>(null as any);
    }

    /**
     * @param updateId (optional) 
     * @param password (optional) 
     * @return Success
     */
    getNewVersion(updateId: number | undefined, password: string | undefined, cancelToken?: CancelToken): Promise<GetNewVersionResponse> {
        let url_ = this.baseUrl + "/Updater/getNewVersion?";
        if (updateId === null)
            throw new Error("The parameter 'updateId' cannot be null.");
        else if (updateId !== undefined)
            url_ += "UpdateId=" + encodeURIComponent("" + updateId) + "&";
        if (password === null)
            throw new Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "Password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewVersion(_response);
        });
    }

    protected processGetNewVersion(response: AxiosResponse): Promise<GetNewVersionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetNewVersionResponse.fromJS(resultData200);
            return Promise.resolve<GetNewVersionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetNewVersionResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveBlobToUpdate(body: SaveBlobToUpdateRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Updater/saveBlobToUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveBlobToUpdate(_response);
        });
    }

    protected processSaveBlobToUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUploaderUri(body: CreateNewUpdateRequest | undefined, cancelToken?: CancelToken): Promise<GetUploaderUriResponse> {
        let url_ = this.baseUrl + "/Updater/GetUploaderUri";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUploaderUri(_response);
        });
    }

    protected processGetUploaderUri(response: AxiosResponse): Promise<GetUploaderUriResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUploaderUriResponse.fromJS(resultData200);
            return Promise.resolve<GetUploaderUriResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUploaderUriResponse>(null as any);
    }

    /**
     * @param file (optional) 
     * @param password (optional) 
     * @return Success
     */
    getUploaderUriToUpdater(file: FileParameter | undefined, password: string | undefined, cancelToken?: CancelToken): Promise<GetUploaderUriResponse> {
        let url_ = this.baseUrl + "/Updater/GetUploaderUriToUpdater";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (password === null || password === undefined)
            throw new Error("The parameter 'password' cannot be null.");
        else
            content_.append("Password", password.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUploaderUriToUpdater(_response);
        });
    }

    protected processGetUploaderUriToUpdater(response: AxiosResponse): Promise<GetUploaderUriResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUploaderUriResponse.fromJS(resultData200);
            return Promise.resolve<GetUploaderUriResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUploaderUriResponse>(null as any);
    }

    /**
     * @param product (optional) 
     * @param pluginToProduct (optional) 
     * @return Success
     */
    updateInfo(product: string | undefined, pluginToProduct: string | undefined, cancelToken?: CancelToken): Promise<UpdateInfoResponse> {
        let url_ = this.baseUrl + "/Updater/updateInfo?";
        if (product === null)
            throw new Error("The parameter 'product' cannot be null.");
        else if (product !== undefined)
            url_ += "Product=" + encodeURIComponent("" + product) + "&";
        if (pluginToProduct === null)
            throw new Error("The parameter 'pluginToProduct' cannot be null.");
        else if (pluginToProduct !== undefined)
            url_ += "PluginToProduct=" + encodeURIComponent("" + pluginToProduct) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInfo(_response);
        });
    }

    protected processUpdateInfo(response: AxiosResponse): Promise<UpdateInfoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateInfoResponse.fromJS(resultData200);
            return Promise.resolve<UpdateInfoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateInfoResponse>(null as any);
    }

    /**
     * @param product (optional) 
     * @param pluginToProduct (optional) 
     * @return Success
     */
    getUpdateInfo(product: SGProductType | undefined, pluginToProduct: BentleyProductType | undefined, cancelToken?: CancelToken): Promise<UpdateInfoResponse> {
        let url_ = this.baseUrl + "/Updater/GetUpdateInfo?";
        if (product === null)
            throw new Error("The parameter 'product' cannot be null.");
        else if (product !== undefined)
            url_ += "Product=" + encodeURIComponent("" + product) + "&";
        if (pluginToProduct === null)
            throw new Error("The parameter 'pluginToProduct' cannot be null.");
        else if (pluginToProduct !== undefined)
            url_ += "PluginToProduct=" + encodeURIComponent("" + pluginToProduct) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUpdateInfo(_response);
        });
    }

    protected processGetUpdateInfo(response: AxiosResponse): Promise<UpdateInfoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateInfoResponse.fromJS(resultData200);
            return Promise.resolve<UpdateInfoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateInfoResponse>(null as any);
    }

    /**
     * @return Success
     */
    healthCheck(password: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Updater/healthCheck/{Password}";
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined.");
        url_ = url_.replace("{Password}", encodeURIComponent("" + password));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHealthCheck(_response);
        });
    }

    protected processHealthCheck(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTenant(body: CreateTenantRequest | undefined, cancelToken?: CancelToken): Promise<CreateTenantResponse> {
        let url_ = this.baseUrl + "/User/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTenant(_response);
        });
    }

    protected processCreateTenant(response: AxiosResponse): Promise<CreateTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateTenantResponse.fromJS(resultData200);
            return Promise.resolve<CreateTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateTenantResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUserToTenant(body: AddUserToTenantRequest | undefined, cancelToken?: CancelToken): Promise<AddUserToTenantResponse> {
        let url_ = this.baseUrl + "/User/AddUserToTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUserToTenant(_response);
        });
    }

    protected processAddUserToTenant(response: AxiosResponse): Promise<AddUserToTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddUserToTenantResponse.fromJS(resultData200);
            return Promise.resolve<AddUserToTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddUserToTenantResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTenantsAdmin( cancelToken?: CancelToken): Promise<GetTenantsAdminResponse> {
        let url_ = this.baseUrl + "/User/GetTenantsAdmin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantsAdmin(_response);
        });
    }

    protected processGetTenantsAdmin(response: AxiosResponse): Promise<GetTenantsAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTenantsAdminResponse.fromJS(resultData200);
            return Promise.resolve<GetTenantsAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTenantsAdminResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTenantsUser( cancelToken?: CancelToken): Promise<GetTenantsUserResponse> {
        let url_ = this.baseUrl + "/User/GetTenantsUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantsUser(_response);
        });
    }

    protected processGetTenantsUser(response: AxiosResponse): Promise<GetTenantsUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTenantsUserResponse.fromJS(resultData200);
            return Promise.resolve<GetTenantsUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTenantsUserResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUserTenant(body: ChangeUserTenantRequest | undefined, cancelToken?: CancelToken): Promise<ChangeUserTenantResponse> {
        let url_ = this.baseUrl + "/User/ChangeUserTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeUserTenant(_response);
        });
    }

    protected processChangeUserTenant(response: AxiosResponse): Promise<ChangeUserTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChangeUserTenantResponse.fromJS(resultData200);
            return Promise.resolve<ChangeUserTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeUserTenantResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveUserData(body: SaveUserDataRequest | undefined, cancelToken?: CancelToken): Promise<SaveUserDataResponse> {
        let url_ = this.baseUrl + "/User/SaveUserData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveUserData(_response);
        });
    }

    protected processSaveUserData(response: AxiosResponse): Promise<SaveUserDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveUserDataResponse.fromJS(resultData200);
            return Promise.resolve<SaveUserDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveUserDataResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPasswordUser(body: ResetPasswordUserRequest | undefined, cancelToken?: CancelToken): Promise<ResetPasswordUserResponse> {
        let url_ = this.baseUrl + "/User/ResetPasswordUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPasswordUser(_response);
        });
    }

    protected processResetPasswordUser(response: AxiosResponse): Promise<ResetPasswordUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetPasswordUserResponse.fromJS(resultData200);
            return Promise.resolve<ResetPasswordUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetPasswordUserResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUserPassword(body: ChangeUserPasswordRequest | undefined, cancelToken?: CancelToken): Promise<ChangeUserPasswordResponse> {
        let url_ = this.baseUrl + "/User/ChangeUserPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeUserPassword(_response);
        });
    }

    protected processChangeUserPassword(response: AxiosResponse): Promise<ChangeUserPasswordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChangeUserPasswordResponse.fromJS(resultData200);
            return Promise.resolve<ChangeUserPasswordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeUserPasswordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUser(body: CreateUserRequest | undefined, cancelToken?: CancelToken): Promise<CreateUserResponse> {
        let url_ = this.baseUrl + "/User/CreateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<CreateUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateUserResponse.fromJS(resultData200);
            return Promise.resolve<CreateUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUsersTenant(tenantId: number, cancelToken?: CancelToken): Promise<GetUsersTenantResponse> {
        let url_ = this.baseUrl + "/User/GetUsersTenant/{TenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{TenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsersTenant(_response);
        });
    }

    protected processGetUsersTenant(response: AxiosResponse): Promise<GetUsersTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUsersTenantResponse.fromJS(resultData200);
            return Promise.resolve<GetUsersTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUsersTenantResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteTenant(tenantId: number, cancelToken?: CancelToken): Promise<DeleteTenantResponse> {
        let url_ = this.baseUrl + "/User/DeleteTenant/{TenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{TenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTenant(_response);
        });
    }

    protected processDeleteTenant(response: AxiosResponse): Promise<DeleteTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteTenantResponse.fromJS(resultData200);
            return Promise.resolve<DeleteTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteTenantResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renameTenant(body: RenameTenantRequest | undefined, cancelToken?: CancelToken): Promise<RenameTenantResponse> {
        let url_ = this.baseUrl + "/User/RenameTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenameTenant(_response);
        });
    }

    protected processRenameTenant(response: AxiosResponse): Promise<RenameTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RenameTenantResponse.fromJS(resultData200);
            return Promise.resolve<RenameTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RenameTenantResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeUserFromTenant(body: RemoveUserFromTenantRequest | undefined, cancelToken?: CancelToken): Promise<RemoveUserFromTenantResponse> {
        let url_ = this.baseUrl + "/User/RemoveUserFromTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveUserFromTenant(_response);
        });
    }

    protected processRemoveUserFromTenant(response: AxiosResponse): Promise<RemoveUserFromTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RemoveUserFromTenantResponse.fromJS(resultData200);
            return Promise.resolve<RemoveUserFromTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RemoveUserFromTenantResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUserSendSignupMail(body: CreateUserSendSignupMailRequest | undefined, cancelToken?: CancelToken): Promise<CreateUserSendSignupMailResponse> {
        let url_ = this.baseUrl + "/User/CreateUserSendSignupMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUserSendSignupMail(_response);
        });
    }

    protected processCreateUserSendSignupMail(response: AxiosResponse): Promise<CreateUserSendSignupMailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateUserSendSignupMailResponse.fromJS(resultData200);
            return Promise.resolve<CreateUserSendSignupMailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateUserSendSignupMailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTenantAndUser(body: CreateTenantAndUserRequest | undefined, cancelToken?: CancelToken): Promise<CreateTenantAndUserResponse> {
        let url_ = this.baseUrl + "/UserAnonymous/CreateTenantAndUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTenantAndUser(_response);
        });
    }

    protected processCreateTenantAndUser(response: AxiosResponse): Promise<CreateTenantAndUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateTenantAndUserResponse.fromJS(resultData200);
            return Promise.resolve<CreateTenantAndUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateTenantAndUserResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createLead(body: CreateLeadRequest | undefined, cancelToken?: CancelToken): Promise<CreateLeadResponse> {
        let url_ = this.baseUrl + "/UserAnonymous/CreateLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateLead(_response);
        });
    }

    protected processCreateLead(response: AxiosResponse): Promise<CreateLeadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateLeadResponse.fromJS(resultData200);
            return Promise.resolve<CreateLeadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateLeadResponse>(null as any);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    getSignupUserData(token: string | undefined, cancelToken?: CancelToken): Promise<GetSignupUserDataResponse> {
        let url_ = this.baseUrl + "/UserAnonymous/GetSignupUserData?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSignupUserData(_response);
        });
    }

    protected processGetSignupUserData(response: AxiosResponse): Promise<GetSignupUserDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSignupUserDataResponse.fromJS(resultData200);
            return Promise.resolve<GetSignupUserDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSignupUserDataResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    signupUserMicrosoft(body: SignupUserMicrosoftRequest | undefined, cancelToken?: CancelToken): Promise<SignupUserMicrosoftResponse> {
        let url_ = this.baseUrl + "/UserAnonymous/SignupUserMicrosoft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignupUserMicrosoft(_response);
        });
    }

    protected processSignupUserMicrosoft(response: AxiosResponse): Promise<SignupUserMicrosoftResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SignupUserMicrosoftResponse.fromJS(resultData200);
            return Promise.resolve<SignupUserMicrosoftResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SignupUserMicrosoftResponse>(null as any);
    }

    /**
     * @param id (optional) 
     * @param newPass (optional) 
     * @param signupToken (optional) 
     * @return Success
     */
    setUserPassword(id: number | undefined, newPass: string | undefined, signupToken: string | undefined, cancelToken?: CancelToken): Promise<SetUserPasswordResponse> {
        let url_ = this.baseUrl + "/UserAnonymous/SetUserPassword?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (newPass === null)
            throw new Error("The parameter 'newPass' cannot be null.");
        else if (newPass !== undefined)
            url_ += "NewPass=" + encodeURIComponent("" + newPass) + "&";
        if (signupToken === null)
            throw new Error("The parameter 'signupToken' cannot be null.");
        else if (signupToken !== undefined)
            url_ += "SignupToken=" + encodeURIComponent("" + signupToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetUserPassword(_response);
        });
    }

    protected processSetUserPassword(response: AxiosResponse): Promise<SetUserPasswordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetUserPasswordResponse.fromJS(resultData200);
            return Promise.resolve<SetUserPasswordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetUserPasswordResponse>(null as any);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    getResetPasswordUserData(token: string | undefined, cancelToken?: CancelToken): Promise<GetResetPasswordUserDataResponse> {
        let url_ = this.baseUrl + "/UserAnonymous/GetResetPasswordUserData?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResetPasswordUserData(_response);
        });
    }

    protected processGetResetPasswordUserData(response: AxiosResponse): Promise<GetResetPasswordUserDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetResetPasswordUserDataResponse.fromJS(resultData200);
            return Promise.resolve<GetResetPasswordUserDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetResetPasswordUserDataResponse>(null as any);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    resetUserPasswordSendMail(email: string | undefined, cancelToken?: CancelToken): Promise<ResetUserPasswordSendMailResponse> {
        let url_ = this.baseUrl + "/UserAnonymous/ResetUserPasswordSendMail?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetUserPasswordSendMail(_response);
        });
    }

    protected processResetUserPasswordSendMail(response: AxiosResponse): Promise<ResetUserPasswordSendMailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetUserPasswordSendMailResponse.fromJS(resultData200);
            return Promise.resolve<ResetUserPasswordSendMailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetUserPasswordSendMailResponse>(null as any);
    }
}

export class AddMicrostationAllAssignRequest implements IAddMicrostationAllAssignRequest {
    mStnPairingId?: number;
    pairingsAssign?: MStnPairingAssignDTO[] | undefined;

    constructor(data?: IAddMicrostationAllAssignRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            if (Array.isArray(_data["pairingsAssign"])) {
                this.pairingsAssign = [] as any;
                for (let item of _data["pairingsAssign"])
                    this.pairingsAssign!.push(MStnPairingAssignDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddMicrostationAllAssignRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddMicrostationAllAssignRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        if (Array.isArray(this.pairingsAssign)) {
            data["pairingsAssign"] = [];
            for (let item of this.pairingsAssign)
                data["pairingsAssign"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddMicrostationAllAssignRequest {
    mStnPairingId?: number;
    pairingsAssign?: MStnPairingAssignDTO[] | undefined;
}

export class AddMicrostationAllAssignResponse implements IAddMicrostationAllAssignResponse {
    ok?: boolean;

    constructor(data?: IAddMicrostationAllAssignResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): AddMicrostationAllAssignResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddMicrostationAllAssignResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IAddMicrostationAllAssignResponse {
    ok?: boolean;
}

export class AddMicrostationPairingPairerRequest implements IAddMicrostationPairingPairerRequest {
    mStnPairingId?: number;
    pairerId?: number;
    name?: string | undefined;
    type?: number;

    constructor(data?: IAddMicrostationPairingPairerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            this.pairerId = _data["pairerId"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): AddMicrostationPairingPairerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddMicrostationPairingPairerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        data["pairerId"] = this.pairerId;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface IAddMicrostationPairingPairerRequest {
    mStnPairingId?: number;
    pairerId?: number;
    name?: string | undefined;
    type?: number;
}

export class AddMicrostationPairingPairerResponse implements IAddMicrostationPairingPairerResponse {
    ok?: boolean;

    constructor(data?: IAddMicrostationPairingPairerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): AddMicrostationPairingPairerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddMicrostationPairingPairerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IAddMicrostationPairingPairerResponse {
    ok?: boolean;
}

export class AddMStnFeederItemsRequest implements IAddMStnFeederItemsRequest {
    mStnPairingId?: number;
    level?: number;
    itemId?: number | undefined;
    elementId?: string | undefined;
    validationRuleIds?: number[] | undefined;
    value?: string | undefined;
    overwrite?: boolean;
    isLocked?: boolean;
    autoValueType?: FeederAutoValueType;
    stringValueType?: FeederStringValueType;
    autoValueState?: FeederAutoValueState;
    autoValue?: string | undefined;

    constructor(data?: IAddMStnFeederItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            this.level = _data["level"];
            this.itemId = _data["itemId"];
            this.elementId = _data["elementId"];
            if (Array.isArray(_data["validationRuleIds"])) {
                this.validationRuleIds = [] as any;
                for (let item of _data["validationRuleIds"])
                    this.validationRuleIds!.push(item);
            }
            this.value = _data["value"];
            this.overwrite = _data["overwrite"];
            this.isLocked = _data["isLocked"];
            this.autoValueType = _data["autoValueType"];
            this.stringValueType = _data["stringValueType"];
            this.autoValueState = _data["autoValueState"];
            this.autoValue = _data["autoValue"];
        }
    }

    static fromJS(data: any): AddMStnFeederItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddMStnFeederItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        data["level"] = this.level;
        data["itemId"] = this.itemId;
        data["elementId"] = this.elementId;
        if (Array.isArray(this.validationRuleIds)) {
            data["validationRuleIds"] = [];
            for (let item of this.validationRuleIds)
                data["validationRuleIds"].push(item);
        }
        data["value"] = this.value;
        data["overwrite"] = this.overwrite;
        data["isLocked"] = this.isLocked;
        data["autoValueType"] = this.autoValueType;
        data["stringValueType"] = this.stringValueType;
        data["autoValueState"] = this.autoValueState;
        data["autoValue"] = this.autoValue;
        return data;
    }
}

export interface IAddMStnFeederItemsRequest {
    mStnPairingId?: number;
    level?: number;
    itemId?: number | undefined;
    elementId?: string | undefined;
    validationRuleIds?: number[] | undefined;
    value?: string | undefined;
    overwrite?: boolean;
    isLocked?: boolean;
    autoValueType?: FeederAutoValueType;
    stringValueType?: FeederStringValueType;
    autoValueState?: FeederAutoValueState;
    autoValue?: string | undefined;
}

export class AddMStnFeederItemsResponse implements IAddMStnFeederItemsResponse {
    ok?: boolean;

    constructor(data?: IAddMStnFeederItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): AddMStnFeederItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddMStnFeederItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IAddMStnFeederItemsResponse {
    ok?: boolean;
}

export class AddUserToTenantRequest implements IAddUserToTenantRequest {
    email?: string | undefined;
    tenantId?: number | undefined;

    constructor(data?: IAddUserToTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AddUserToTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserToTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAddUserToTenantRequest {
    email?: string | undefined;
    tenantId?: number | undefined;
}

export class AddUserToTenantResponse implements IAddUserToTenantResponse {
    ok?: boolean;
    alreadyAdded?: boolean;
    userId?: number | undefined;

    constructor(data?: IAddUserToTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.alreadyAdded = _data["alreadyAdded"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AddUserToTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserToTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["alreadyAdded"] = this.alreadyAdded;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAddUserToTenantResponse {
    ok?: boolean;
    alreadyAdded?: boolean;
    userId?: number | undefined;
}

export class AuthLocalRequest implements IAuthLocalRequest {
    username?: string | undefined;
    password?: string | undefined;
    tenantId?: number | undefined;

    constructor(data?: IAuthLocalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AuthLocalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthLocalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAuthLocalRequest {
    username?: string | undefined;
    password?: string | undefined;
    tenantId?: number | undefined;
}

export class AuthMicrosoftRequest implements IAuthMicrosoftRequest {
    token?: string | undefined;
    tenantId?: number | undefined;

    constructor(data?: IAuthMicrosoftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AuthMicrosoftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthMicrosoftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAuthMicrosoftRequest {
    token?: string | undefined;
    tenantId?: number | undefined;
}

export class AuthResponse implements IAuthResponse {
    id?: number;
    microsoftId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenants?: TenantLoginDTO[] | undefined;
    tenantId?: number | undefined;
    resetPassword?: boolean | undefined;

    constructor(data?: IAuthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.microsoftId = _data["microsoftId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.token = _data["token"];
            this.tokenExpiration = _data["tokenExpiration"] ? new Date(_data["tokenExpiration"].toString()) : <any>undefined;
            this.refreshToken = _data["refreshToken"];
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantLoginDTO.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.resetPassword = _data["resetPassword"];
        }
    }

    static fromJS(data: any): AuthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["microsoftId"] = this.microsoftId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["token"] = this.token;
        data["tokenExpiration"] = this.tokenExpiration ? this.tokenExpiration.toISOString() : <any>undefined;
        data["refreshToken"] = this.refreshToken;
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["resetPassword"] = this.resetPassword;
        return data;
    }
}

export interface IAuthResponse {
    id?: number;
    microsoftId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenants?: TenantLoginDTO[] | undefined;
    tenantId?: number | undefined;
    resetPassword?: boolean | undefined;
}

export class BaseLineDTO implements IBaseLineDTO {
    name?: string | undefined;
    data?: CorridorBaseLineDataDTO[] | undefined;

    constructor(data?: IBaseLineDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CorridorBaseLineDataDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseLineDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BaseLineDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBaseLineDTO {
    name?: string | undefined;
    data?: CorridorBaseLineDataDTO[] | undefined;
}

export enum BentleyProductType {
    Microstation = "Microstation",
    Openroads = "Openroads",
    Openrail = "Openrail",
}

export enum CollectionState {
    Unchanged = "Unchanged",
    Added = "Added",
    Modified = "Modified",
    Deleted = "Deleted",
}

export class CopyDataStandardRequest implements ICopyDataStandardRequest {
    name?: string | undefined;
    standardId?: number;

    constructor(data?: ICopyDataStandardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.standardId = _data["standardId"];
        }
    }

    static fromJS(data: any): CopyDataStandardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyDataStandardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["standardId"] = this.standardId;
        return data;
    }
}

export interface ICopyDataStandardRequest {
    name?: string | undefined;
    standardId?: number;
}

export class CopyDataStandardResponse implements ICopyDataStandardResponse {
    id?: number;

    constructor(data?: ICopyDataStandardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CopyDataStandardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopyDataStandardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICopyDataStandardResponse {
    id?: number;
}

export class CopyPairersRequest implements ICopyPairersRequest {
    pairersIds?: number[] | undefined;
    groupId?: number;

    constructor(data?: ICopyPairersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pairersIds"])) {
                this.pairersIds = [] as any;
                for (let item of _data["pairersIds"])
                    this.pairersIds!.push(item);
            }
            this.groupId = _data["groupId"];
        }
    }

    static fromJS(data: any): CopyPairersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyPairersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairersIds)) {
            data["pairersIds"] = [];
            for (let item of this.pairersIds)
                data["pairersIds"].push(item);
        }
        data["groupId"] = this.groupId;
        return data;
    }
}

export interface ICopyPairersRequest {
    pairersIds?: number[] | undefined;
    groupId?: number;
}

export class CopyPairersResponse implements ICopyPairersResponse {

    constructor(data?: ICopyPairersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CopyPairersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopyPairersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICopyPairersResponse {
}

export class CopyValidationRulesRequest implements ICopyValidationRulesRequest {
    destinationPairersIds?: number[] | undefined;
    pairerCopyValidationId?: number;

    constructor(data?: ICopyValidationRulesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["destinationPairersIds"])) {
                this.destinationPairersIds = [] as any;
                for (let item of _data["destinationPairersIds"])
                    this.destinationPairersIds!.push(item);
            }
            this.pairerCopyValidationId = _data["pairerCopyValidationId"];
        }
    }

    static fromJS(data: any): CopyValidationRulesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyValidationRulesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.destinationPairersIds)) {
            data["destinationPairersIds"] = [];
            for (let item of this.destinationPairersIds)
                data["destinationPairersIds"].push(item);
        }
        data["pairerCopyValidationId"] = this.pairerCopyValidationId;
        return data;
    }
}

export interface ICopyValidationRulesRequest {
    destinationPairersIds?: number[] | undefined;
    pairerCopyValidationId?: number;
}

export class CopyValidationRulesResponse implements ICopyValidationRulesResponse {

    constructor(data?: ICopyValidationRulesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CopyValidationRulesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopyValidationRulesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICopyValidationRulesResponse {
}

export class CorridorBaseLineDataDTO implements ICorridorBaseLineDataDTO {
    datum?: Date;
    isActual?: boolean;
    id?: number;
    autor?: string | undefined;

    constructor(data?: ICorridorBaseLineDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : <any>undefined;
            this.isActual = _data["isActual"];
            this.id = _data["id"];
            this.autor = _data["autor"];
        }
    }

    static fromJS(data: any): CorridorBaseLineDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CorridorBaseLineDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datum"] = this.datum ? this.datum.toISOString() : <any>undefined;
        data["isActual"] = this.isActual;
        data["id"] = this.id;
        data["autor"] = this.autor;
        return data;
    }
}

export interface ICorridorBaseLineDataDTO {
    datum?: Date;
    isActual?: boolean;
    id?: number;
    autor?: string | undefined;
}

export class CorridorDTO implements ICorridorDTO {
    name?: string | undefined;
    baseLines?: BaseLineDTO[] | undefined;

    constructor(data?: ICorridorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["baseLines"])) {
                this.baseLines = [] as any;
                for (let item of _data["baseLines"])
                    this.baseLines!.push(BaseLineDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CorridorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CorridorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.baseLines)) {
            data["baseLines"] = [];
            for (let item of this.baseLines)
                data["baseLines"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICorridorDTO {
    name?: string | undefined;
    baseLines?: BaseLineDTO[] | undefined;
}

export class CreateDataStandardRequest implements ICreateDataStandardRequest {
    name?: string | undefined;
    classifierName?: string | undefined;
    stage?: DocumentationStage;

    constructor(data?: ICreateDataStandardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.classifierName = _data["classifierName"];
            this.stage = _data["stage"];
        }
    }

    static fromJS(data: any): CreateDataStandardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDataStandardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["classifierName"] = this.classifierName;
        data["stage"] = this.stage;
        return data;
    }
}

export interface ICreateDataStandardRequest {
    name?: string | undefined;
    classifierName?: string | undefined;
    stage?: DocumentationStage;
}

export class CreateDataStandardResponse implements ICreateDataStandardResponse {
    id?: number;
    ok?: boolean;
    timestamp?: Date;

    constructor(data?: ICreateDataStandardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ok = _data["ok"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateDataStandardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDataStandardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ok"] = this.ok;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateDataStandardResponse {
    id?: number;
    ok?: boolean;
    timestamp?: Date;
}

export class CreateEntityResponse implements ICreateEntityResponse {
    id?: number;
    rowVersion?: string | undefined;

    constructor(data?: ICreateEntityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): CreateEntityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEntityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface ICreateEntityResponse {
    id?: number;
    rowVersion?: string | undefined;
}

export class CreateGroupForStandardRequest implements ICreateGroupForStandardRequest {
    standardId?: number;
    name?: string | undefined;

    constructor(data?: ICreateGroupForStandardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardId = _data["standardId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateGroupForStandardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGroupForStandardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardId"] = this.standardId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateGroupForStandardRequest {
    standardId?: number;
    name?: string | undefined;
}

export class CreateLeadRequest implements ICreateLeadRequest {
    email?: string | undefined;
    company?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: ICreateLeadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.company = _data["company"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): CreateLeadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLeadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["company"] = this.company;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ICreateLeadRequest {
    email?: string | undefined;
    company?: string | undefined;
    phoneNumber?: string | undefined;
}

export class CreateLeadResponse implements ICreateLeadResponse {
    ok?: boolean;

    constructor(data?: ICreateLeadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): CreateLeadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLeadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ICreateLeadResponse {
    ok?: boolean;
}

export class CreateMicrostationPairingRequest implements ICreateMicrostationPairingRequest {
    dataStandardId?: number;
    projectId?: number;
    name?: string | undefined;

    constructor(data?: ICreateMicrostationPairingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataStandardId = _data["dataStandardId"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateMicrostationPairingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMicrostationPairingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataStandardId"] = this.dataStandardId;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateMicrostationPairingRequest {
    dataStandardId?: number;
    projectId?: number;
    name?: string | undefined;
}

export class CreateMicrostationPairingResponse implements ICreateMicrostationPairingResponse {
    id?: number;
    rowVersion?: Date;

    constructor(data?: ICreateMicrostationPairingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"] ? new Date(_data["rowVersion"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateMicrostationPairingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMicrostationPairingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion ? this.rowVersion.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateMicrostationPairingResponse {
    id?: number;
    rowVersion?: Date;
}

export class CreateNewUpdateRequest implements ICreateNewUpdateRequest {
    version?: string | undefined;
    minimumUpdateVersion?: string | undefined;
    product?: SGProductType;
    productPlugin?: BentleyProductType;
    password?: string | undefined;

    constructor(data?: ICreateNewUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.minimumUpdateVersion = _data["minimumUpdateVersion"];
            this.product = _data["product"];
            this.productPlugin = _data["productPlugin"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateNewUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["minimumUpdateVersion"] = this.minimumUpdateVersion;
        data["product"] = this.product;
        data["productPlugin"] = this.productPlugin;
        data["password"] = this.password;
        return data;
    }
}

export interface ICreateNewUpdateRequest {
    version?: string | undefined;
    minimumUpdateVersion?: string | undefined;
    product?: SGProductType;
    productPlugin?: BentleyProductType;
    password?: string | undefined;
}

export class CreateOrGroupRequest implements ICreateOrGroupRequest {
    pairerId?: number;
    name?: string | undefined;

    constructor(data?: ICreateOrGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pairerId = _data["pairerId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateOrGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pairerId"] = this.pairerId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateOrGroupRequest {
    pairerId?: number;
    name?: string | undefined;
}

export class CreateOrUpdateCurvesRequest implements ICreateOrUpdateCurvesRequest {
    routeId?: number;
    curves?: CurveDTO[] | undefined;
    deleted?: number[] | undefined;
    replace?: boolean | undefined;

    constructor(data?: ICreateOrUpdateCurvesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.routeId = _data["routeId"];
            if (Array.isArray(_data["curves"])) {
                this.curves = [] as any;
                for (let item of _data["curves"])
                    this.curves!.push(CurveDTO.fromJS(item));
            }
            if (Array.isArray(_data["deleted"])) {
                this.deleted = [] as any;
                for (let item of _data["deleted"])
                    this.deleted!.push(item);
            }
            this.replace = _data["replace"];
        }
    }

    static fromJS(data: any): CreateOrUpdateCurvesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCurvesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routeId"] = this.routeId;
        if (Array.isArray(this.curves)) {
            data["curves"] = [];
            for (let item of this.curves)
                data["curves"].push(item.toJSON());
        }
        if (Array.isArray(this.deleted)) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item);
        }
        data["replace"] = this.replace;
        return data;
    }
}

export interface ICreateOrUpdateCurvesRequest {
    routeId?: number;
    curves?: CurveDTO[] | undefined;
    deleted?: number[] | undefined;
    replace?: boolean | undefined;
}

export class CreateOrUpdateCurvesResponse implements ICreateOrUpdateCurvesResponse {
    ok?: boolean;

    constructor(data?: ICreateOrUpdateCurvesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): CreateOrUpdateCurvesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCurvesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ICreateOrUpdateCurvesResponse {
    ok?: boolean;
}

export class CreateOrUpdateSelectorItemRequest implements ICreateOrUpdateSelectorItemRequest {
    id?: number;
    validationRuleConditionId?: number;
    newValue?: string | undefined;
    type?: DataTypeValidation;

    constructor(data?: ICreateOrUpdateSelectorItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.validationRuleConditionId = _data["validationRuleConditionId"];
            this.newValue = _data["newValue"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CreateOrUpdateSelectorItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSelectorItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["validationRuleConditionId"] = this.validationRuleConditionId;
        data["newValue"] = this.newValue;
        data["type"] = this.type;
        return data;
    }
}

export interface ICreateOrUpdateSelectorItemRequest {
    id?: number;
    validationRuleConditionId?: number;
    newValue?: string | undefined;
    type?: DataTypeValidation;
}

export class CreateOrUpdateSelectorItemResponse implements ICreateOrUpdateSelectorItemResponse {
    ok?: boolean;
    id?: number | undefined;

    constructor(data?: ICreateOrUpdateSelectorItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateSelectorItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSelectorItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrUpdateSelectorItemResponse {
    ok?: boolean;
    id?: number | undefined;
}

export class CreateOrUpdateSelectorRequest implements ICreateOrUpdateSelectorRequest {
    id?: number;
    newValue?: string | undefined;
    selectorType?: SelectorType;
    dataType?: DataTypeValidation;

    constructor(data?: ICreateOrUpdateSelectorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newValue = _data["newValue"];
            this.selectorType = _data["selectorType"];
            this.dataType = _data["dataType"];
        }
    }

    static fromJS(data: any): CreateOrUpdateSelectorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSelectorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newValue"] = this.newValue;
        data["selectorType"] = this.selectorType;
        data["dataType"] = this.dataType;
        return data;
    }
}

export interface ICreateOrUpdateSelectorRequest {
    id?: number;
    newValue?: string | undefined;
    selectorType?: SelectorType;
    dataType?: DataTypeValidation;
}

export class CreateOrUpdateSelectorResponse implements ICreateOrUpdateSelectorResponse {
    ok?: boolean;
    id?: number;

    constructor(data?: ICreateOrUpdateSelectorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateSelectorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSelectorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrUpdateSelectorResponse {
    ok?: boolean;
    id?: number;
}

export class CreatePairerRequest implements ICreatePairerRequest {
    name?: string | undefined;
    filter?: string | undefined;
    groupId?: number;

    constructor(data?: ICreatePairerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.filter = _data["filter"];
            this.groupId = _data["groupId"];
        }
    }

    static fromJS(data: any): CreatePairerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePairerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["filter"] = this.filter;
        data["groupId"] = this.groupId;
        return data;
    }
}

export interface ICreatePairerRequest {
    name?: string | undefined;
    filter?: string | undefined;
    groupId?: number;
}

export class CreateProjectRequest implements ICreateProjectRequest {
    name?: string | undefined;
    type?: number;

    constructor(data?: ICreateProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CreateProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface ICreateProjectRequest {
    name?: string | undefined;
    type?: number;
}

export class CreateProjectResponse implements ICreateProjectResponse {
    projectId?: number;

    constructor(data?: ICreateProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): CreateProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface ICreateProjectResponse {
    projectId?: number;
}

export class CreateRouteRequest implements ICreateRouteRequest {
    projectId?: number;
    name?: string | undefined;
    state?: number;

    constructor(data?: ICreateRouteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): CreateRouteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRouteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["state"] = this.state;
        return data;
    }
}

export interface ICreateRouteRequest {
    projectId?: number;
    name?: string | undefined;
    state?: number;
}

export class CreateRouteResponse implements ICreateRouteResponse {
    routeId?: number;

    constructor(data?: ICreateRouteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.routeId = _data["routeId"];
        }
    }

    static fromJS(data: any): CreateRouteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRouteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routeId"] = this.routeId;
        return data;
    }
}

export interface ICreateRouteResponse {
    routeId?: number;
}

export enum CreateTenantAndUserErrorType {
    USER_EXISTS = "USER_EXISTS",
    TENANT_EXISTS = "TENANT_EXISTS",
}

export class CreateTenantAndUserRequest implements ICreateTenantAndUserRequest {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    company?: string | undefined;
    password?: string | undefined;

    constructor(data?: ICreateTenantAndUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.company = _data["company"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateTenantAndUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantAndUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["company"] = this.company;
        data["password"] = this.password;
        return data;
    }
}

export interface ICreateTenantAndUserRequest {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    company?: string | undefined;
    password?: string | undefined;
}

export class CreateTenantAndUserResponse implements ICreateTenantAndUserResponse {
    ok?: boolean;
    error?: CreateTenantAndUserErrorType;

    constructor(data?: ICreateTenantAndUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): CreateTenantAndUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantAndUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["error"] = this.error;
        return data;
    }
}

export interface ICreateTenantAndUserResponse {
    ok?: boolean;
    error?: CreateTenantAndUserErrorType;
}

export class CreateTenantRequest implements ICreateTenantRequest {
    name?: string | undefined;

    constructor(data?: ICreateTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateTenantRequest {
    name?: string | undefined;
}

export class CreateTenantResponse implements ICreateTenantResponse {
    ok?: boolean;
    tenantId?: number | undefined;

    constructor(data?: ICreateTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateTenantResponse {
    ok?: boolean;
    tenantId?: number | undefined;
}

export class CreateUserRequest implements ICreateUserRequest {
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    tenantId?: number | undefined;

    constructor(data?: ICreateUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateUserRequest {
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    tenantId?: number | undefined;
}

export class CreateUserResponse implements ICreateUserResponse {
    ok?: boolean;
    password?: string | undefined;

    constructor(data?: ICreateUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["password"] = this.password;
        return data;
    }
}

export interface ICreateUserResponse {
    ok?: boolean;
    password?: string | undefined;
}

export class CreateUserSendSignupMailRequest implements ICreateUserSendSignupMailRequest {
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    localLogin?: boolean;
    msLogin?: boolean;
    tenantId?: number | undefined;

    constructor(data?: ICreateUserSendSignupMailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.localLogin = _data["localLogin"];
            this.msLogin = _data["msLogin"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateUserSendSignupMailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserSendSignupMailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["localLogin"] = this.localLogin;
        data["msLogin"] = this.msLogin;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateUserSendSignupMailRequest {
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    localLogin?: boolean;
    msLogin?: boolean;
    tenantId?: number | undefined;
}

export class CreateUserSendSignupMailResponse implements ICreateUserSendSignupMailResponse {
    ok?: boolean;

    constructor(data?: ICreateUserSendSignupMailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): CreateUserSendSignupMailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserSendSignupMailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ICreateUserSendSignupMailResponse {
    ok?: boolean;
}

export class CreateValidationRuleInOrGroupRequest implements ICreateValidationRuleInOrGroupRequest {
    namePrefix?: string | undefined;
    name?: string | undefined;
    field?: string | undefined;
    nullable?: boolean;
    dataType?: DataTypeValidation;
    groupId?: number;
    groupIndex?: number;

    constructor(data?: ICreateValidationRuleInOrGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.namePrefix = _data["namePrefix"];
            this.name = _data["name"];
            this.field = _data["field"];
            this.nullable = _data["nullable"];
            this.dataType = _data["dataType"];
            this.groupId = _data["groupId"];
            this.groupIndex = _data["groupIndex"];
        }
    }

    static fromJS(data: any): CreateValidationRuleInOrGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateValidationRuleInOrGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["namePrefix"] = this.namePrefix;
        data["name"] = this.name;
        data["field"] = this.field;
        data["nullable"] = this.nullable;
        data["dataType"] = this.dataType;
        data["groupId"] = this.groupId;
        data["groupIndex"] = this.groupIndex;
        return data;
    }
}

export interface ICreateValidationRuleInOrGroupRequest {
    namePrefix?: string | undefined;
    name?: string | undefined;
    field?: string | undefined;
    nullable?: boolean;
    dataType?: DataTypeValidation;
    groupId?: number;
    groupIndex?: number;
}

export class CreateValidationsRuleRequest implements ICreateValidationsRuleRequest {
    namePrefix?: string | undefined;
    name?: string | undefined;
    field?: string | undefined;
    nullable?: boolean;
    isCCI?: boolean;
    decimalPlaces?: number | undefined;
    dataType?: DataTypeValidation;
    condition?: string | undefined;
    valueCondition?: ValueConditionModelDTO;
    pairerId?: number;

    constructor(data?: ICreateValidationsRuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.namePrefix = _data["namePrefix"];
            this.name = _data["name"];
            this.field = _data["field"];
            this.nullable = _data["nullable"];
            this.isCCI = _data["isCCI"];
            this.decimalPlaces = _data["decimalPlaces"];
            this.dataType = _data["dataType"];
            this.condition = _data["condition"];
            this.valueCondition = _data["valueCondition"] ? ValueConditionModelDTO.fromJS(_data["valueCondition"]) : <any>undefined;
            this.pairerId = _data["pairerId"];
        }
    }

    static fromJS(data: any): CreateValidationsRuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateValidationsRuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["namePrefix"] = this.namePrefix;
        data["name"] = this.name;
        data["field"] = this.field;
        data["nullable"] = this.nullable;
        data["isCCI"] = this.isCCI;
        data["decimalPlaces"] = this.decimalPlaces;
        data["dataType"] = this.dataType;
        data["condition"] = this.condition;
        data["valueCondition"] = this.valueCondition ? this.valueCondition.toJSON() : <any>undefined;
        data["pairerId"] = this.pairerId;
        return data;
    }
}

export interface ICreateValidationsRuleRequest {
    namePrefix?: string | undefined;
    name?: string | undefined;
    field?: string | undefined;
    nullable?: boolean;
    isCCI?: boolean;
    decimalPlaces?: number | undefined;
    dataType?: DataTypeValidation;
    condition?: string | undefined;
    valueCondition?: ValueConditionModelDTO;
    pairerId?: number;
}

export class CurveDTO implements ICurveDTO {
    id?: number;
    r?: number | undefined;
    dstav?: number | undefined;
    d?: number | undefined;
    v?: number | undefined;
    v130?: number | undefined;
    v150?: number | undefined;
    vk?: number | undefined;
    vnakl?: number | undefined;
    lk1?: number | undefined;
    lk2?: number | undefined;
    inflexWithPrevious?: boolean;
    inflexWithNext?: boolean;
    hasMezilehla?: boolean;
    lkm?: number | undefined;

    constructor(data?: ICurveDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.r = _data["r"];
            this.dstav = _data["dstav"];
            this.d = _data["d"];
            this.v = _data["v"];
            this.v130 = _data["v130"];
            this.v150 = _data["v150"];
            this.vk = _data["vk"];
            this.vnakl = _data["vnakl"];
            this.lk1 = _data["lk1"];
            this.lk2 = _data["lk2"];
            this.inflexWithPrevious = _data["inflexWithPrevious"];
            this.inflexWithNext = _data["inflexWithNext"];
            this.hasMezilehla = _data["hasMezilehla"];
            this.lkm = _data["lkm"];
        }
    }

    static fromJS(data: any): CurveDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CurveDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["r"] = this.r;
        data["dstav"] = this.dstav;
        data["d"] = this.d;
        data["v"] = this.v;
        data["v130"] = this.v130;
        data["v150"] = this.v150;
        data["vk"] = this.vk;
        data["vnakl"] = this.vnakl;
        data["lk1"] = this.lk1;
        data["lk2"] = this.lk2;
        data["inflexWithPrevious"] = this.inflexWithPrevious;
        data["inflexWithNext"] = this.inflexWithNext;
        data["hasMezilehla"] = this.hasMezilehla;
        data["lkm"] = this.lkm;
        return data;
    }
}

export interface ICurveDTO {
    id?: number;
    r?: number | undefined;
    dstav?: number | undefined;
    d?: number | undefined;
    v?: number | undefined;
    v130?: number | undefined;
    v150?: number | undefined;
    vk?: number | undefined;
    vnakl?: number | undefined;
    lk1?: number | undefined;
    lk2?: number | undefined;
    inflexWithPrevious?: boolean;
    inflexWithNext?: boolean;
    hasMezilehla?: boolean;
    lkm?: number | undefined;
}

export class DataStandardDTO implements IDataStandardDTO {
    id?: number;
    name?: string | undefined;
    classifierName?: string | undefined;
    rowVersion?: string | undefined;
    documentationStage?: DocumentationStage;

    constructor(data?: IDataStandardDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.classifierName = _data["classifierName"];
            this.rowVersion = _data["rowVersion"];
            this.documentationStage = _data["documentationStage"];
        }
    }

    static fromJS(data: any): DataStandardDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DataStandardDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["classifierName"] = this.classifierName;
        data["rowVersion"] = this.rowVersion;
        data["documentationStage"] = this.documentationStage;
        return data;
    }
}

export interface IDataStandardDTO {
    id?: number;
    name?: string | undefined;
    classifierName?: string | undefined;
    rowVersion?: string | undefined;
    documentationStage?: DocumentationStage;
}

export class DataStandardsFullTreeDTO implements IDataStandardsFullTreeDTO {
    id?: number;
    name?: string | undefined;
    pairersGroup?: PairerGroupFullTreeDTO[] | undefined;

    constructor(data?: IDataStandardsFullTreeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["pairersGroup"])) {
                this.pairersGroup = [] as any;
                for (let item of _data["pairersGroup"])
                    this.pairersGroup!.push(PairerGroupFullTreeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataStandardsFullTreeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DataStandardsFullTreeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.pairersGroup)) {
            data["pairersGroup"] = [];
            for (let item of this.pairersGroup)
                data["pairersGroup"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDataStandardsFullTreeDTO {
    id?: number;
    name?: string | undefined;
    pairersGroup?: PairerGroupFullTreeDTO[] | undefined;
}

export enum DataTypeValidation {
    None = "None",
    String = "String",
    Integer = "Integer",
    Decimal = "Decimal",
    Date = "Date",
    DateTime = "DateTime",
    Boolean = "Boolean",
    Guid = "Guid",
}

export class DeleteCurveRequest implements IDeleteCurveRequest {
    id?: number;

    constructor(data?: IDeleteCurveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteCurveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCurveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteCurveRequest {
    id?: number;
}

export class DeleteCurveResponse implements IDeleteCurveResponse {
    ok?: boolean;

    constructor(data?: IDeleteCurveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteCurveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCurveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteCurveResponse {
    ok?: boolean;
}

export class DeleteMicrostationPairingPairerResponse implements IDeleteMicrostationPairingPairerResponse {
    ok?: boolean;

    constructor(data?: IDeleteMicrostationPairingPairerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteMicrostationPairingPairerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMicrostationPairingPairerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteMicrostationPairingPairerResponse {
    ok?: boolean;
}

export class DeleteMicrostationPairingResponse implements IDeleteMicrostationPairingResponse {
    ok?: boolean;

    constructor(data?: IDeleteMicrostationPairingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteMicrostationPairingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMicrostationPairingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteMicrostationPairingResponse {
    ok?: boolean;
}

export class DeleteMStnFeederItemsRequest implements IDeleteMStnFeederItemsRequest {
    ids?: number[] | undefined;

    constructor(data?: IDeleteMStnFeederItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteMStnFeederItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMStnFeederItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IDeleteMStnFeederItemsRequest {
    ids?: number[] | undefined;
}

export class DeleteMStnFeederItemsResponse implements IDeleteMStnFeederItemsResponse {
    ok?: boolean;

    constructor(data?: IDeleteMStnFeederItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteMStnFeederItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMStnFeederItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteMStnFeederItemsResponse {
    ok?: boolean;
}

export class DeleteOrGroupRuleSetRequest implements IDeleteOrGroupRuleSetRequest {
    groupId?: number;
    groupIndex?: number;

    constructor(data?: IDeleteOrGroupRuleSetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.groupIndex = _data["groupIndex"];
        }
    }

    static fromJS(data: any): DeleteOrGroupRuleSetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteOrGroupRuleSetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["groupIndex"] = this.groupIndex;
        return data;
    }
}

export interface IDeleteOrGroupRuleSetRequest {
    groupId?: number;
    groupIndex?: number;
}

export class DeleteOrGroupRuleSetResponse implements IDeleteOrGroupRuleSetResponse {
    deleted?: boolean;

    constructor(data?: IDeleteOrGroupRuleSetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): DeleteOrGroupRuleSetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteOrGroupRuleSetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deleted"] = this.deleted;
        return data;
    }
}

export interface IDeleteOrGroupRuleSetResponse {
    deleted?: boolean;
}

export class DeletePairersRequest implements IDeletePairersRequest {
    ids?: number[] | undefined;

    constructor(data?: IDeletePairersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): DeletePairersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePairersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IDeletePairersRequest {
    ids?: number[] | undefined;
}

export class DeleteProjectRequest implements IDeleteProjectRequest {
    id?: number;

    constructor(data?: IDeleteProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteProjectRequest {
    id?: number;
}

export class DeleteProjectResponse implements IDeleteProjectResponse {
    ok?: boolean;

    constructor(data?: IDeleteProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteProjectResponse {
    ok?: boolean;
}

export class DeleteRouteRequest implements IDeleteRouteRequest {
    id?: number;

    constructor(data?: IDeleteRouteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteRouteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRouteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteRouteRequest {
    id?: number;
}

export class DeleteRouteResponse implements IDeleteRouteResponse {
    ok?: boolean;

    constructor(data?: IDeleteRouteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteRouteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRouteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteRouteResponse {
    ok?: boolean;
}

export class DeleteSelectorItemRequest implements IDeleteSelectorItemRequest {
    id?: number;
    selectorType?: SelectorType;

    constructor(data?: IDeleteSelectorItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.selectorType = _data["selectorType"];
        }
    }

    static fromJS(data: any): DeleteSelectorItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSelectorItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["selectorType"] = this.selectorType;
        return data;
    }
}

export interface IDeleteSelectorItemRequest {
    id?: number;
    selectorType?: SelectorType;
}

export class DeleteSelectorItemResponse implements IDeleteSelectorItemResponse {
    ok?: boolean;

    constructor(data?: IDeleteSelectorItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteSelectorItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSelectorItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteSelectorItemResponse {
    ok?: boolean;
}

export class DeleteSelectorRequest implements IDeleteSelectorRequest {
    id?: number;
    selectorType?: SelectorType;

    constructor(data?: IDeleteSelectorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.selectorType = _data["selectorType"];
        }
    }

    static fromJS(data: any): DeleteSelectorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSelectorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["selectorType"] = this.selectorType;
        return data;
    }
}

export interface IDeleteSelectorRequest {
    id?: number;
    selectorType?: SelectorType;
}

export class DeleteSelectorResponse implements IDeleteSelectorResponse {
    ok?: boolean;

    constructor(data?: IDeleteSelectorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteSelectorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSelectorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteSelectorResponse {
    ok?: boolean;
}

export class DeleteTenantResponse implements IDeleteTenantResponse {
    ok?: boolean;

    constructor(data?: IDeleteTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteTenantResponse {
    ok?: boolean;
}

export enum DocumentationStage {
    DUR = "DUR",
    DSP = "DSP",
    PDPS = "PDPS",
    RDS = "RDS",
}

export class EmptyResponse implements IEmptyResponse {
    unit?: Unit;

    constructor(data?: IEmptyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmptyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmptyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmptyResponse {
    unit?: Unit;
}

export class ExportResult implements IExportResult {
    errors?: string[] | undefined;
    fileResult?: any | undefined;

    constructor(data?: IExportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.fileResult = _data["fileResult"];
        }
    }

    static fromJS(data: any): ExportResult {
        data = typeof data === 'object' ? data : {};
        let result = new ExportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["fileResult"] = this.fileResult;
        return data;
    }
}

export interface IExportResult {
    errors?: string[] | undefined;
    fileResult?: any | undefined;
}

export enum FeederAutoValueState {
    OK = "OK",
    ElementNotFound = "ElementNotFound",
    AttributNotFound = "AttributNotFound",
    UnsupportedElement = "UnsupportedElement",
}

export enum FeederAutoValueType {
    ManualValue = "ManualValue",
    Volume = "Volume",
    Length = "Length",
    Area2D = "Area2D",
    Area3DUp = "Area3DUp",
}

export enum FeederStringValueType {
    ManualValue = "ManualValue",
    FromDS = "FromDS",
}

export class FilterElementsRequest implements IFilterElementsRequest {
    data?: string | undefined;
    filterModel?: string | undefined;

    constructor(data?: IFilterElementsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.filterModel = _data["filterModel"];
        }
    }

    static fromJS(data: any): FilterElementsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FilterElementsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["filterModel"] = this.filterModel;
        return data;
    }
}

export interface IFilterElementsRequest {
    data?: string | undefined;
    filterModel?: string | undefined;
}

export enum FilteringOperator {
    Equals = "Equals",
    Contains = "Contains",
    StartsWith = "StartsWith",
    EndsWith = "EndsWith",
    Empty = "Empty",
    NotEmpty = "NotEmpty",
}

export class FilterItem implements IFilterItem {
    field?: string | undefined;
    filterOperator?: FilteringOperator;
    value?: string | undefined;
    id?: number;

    constructor(data?: IFilterItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.filterOperator = _data["filterOperator"];
            this.value = _data["value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FilterItem {
        data = typeof data === 'object' ? data : {};
        let result = new FilterItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["filterOperator"] = this.filterOperator;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }
}

export interface IFilterItem {
    field?: string | undefined;
    filterOperator?: FilteringOperator;
    value?: string | undefined;
    id?: number;
}

export class GetAppLogoResponse implements IGetAppLogoResponse {
    base64?: string | undefined;

    constructor(data?: IGetAppLogoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): GetAppLogoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppLogoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        return data;
    }
}

export interface IGetAppLogoResponse {
    base64?: string | undefined;
}

export class GetCurvesForRouteResponse implements IGetCurvesForRouteResponse {
    routeId?: number;
    routeName?: string | undefined;
    projectId?: number;
    projectName?: string | undefined;
    curves?: CurveDTO[] | undefined;

    constructor(data?: IGetCurvesForRouteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.routeId = _data["routeId"];
            this.routeName = _data["routeName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            if (Array.isArray(_data["curves"])) {
                this.curves = [] as any;
                for (let item of _data["curves"])
                    this.curves!.push(CurveDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCurvesForRouteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurvesForRouteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routeId"] = this.routeId;
        data["routeName"] = this.routeName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        if (Array.isArray(this.curves)) {
            data["curves"] = [];
            for (let item of this.curves)
                data["curves"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCurvesForRouteResponse {
    routeId?: number;
    routeName?: string | undefined;
    projectId?: number;
    projectName?: string | undefined;
    curves?: CurveDTO[] | undefined;
}

export class GetDataFromModelRequest implements IGetDataFromModelRequest {
    models?: Model[] | undefined;

    constructor(data?: IGetDataFromModelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["models"])) {
                this.models = [] as any;
                for (let item of _data["models"])
                    this.models!.push(Model.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataFromModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataFromModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.models)) {
            data["models"] = [];
            for (let item of this.models)
                data["models"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDataFromModelRequest {
    models?: Model[] | undefined;
}

export class GetDataStandardForTreeFeederRequest implements IGetDataStandardForTreeFeederRequest {
    mStnPairingId?: number;
    levels?: LevelMStnDTO[] | undefined;

    constructor(data?: IGetDataStandardForTreeFeederRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(LevelMStnDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataStandardForTreeFeederRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataStandardForTreeFeederRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDataStandardForTreeFeederRequest {
    mStnPairingId?: number;
    levels?: LevelMStnDTO[] | undefined;
}

export class GetDataStandardForTreeFeederResponse implements IGetDataStandardForTreeFeederResponse {
    dataStandard?: PairerGroupFullDTO[] | undefined;

    constructor(data?: IGetDataStandardForTreeFeederResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dataStandard"])) {
                this.dataStandard = [] as any;
                for (let item of _data["dataStandard"])
                    this.dataStandard!.push(PairerGroupFullDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataStandardForTreeFeederResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataStandardForTreeFeederResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dataStandard)) {
            data["dataStandard"] = [];
            for (let item of this.dataStandard)
                data["dataStandard"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDataStandardForTreeFeederResponse {
    dataStandard?: PairerGroupFullDTO[] | undefined;
}

export class GetDataStandardForTreePairingResponse implements IGetDataStandardForTreePairingResponse {
    dataStandard?: PairerGroupFullDTO[] | undefined;

    constructor(data?: IGetDataStandardForTreePairingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dataStandard"])) {
                this.dataStandard = [] as any;
                for (let item of _data["dataStandard"])
                    this.dataStandard!.push(PairerGroupFullDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataStandardForTreePairingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataStandardForTreePairingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dataStandard)) {
            data["dataStandard"] = [];
            for (let item of this.dataStandard)
                data["dataStandard"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDataStandardForTreePairingResponse {
    dataStandard?: PairerGroupFullDTO[] | undefined;
}

export class GetDataStandardForTreeValRuleResponse implements IGetDataStandardForTreeValRuleResponse {
    dataStandard?: DataStandardsFullTreeDTO;

    constructor(data?: IGetDataStandardForTreeValRuleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataStandard = _data["dataStandard"] ? DataStandardsFullTreeDTO.fromJS(_data["dataStandard"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDataStandardForTreeValRuleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataStandardForTreeValRuleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataStandard"] = this.dataStandard ? this.dataStandard.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDataStandardForTreeValRuleResponse {
    dataStandard?: DataStandardsFullTreeDTO;
}

export class GetDataStandardsResponse implements IGetDataStandardsResponse {
    dataStandards?: DataStandardDTO[] | undefined;

    constructor(data?: IGetDataStandardsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dataStandards"])) {
                this.dataStandards = [] as any;
                for (let item of _data["dataStandards"])
                    this.dataStandards!.push(DataStandardDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataStandardsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataStandardsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dataStandards)) {
            data["dataStandards"] = [];
            for (let item of this.dataStandards)
                data["dataStandards"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDataStandardsResponse {
    dataStandards?: DataStandardDTO[] | undefined;
}

export class GetGroupsForStandardResponse implements IGetGroupsForStandardResponse {
    pairersGroups?: PairerGroupDTO[] | undefined;

    constructor(data?: IGetGroupsForStandardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pairersGroups"])) {
                this.pairersGroups = [] as any;
                for (let item of _data["pairersGroups"])
                    this.pairersGroups!.push(PairerGroupDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGroupsForStandardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGroupsForStandardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairersGroups)) {
            data["pairersGroups"] = [];
            for (let item of this.pairersGroups)
                data["pairersGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGroupsForStandardResponse {
    pairersGroups?: PairerGroupDTO[] | undefined;
}

export class GetInitDataResponse implements IGetInitDataResponse {
    generatedData?: OutputRowDTO[] | undefined;

    constructor(data?: IGetInitDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["generatedData"])) {
                this.generatedData = [] as any;
                for (let item of _data["generatedData"])
                    this.generatedData!.push(OutputRowDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInitDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInitDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.generatedData)) {
            data["generatedData"] = [];
            for (let item of this.generatedData)
                data["generatedData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetInitDataResponse {
    generatedData?: OutputRowDTO[] | undefined;
}

export class GetMicrostationPairingPairersResponse implements IGetMicrostationPairingPairersResponse {
    pairing?: MicrostationPairingPairerDTO[] | undefined;

    constructor(data?: IGetMicrostationPairingPairersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pairing"])) {
                this.pairing = [] as any;
                for (let item of _data["pairing"])
                    this.pairing!.push(MicrostationPairingPairerDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMicrostationPairingPairersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMicrostationPairingPairersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairing)) {
            data["pairing"] = [];
            for (let item of this.pairing)
                data["pairing"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMicrostationPairingPairersResponse {
    pairing?: MicrostationPairingPairerDTO[] | undefined;
}

export class GetMicrostationPairingResponse implements IGetMicrostationPairingResponse {
    pairings?: MicrostationPairingDTO[] | undefined;

    constructor(data?: IGetMicrostationPairingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pairings"])) {
                this.pairings = [] as any;
                for (let item of _data["pairings"])
                    this.pairings!.push(MicrostationPairingDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMicrostationPairingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMicrostationPairingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairings)) {
            data["pairings"] = [];
            for (let item of this.pairings)
                data["pairings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMicrostationPairingResponse {
    pairings?: MicrostationPairingDTO[] | undefined;
}

export class GetMStnFeederAllValRulesRequest implements IGetMStnFeederAllValRulesRequest {
    mStnPairingId?: number;
    levels?: LevelMStnDTO[] | undefined;

    constructor(data?: IGetMStnFeederAllValRulesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(LevelMStnDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMStnFeederAllValRulesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnFeederAllValRulesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMStnFeederAllValRulesRequest {
    mStnPairingId?: number;
    levels?: LevelMStnDTO[] | undefined;
}

export class GetMStnFeederAllValRulesResponse implements IGetMStnFeederAllValRulesResponse {
    pairerValRules?: PairerValRulesDTO[] | undefined;

    constructor(data?: IGetMStnFeederAllValRulesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pairerValRules"])) {
                this.pairerValRules = [] as any;
                for (let item of _data["pairerValRules"])
                    this.pairerValRules!.push(PairerValRulesDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMStnFeederAllValRulesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnFeederAllValRulesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairerValRules)) {
            data["pairerValRules"] = [];
            for (let item of this.pairerValRules)
                data["pairerValRules"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMStnFeederAllValRulesResponse {
    pairerValRules?: PairerValRulesDTO[] | undefined;
}

export class GetMStnFeederItemsResponse implements IGetMStnFeederItemsResponse {
    mStnFeederItems?: MStnFeederItemDTO[] | undefined;

    constructor(data?: IGetMStnFeederItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mStnFeederItems"])) {
                this.mStnFeederItems = [] as any;
                for (let item of _data["mStnFeederItems"])
                    this.mStnFeederItems!.push(MStnFeederItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMStnFeederItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnFeederItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mStnFeederItems)) {
            data["mStnFeederItems"] = [];
            for (let item of this.mStnFeederItems)
                data["mStnFeederItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMStnFeederItemsResponse {
    mStnFeederItems?: MStnFeederItemDTO[] | undefined;
}

export class GetMStnPairingsByLevelsRequest implements IGetMStnPairingsByLevelsRequest {
    mStnPairingId?: number;
    levels?: LevelMStnDTO[] | undefined;

    constructor(data?: IGetMStnPairingsByLevelsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(LevelMStnDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMStnPairingsByLevelsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnPairingsByLevelsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMStnPairingsByLevelsRequest {
    mStnPairingId?: number;
    levels?: LevelMStnDTO[] | undefined;
}

export class GetMStnPairingsByLevelsResponse implements IGetMStnPairingsByLevelsResponse {
    mStnPairings?: MStnPairingDTO[] | undefined;

    constructor(data?: IGetMStnPairingsByLevelsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mStnPairings"])) {
                this.mStnPairings = [] as any;
                for (let item of _data["mStnPairings"])
                    this.mStnPairings!.push(MStnPairingDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMStnPairingsByLevelsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnPairingsByLevelsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mStnPairings)) {
            data["mStnPairings"] = [];
            for (let item of this.mStnPairings)
                data["mStnPairings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMStnPairingsByLevelsResponse {
    mStnPairings?: MStnPairingDTO[] | undefined;
}

export class GetMStnPairingsByRelevance2Request implements IGetMStnPairingsByRelevance2Request {
    dataStandardId?: number;
    levels?: string[] | undefined;
    isCaseSensitive?: boolean;
    isDiacritics?: boolean;
    prefix?: number;
    suffix?: number;

    constructor(data?: IGetMStnPairingsByRelevance2Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataStandardId = _data["dataStandardId"];
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(item);
            }
            this.isCaseSensitive = _data["isCaseSensitive"];
            this.isDiacritics = _data["isDiacritics"];
            this.prefix = _data["prefix"];
            this.suffix = _data["suffix"];
        }
    }

    static fromJS(data: any): GetMStnPairingsByRelevance2Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnPairingsByRelevance2Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataStandardId"] = this.dataStandardId;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item);
        }
        data["isCaseSensitive"] = this.isCaseSensitive;
        data["isDiacritics"] = this.isDiacritics;
        data["prefix"] = this.prefix;
        data["suffix"] = this.suffix;
        return data;
    }
}

export interface IGetMStnPairingsByRelevance2Request {
    dataStandardId?: number;
    levels?: string[] | undefined;
    isCaseSensitive?: boolean;
    isDiacritics?: boolean;
    prefix?: number;
    suffix?: number;
}

export class GetMStnPairingsByRelevance2Response implements IGetMStnPairingsByRelevance2Response {
    mStnPairingRelevance?: MStnPairingRelevanceDTO[] | undefined;

    constructor(data?: IGetMStnPairingsByRelevance2Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mStnPairingRelevance"])) {
                this.mStnPairingRelevance = [] as any;
                for (let item of _data["mStnPairingRelevance"])
                    this.mStnPairingRelevance!.push(MStnPairingRelevanceDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMStnPairingsByRelevance2Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnPairingsByRelevance2Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mStnPairingRelevance)) {
            data["mStnPairingRelevance"] = [];
            for (let item of this.mStnPairingRelevance)
                data["mStnPairingRelevance"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMStnPairingsByRelevance2Response {
    mStnPairingRelevance?: MStnPairingRelevanceDTO[] | undefined;
}

export class GetMStnPairingsByRelevanceRequest implements IGetMStnPairingsByRelevanceRequest {
    dataStandardId?: number;
    mStnPairingId?: number;
    levels?: string[] | undefined;
    isCaseSensitive?: boolean;
    isDiacritics?: boolean;
    prefix?: number;
    suffix?: number;

    constructor(data?: IGetMStnPairingsByRelevanceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataStandardId = _data["dataStandardId"];
            this.mStnPairingId = _data["mStnPairingId"];
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(item);
            }
            this.isCaseSensitive = _data["isCaseSensitive"];
            this.isDiacritics = _data["isDiacritics"];
            this.prefix = _data["prefix"];
            this.suffix = _data["suffix"];
        }
    }

    static fromJS(data: any): GetMStnPairingsByRelevanceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnPairingsByRelevanceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataStandardId"] = this.dataStandardId;
        data["mStnPairingId"] = this.mStnPairingId;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item);
        }
        data["isCaseSensitive"] = this.isCaseSensitive;
        data["isDiacritics"] = this.isDiacritics;
        data["prefix"] = this.prefix;
        data["suffix"] = this.suffix;
        return data;
    }
}

export interface IGetMStnPairingsByRelevanceRequest {
    dataStandardId?: number;
    mStnPairingId?: number;
    levels?: string[] | undefined;
    isCaseSensitive?: boolean;
    isDiacritics?: boolean;
    prefix?: number;
    suffix?: number;
}

export class GetMStnPairingsByRelevanceResponse implements IGetMStnPairingsByRelevanceResponse {
    mStnPairingRelevance?: MStnPairingRelevanceDTO[] | undefined;

    constructor(data?: IGetMStnPairingsByRelevanceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mStnPairingRelevance"])) {
                this.mStnPairingRelevance = [] as any;
                for (let item of _data["mStnPairingRelevance"])
                    this.mStnPairingRelevance!.push(MStnPairingRelevanceDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMStnPairingsByRelevanceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnPairingsByRelevanceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mStnPairingRelevance)) {
            data["mStnPairingRelevance"] = [];
            for (let item of this.mStnPairingRelevance)
                data["mStnPairingRelevance"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMStnPairingsByRelevanceResponse {
    mStnPairingRelevance?: MStnPairingRelevanceDTO[] | undefined;
}

export class GetMStnPairingsLevelsNameResponse implements IGetMStnPairingsLevelsNameResponse {
    levelNames?: string[] | undefined;

    constructor(data?: IGetMStnPairingsLevelsNameResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["levelNames"])) {
                this.levelNames = [] as any;
                for (let item of _data["levelNames"])
                    this.levelNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetMStnPairingsLevelsNameResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnPairingsLevelsNameResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.levelNames)) {
            data["levelNames"] = [];
            for (let item of this.levelNames)
                data["levelNames"].push(item);
        }
        return data;
    }
}

export interface IGetMStnPairingsLevelsNameResponse {
    levelNames?: string[] | undefined;
}

export class GetMultiPairerByGroupIdResponse implements IGetMultiPairerByGroupIdResponse {
    rows?: MultiPairerRowDTO[] | undefined;

    constructor(data?: IGetMultiPairerByGroupIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(MultiPairerRowDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMultiPairerByGroupIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMultiPairerByGroupIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMultiPairerByGroupIdResponse {
    rows?: MultiPairerRowDTO[] | undefined;
}

export class GetMultiPairerByIdsRequest implements IGetMultiPairerByIdsRequest {
    ids?: number[] | undefined;

    constructor(data?: IGetMultiPairerByIdsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): GetMultiPairerByIdsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMultiPairerByIdsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IGetMultiPairerByIdsRequest {
    ids?: number[] | undefined;
}

export class GetMultiPairerByIdsResponse implements IGetMultiPairerByIdsResponse {
    rows?: MultiPairerRowDTO[] | undefined;

    constructor(data?: IGetMultiPairerByIdsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(MultiPairerRowDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMultiPairerByIdsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMultiPairerByIdsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMultiPairerByIdsResponse {
    rows?: MultiPairerRowDTO[] | undefined;
}

export class GetNewVersionResponse implements IGetNewVersionResponse {
    downloadLink?: string | undefined;

    constructor(data?: IGetNewVersionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.downloadLink = _data["downloadLink"];
        }
    }

    static fromJS(data: any): GetNewVersionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewVersionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadLink"] = this.downloadLink;
        return data;
    }
}

export interface IGetNewVersionResponse {
    downloadLink?: string | undefined;
}

export class GetPairerDetailResponse implements IGetPairerDetailResponse {
    id?: number;
    name?: string | undefined;
    filter?: string | undefined;
    standardId?: number;
    groupId?: number;
    rowVersion?: string | undefined;
    isParsable?: boolean;
    filterItems?: FilterItem[] | undefined;
    validationRules?: PairerDetailValidationRuleDTO[] | undefined;
    validationOrGroups?: ValidationOrGroupDTO[] | undefined;

    constructor(data?: IGetPairerDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.filter = _data["filter"];
            this.standardId = _data["standardId"];
            this.groupId = _data["groupId"];
            this.rowVersion = _data["rowVersion"];
            this.isParsable = _data["isParsable"];
            if (Array.isArray(_data["filterItems"])) {
                this.filterItems = [] as any;
                for (let item of _data["filterItems"])
                    this.filterItems!.push(FilterItem.fromJS(item));
            }
            if (Array.isArray(_data["validationRules"])) {
                this.validationRules = [] as any;
                for (let item of _data["validationRules"])
                    this.validationRules!.push(PairerDetailValidationRuleDTO.fromJS(item));
            }
            if (Array.isArray(_data["validationOrGroups"])) {
                this.validationOrGroups = [] as any;
                for (let item of _data["validationOrGroups"])
                    this.validationOrGroups!.push(ValidationOrGroupDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPairerDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPairerDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["filter"] = this.filter;
        data["standardId"] = this.standardId;
        data["groupId"] = this.groupId;
        data["rowVersion"] = this.rowVersion;
        data["isParsable"] = this.isParsable;
        if (Array.isArray(this.filterItems)) {
            data["filterItems"] = [];
            for (let item of this.filterItems)
                data["filterItems"].push(item.toJSON());
        }
        if (Array.isArray(this.validationRules)) {
            data["validationRules"] = [];
            for (let item of this.validationRules)
                data["validationRules"].push(item.toJSON());
        }
        if (Array.isArray(this.validationOrGroups)) {
            data["validationOrGroups"] = [];
            for (let item of this.validationOrGroups)
                data["validationOrGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPairerDetailResponse {
    id?: number;
    name?: string | undefined;
    filter?: string | undefined;
    standardId?: number;
    groupId?: number;
    rowVersion?: string | undefined;
    isParsable?: boolean;
    filterItems?: FilterItem[] | undefined;
    validationRules?: PairerDetailValidationRuleDTO[] | undefined;
    validationOrGroups?: ValidationOrGroupDTO[] | undefined;
}

export class GetPairerListForGroupIdResponse implements IGetPairerListForGroupIdResponse {
    pairers?: PairerDTO[] | undefined;
    elapsedTimeMilliseconds?: number;

    constructor(data?: IGetPairerListForGroupIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pairers"])) {
                this.pairers = [] as any;
                for (let item of _data["pairers"])
                    this.pairers!.push(PairerDTO.fromJS(item));
            }
            this.elapsedTimeMilliseconds = _data["elapsedTimeMilliseconds"];
        }
    }

    static fromJS(data: any): GetPairerListForGroupIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPairerListForGroupIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairers)) {
            data["pairers"] = [];
            for (let item of this.pairers)
                data["pairers"].push(item.toJSON());
        }
        data["elapsedTimeMilliseconds"] = this.elapsedTimeMilliseconds;
        return data;
    }
}

export interface IGetPairerListForGroupIdResponse {
    pairers?: PairerDTO[] | undefined;
    elapsedTimeMilliseconds?: number;
}

export class GetProjectsForTenantResponse implements IGetProjectsForTenantResponse {
    tenantId?: number;
    tenantName?: string | undefined;
    projects?: ProjectDTO[] | undefined;

    constructor(data?: IGetProjectsForTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectsForTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectsForTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectsForTenantResponse {
    tenantId?: number;
    tenantName?: string | undefined;
    projects?: ProjectDTO[] | undefined;
}

export class GetResetPasswordUserDataResponse implements IGetResetPasswordUserDataResponse {
    userId?: number;

    constructor(data?: IGetResetPasswordUserDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): GetResetPasswordUserDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetResetPasswordUserDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}

export interface IGetResetPasswordUserDataResponse {
    userId?: number;
}

export class GetRoutesForProjectResponse implements IGetRoutesForProjectResponse {
    projectId?: number;
    projectData?: ProjectDataDTO;
    routes?: RouteDTO[] | undefined;

    constructor(data?: IGetRoutesForProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectData = _data["projectData"] ? ProjectDataDTO.fromJS(_data["projectData"]) : <any>undefined;
            if (Array.isArray(_data["routes"])) {
                this.routes = [] as any;
                for (let item of _data["routes"])
                    this.routes!.push(RouteDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRoutesForProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoutesForProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectData"] = this.projectData ? this.projectData.toJSON() : <any>undefined;
        if (Array.isArray(this.routes)) {
            data["routes"] = [];
            for (let item of this.routes)
                data["routes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRoutesForProjectResponse {
    projectId?: number;
    projectData?: ProjectDataDTO;
    routes?: RouteDTO[] | undefined;
}

export class GetSelectorItemsRequest implements IGetSelectorItemsRequest {
    id?: number;
    type?: SelectorType;

    constructor(data?: IGetSelectorItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): GetSelectorItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectorItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        return data;
    }
}

export interface IGetSelectorItemsRequest {
    id?: number;
    type?: SelectorType;
}

export class GetSelectorItemsResponse implements IGetSelectorItemsResponse {
    selectorItems?: SelectorItemDTO[] | undefined;

    constructor(data?: IGetSelectorItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectorItems"])) {
                this.selectorItems = [] as any;
                for (let item of _data["selectorItems"])
                    this.selectorItems!.push(SelectorItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSelectorItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectorItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectorItems)) {
            data["selectorItems"] = [];
            for (let item of this.selectorItems)
                data["selectorItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSelectorItemsResponse {
    selectorItems?: SelectorItemDTO[] | undefined;
}

export class GetSelectorListRequest implements IGetSelectorListRequest {
    type?: SelectorType;
    options?: SelectorOptionDTO;

    constructor(data?: IGetSelectorListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.options = _data["options"] ? SelectorOptionDTO.fromJS(_data["options"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSelectorListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectorListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSelectorListRequest {
    type?: SelectorType;
    options?: SelectorOptionDTO;
}

export class GetSelectorListResponse implements IGetSelectorListResponse {
    selectorList?: SelectorListDTO[] | undefined;

    constructor(data?: IGetSelectorListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectorList"])) {
                this.selectorList = [] as any;
                for (let item of _data["selectorList"])
                    this.selectorList!.push(SelectorListDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSelectorListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectorListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectorList)) {
            data["selectorList"] = [];
            for (let item of this.selectorList)
                data["selectorList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSelectorListResponse {
    selectorList?: SelectorListDTO[] | undefined;
}

export class GetSignupUserDataResponse implements IGetSignupUserDataResponse {
    userId?: number;
    localLogin?: boolean;
    msLogin?: boolean;

    constructor(data?: IGetSignupUserDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.localLogin = _data["localLogin"];
            this.msLogin = _data["msLogin"];
        }
    }

    static fromJS(data: any): GetSignupUserDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSignupUserDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["localLogin"] = this.localLogin;
        data["msLogin"] = this.msLogin;
        return data;
    }
}

export interface IGetSignupUserDataResponse {
    userId?: number;
    localLogin?: boolean;
    msLogin?: boolean;
}

export class GetTenantsAdminResponse implements IGetTenantsAdminResponse {
    tenants?: TenantDTO[] | undefined;

    constructor(data?: IGetTenantsAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantsAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantsAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTenantsAdminResponse {
    tenants?: TenantDTO[] | undefined;
}

export class GetTenantsUserResponse implements IGetTenantsUserResponse {
    tenants?: TenantDTO[] | undefined;

    constructor(data?: IGetTenantsUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantsUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantsUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTenantsUserResponse {
    tenants?: TenantDTO[] | undefined;
}

export class GetUploaderUriResponse implements IGetUploaderUriResponse {
    uri?: string | undefined;
    updateId?: number;

    constructor(data?: IGetUploaderUriResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uri = _data["uri"];
            this.updateId = _data["updateId"];
        }
    }

    static fromJS(data: any): GetUploaderUriResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUploaderUriResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uri"] = this.uri;
        data["updateId"] = this.updateId;
        return data;
    }
}

export interface IGetUploaderUriResponse {
    uri?: string | undefined;
    updateId?: number;
}

export class GetUserInfoResponse implements IGetUserInfoResponse {
    userId?: number;
    tenantId?: number;
    username?: string | undefined;
    userSurname?: string | undefined;
    userEmail?: string | undefined;
    tenantName?: string | undefined;
    canCreateTenant?: boolean;
    canCreateUsers?: boolean;
    initials?: string | undefined;
    isAdmin?: boolean;
    validatingTreeProps?: boolean;

    constructor(data?: IGetUserInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.username = _data["username"];
            this.userSurname = _data["userSurname"];
            this.userEmail = _data["userEmail"];
            this.tenantName = _data["tenantName"];
            this.canCreateTenant = _data["canCreateTenant"];
            this.canCreateUsers = _data["canCreateUsers"];
            this.initials = _data["initials"];
            this.isAdmin = _data["isAdmin"];
            this.validatingTreeProps = _data["validatingTreeProps"];
        }
    }

    static fromJS(data: any): GetUserInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["username"] = this.username;
        data["userSurname"] = this.userSurname;
        data["userEmail"] = this.userEmail;
        data["tenantName"] = this.tenantName;
        data["canCreateTenant"] = this.canCreateTenant;
        data["canCreateUsers"] = this.canCreateUsers;
        data["initials"] = this.initials;
        data["isAdmin"] = this.isAdmin;
        data["validatingTreeProps"] = this.validatingTreeProps;
        return data;
    }
}

export interface IGetUserInfoResponse {
    userId?: number;
    tenantId?: number;
    username?: string | undefined;
    userSurname?: string | undefined;
    userEmail?: string | undefined;
    tenantName?: string | undefined;
    canCreateTenant?: boolean;
    canCreateUsers?: boolean;
    initials?: string | undefined;
    isAdmin?: boolean;
    validatingTreeProps?: boolean;
}

export class GetUsersTenantResponse implements IGetUsersTenantResponse {
    tenant?: TenantDTO;

    constructor(data?: IGetUsersTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenant = _data["tenant"] ? TenantDTO.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUsersTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUsersTenantResponse {
    tenant?: TenantDTO;
}

export class GetUserTenantsResponse implements IGetUserTenantsResponse {
    tenants?: TenantListDTO[] | undefined;

    constructor(data?: IGetUserTenantsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantListDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserTenantsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserTenantsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserTenantsResponse {
    tenants?: TenantListDTO[] | undefined;
}

export class GridFilterModel implements IGridFilterModel {
    items?: GridFilterModelItem[] | undefined;
    logicOperator?: GridLogicOperator;

    constructor(data?: IGridFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GridFilterModelItem.fromJS(item));
            }
            this.logicOperator = _data["logicOperator"];
        }
    }

    static fromJS(data: any): GridFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new GridFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["logicOperator"] = this.logicOperator;
        return data;
    }
}

export interface IGridFilterModel {
    items?: GridFilterModelItem[] | undefined;
    logicOperator?: GridLogicOperator;
}

export class GridFilterModelItem implements IGridFilterModelItem {
    id?: number;
    field?: string | undefined;
    operator?: string | undefined;
    value?: string | undefined;

    constructor(data?: IGridFilterModelItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.field = _data["field"];
            this.operator = _data["operator"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GridFilterModelItem {
        data = typeof data === 'object' ? data : {};
        let result = new GridFilterModelItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["field"] = this.field;
        data["operator"] = this.operator;
        data["value"] = this.value;
        return data;
    }
}

export interface IGridFilterModelItem {
    id?: number;
    field?: string | undefined;
    operator?: string | undefined;
    value?: string | undefined;
}

export enum GridLogicOperator {
    And = "And",
    Or = "Or",
}

export class ChangeUserPasswordRequest implements IChangeUserPasswordRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IChangeUserPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangeUserPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangeUserPasswordRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
}

export class ChangeUserPasswordResponse implements IChangeUserPasswordResponse {
    ok?: boolean;

    constructor(data?: IChangeUserPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): ChangeUserPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IChangeUserPasswordResponse {
    ok?: boolean;
}

export class ChangeUserTenantRequest implements IChangeUserTenantRequest {
    tenantId?: number;

    constructor(data?: IChangeUserTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): ChangeUserTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IChangeUserTenantRequest {
    tenantId?: number;
}

export class ChangeUserTenantResponse implements IChangeUserTenantResponse {
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenantId?: number;

    constructor(data?: IChangeUserTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.tokenExpiration = _data["tokenExpiration"] ? new Date(_data["tokenExpiration"].toString()) : <any>undefined;
            this.refreshToken = _data["refreshToken"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): ChangeUserTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["tokenExpiration"] = this.tokenExpiration ? this.tokenExpiration.toISOString() : <any>undefined;
        data["refreshToken"] = this.refreshToken;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IChangeUserTenantResponse {
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenantId?: number;
}

export class IdsExportRequest implements IIdsExportRequest {
    dataStandardId?: number;
    exportOrsAsAnds?: boolean;
    propertySetName?: string | undefined;

    constructor(data?: IIdsExportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataStandardId = _data["dataStandardId"];
            this.exportOrsAsAnds = _data["exportOrsAsAnds"];
            this.propertySetName = _data["propertySetName"];
        }
    }

    static fromJS(data: any): IdsExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IdsExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataStandardId"] = this.dataStandardId;
        data["exportOrsAsAnds"] = this.exportOrsAsAnds;
        data["propertySetName"] = this.propertySetName;
        return data;
    }
}

export interface IIdsExportRequest {
    dataStandardId?: number;
    exportOrsAsAnds?: boolean;
    propertySetName?: string | undefined;
}

export class ImportDataStandardLocallyRequest implements IImportDataStandardLocallyRequest {
    standardId?: number;
    filterField?: string | undefined;
    documentationStage?: DocumentationStage;
    filterStage?: boolean;
    prefix?: string | undefined;
    whiteSubstition?: string | undefined;
    file?: string | undefined;

    constructor(data?: IImportDataStandardLocallyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardId = _data["standardId"];
            this.filterField = _data["filterField"];
            this.documentationStage = _data["documentationStage"];
            this.filterStage = _data["filterStage"];
            this.prefix = _data["prefix"];
            this.whiteSubstition = _data["whiteSubstition"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): ImportDataStandardLocallyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportDataStandardLocallyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardId"] = this.standardId;
        data["filterField"] = this.filterField;
        data["documentationStage"] = this.documentationStage;
        data["filterStage"] = this.filterStage;
        data["prefix"] = this.prefix;
        data["whiteSubstition"] = this.whiteSubstition;
        data["file"] = this.file;
        return data;
    }
}

export interface IImportDataStandardLocallyRequest {
    standardId?: number;
    filterField?: string | undefined;
    documentationStage?: DocumentationStage;
    filterStage?: boolean;
    prefix?: string | undefined;
    whiteSubstition?: string | undefined;
    file?: string | undefined;
}

export class ImportDataStandardRequest implements IImportDataStandardRequest {
    standardId?: number;
    filterField?: string | undefined;
    documentationStage?: DocumentationStage;
    filterStage?: boolean;
    prefix?: string | undefined;
    whiteSubstition?: string | undefined;
    file?: string | undefined;
    elementNameColumn?: number;
    importCciValues?: boolean;

    constructor(data?: IImportDataStandardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardId = _data["standardId"];
            this.filterField = _data["filterField"];
            this.documentationStage = _data["documentationStage"];
            this.filterStage = _data["filterStage"];
            this.prefix = _data["prefix"];
            this.whiteSubstition = _data["whiteSubstition"];
            this.file = _data["file"];
            this.elementNameColumn = _data["elementNameColumn"];
            this.importCciValues = _data["importCciValues"];
        }
    }

    static fromJS(data: any): ImportDataStandardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportDataStandardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardId"] = this.standardId;
        data["filterField"] = this.filterField;
        data["documentationStage"] = this.documentationStage;
        data["filterStage"] = this.filterStage;
        data["prefix"] = this.prefix;
        data["whiteSubstition"] = this.whiteSubstition;
        data["file"] = this.file;
        data["elementNameColumn"] = this.elementNameColumn;
        data["importCciValues"] = this.importCciValues;
        return data;
    }
}

export interface IImportDataStandardRequest {
    standardId?: number;
    filterField?: string | undefined;
    documentationStage?: DocumentationStage;
    filterStage?: boolean;
    prefix?: string | undefined;
    whiteSubstition?: string | undefined;
    file?: string | undefined;
    elementNameColumn?: number;
    importCciValues?: boolean;
}

export class ImportDataStandardResponse implements IImportDataStandardResponse {
    ok?: boolean;

    constructor(data?: IImportDataStandardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): ImportDataStandardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportDataStandardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IImportDataStandardResponse {
    ok?: boolean;
}

export class ImportMultiCurvesNewRequest implements IImportMultiCurvesNewRequest {
    curves?: CurveDTO[] | undefined;
    projectId?: number;
    routeId?: number | undefined;
    toExisting?: boolean;
    replace?: boolean;
    routeName?: string | undefined;

    constructor(data?: IImportMultiCurvesNewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["curves"])) {
                this.curves = [] as any;
                for (let item of _data["curves"])
                    this.curves!.push(CurveDTO.fromJS(item));
            }
            this.projectId = _data["projectId"];
            this.routeId = _data["routeId"];
            this.toExisting = _data["toExisting"];
            this.replace = _data["replace"];
            this.routeName = _data["routeName"];
        }
    }

    static fromJS(data: any): ImportMultiCurvesNewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportMultiCurvesNewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.curves)) {
            data["curves"] = [];
            for (let item of this.curves)
                data["curves"].push(item.toJSON());
        }
        data["projectId"] = this.projectId;
        data["routeId"] = this.routeId;
        data["toExisting"] = this.toExisting;
        data["replace"] = this.replace;
        data["routeName"] = this.routeName;
        return data;
    }
}

export interface IImportMultiCurvesNewRequest {
    curves?: CurveDTO[] | undefined;
    projectId?: number;
    routeId?: number | undefined;
    toExisting?: boolean;
    replace?: boolean;
    routeName?: string | undefined;
}

export class ImportMultiCurvesNewResponse implements IImportMultiCurvesNewResponse {
    routeId?: number;

    constructor(data?: IImportMultiCurvesNewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.routeId = _data["routeId"];
        }
    }

    static fromJS(data: any): ImportMultiCurvesNewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportMultiCurvesNewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routeId"] = this.routeId;
        return data;
    }
}

export interface IImportMultiCurvesNewResponse {
    routeId?: number;
}

export enum InvalidFieldReasons {
    InvalidFieldName = "InvalidFieldName",
    InvalidDataType = "InvalidDataType",
    InvalidNull = "InvalidNull",
    InvalidCondition = "InvalidCondition",
    InvalidField = "InvalidField",
}

export class LevelMStnDTO implements ILevelMStnDTO {
    levelName?: string | undefined;
    type?: number;

    constructor(data?: ILevelMStnDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.levelName = _data["levelName"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): LevelMStnDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LevelMStnDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelName"] = this.levelName;
        data["type"] = this.type;
        return data;
    }
}

export interface ILevelMStnDTO {
    levelName?: string | undefined;
    type?: number;
}

export class MicrostationPairingDTO implements IMicrostationPairingDTO {
    id?: number;
    projectId?: number;
    dataStandardId?: number;
    name?: string | undefined;

    constructor(data?: IMicrostationPairingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.dataStandardId = _data["dataStandardId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MicrostationPairingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MicrostationPairingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["dataStandardId"] = this.dataStandardId;
        data["name"] = this.name;
        return data;
    }
}

export interface IMicrostationPairingDTO {
    id?: number;
    projectId?: number;
    dataStandardId?: number;
    name?: string | undefined;
}

export class MicrostationPairingPairerDTO implements IMicrostationPairingPairerDTO {
    id?: number;
    levelName?: string | undefined;
    type?: number;
    pairerName?: string | undefined;

    constructor(data?: IMicrostationPairingPairerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.levelName = _data["levelName"];
            this.type = _data["type"];
            this.pairerName = _data["pairerName"];
        }
    }

    static fromJS(data: any): MicrostationPairingPairerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MicrostationPairingPairerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["levelName"] = this.levelName;
        data["type"] = this.type;
        data["pairerName"] = this.pairerName;
        return data;
    }
}

export interface IMicrostationPairingPairerDTO {
    id?: number;
    levelName?: string | undefined;
    type?: number;
    pairerName?: string | undefined;
}

export class Model implements IModel {
    elements?: ModelData[] | undefined;
    modelId?: number;

    constructor(data?: IModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ModelData.fromJS(item));
            }
            this.modelId = _data["modelId"];
        }
    }

    static fromJS(data: any): Model {
        data = typeof data === 'object' ? data : {};
        let result = new Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["modelId"] = this.modelId;
        return data;
    }
}

export interface IModel {
    elements?: ModelData[] | undefined;
    modelId?: number;
}

export class ModelData implements IModelData {
    expressId?: number;
    ifcId?: string | undefined;
    propertySets?: PropertySet[] | undefined;

    constructor(data?: IModelData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressId = _data["expressId"];
            this.ifcId = _data["ifcId"];
            if (Array.isArray(_data["propertySets"])) {
                this.propertySets = [] as any;
                for (let item of _data["propertySets"])
                    this.propertySets!.push(PropertySet.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModelData {
        data = typeof data === 'object' ? data : {};
        let result = new ModelData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expressId"] = this.expressId;
        data["ifcId"] = this.ifcId;
        if (Array.isArray(this.propertySets)) {
            data["propertySets"] = [];
            for (let item of this.propertySets)
                data["propertySets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IModelData {
    expressId?: number;
    ifcId?: string | undefined;
    propertySets?: PropertySet[] | undefined;
}

export class MStnElementDTO implements IMStnElementDTO {
    id?: string | undefined;
    pairerLevel?: PairerLevelDTO;

    constructor(data?: IMStnElementDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pairerLevel = _data["pairerLevel"] ? PairerLevelDTO.fromJS(_data["pairerLevel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MStnElementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MStnElementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pairerLevel"] = this.pairerLevel ? this.pairerLevel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMStnElementDTO {
    id?: string | undefined;
    pairerLevel?: PairerLevelDTO;
}

export class MStnFeederAutoValueDTO implements IMStnFeederAutoValueDTO {
    elementId?: string | undefined;
    validationRuleId?: number;
    autoValue?: string | undefined;
    autoValueType?: FeederAutoValueType;
    stringValueType?: FeederStringValueType;
    autoValueState?: FeederAutoValueState;

    constructor(data?: IMStnFeederAutoValueDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementId = _data["elementId"];
            this.validationRuleId = _data["validationRuleId"];
            this.autoValue = _data["autoValue"];
            this.autoValueType = _data["autoValueType"];
            this.stringValueType = _data["stringValueType"];
            this.autoValueState = _data["autoValueState"];
        }
    }

    static fromJS(data: any): MStnFeederAutoValueDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MStnFeederAutoValueDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementId"] = this.elementId;
        data["validationRuleId"] = this.validationRuleId;
        data["autoValue"] = this.autoValue;
        data["autoValueType"] = this.autoValueType;
        data["stringValueType"] = this.stringValueType;
        data["autoValueState"] = this.autoValueState;
        return data;
    }
}

export interface IMStnFeederAutoValueDTO {
    elementId?: string | undefined;
    validationRuleId?: number;
    autoValue?: string | undefined;
    autoValueType?: FeederAutoValueType;
    stringValueType?: FeederStringValueType;
    autoValueState?: FeederAutoValueState;
}

export class MStnFeederFromDGNDTO implements IMStnFeederFromDGNDTO {
    elementId?: string | undefined;
    validationRuleId?: number;
    value?: string | undefined;

    constructor(data?: IMStnFeederFromDGNDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementId = _data["elementId"];
            this.validationRuleId = _data["validationRuleId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): MStnFeederFromDGNDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MStnFeederFromDGNDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementId"] = this.elementId;
        data["validationRuleId"] = this.validationRuleId;
        data["value"] = this.value;
        return data;
    }
}

export interface IMStnFeederFromDGNDTO {
    elementId?: string | undefined;
    validationRuleId?: number;
    value?: string | undefined;
}

export class MStnFeederItemDTO implements IMStnFeederItemDTO {
    id?: number;
    level?: number;
    itemId?: number | undefined;
    elementId?: string | undefined;
    value?: string | undefined;
    overwrite?: boolean;
    isLocked?: boolean;
    autoValueType?: FeederAutoValueType;
    stringValueType?: FeederStringValueType;
    autoValueState?: FeederAutoValueState;
    autoValue?: string | undefined;
    validationRule?: ValidationRuleFullTreeDTO;

    constructor(data?: IMStnFeederItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.level = _data["level"];
            this.itemId = _data["itemId"];
            this.elementId = _data["elementId"];
            this.value = _data["value"];
            this.overwrite = _data["overwrite"];
            this.isLocked = _data["isLocked"];
            this.autoValueType = _data["autoValueType"];
            this.stringValueType = _data["stringValueType"];
            this.autoValueState = _data["autoValueState"];
            this.autoValue = _data["autoValue"];
            this.validationRule = _data["validationRule"] ? ValidationRuleFullTreeDTO.fromJS(_data["validationRule"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MStnFeederItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MStnFeederItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["level"] = this.level;
        data["itemId"] = this.itemId;
        data["elementId"] = this.elementId;
        data["value"] = this.value;
        data["overwrite"] = this.overwrite;
        data["isLocked"] = this.isLocked;
        data["autoValueType"] = this.autoValueType;
        data["stringValueType"] = this.stringValueType;
        data["autoValueState"] = this.autoValueState;
        data["autoValue"] = this.autoValue;
        data["validationRule"] = this.validationRule ? this.validationRule.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMStnFeederItemDTO {
    id?: number;
    level?: number;
    itemId?: number | undefined;
    elementId?: string | undefined;
    value?: string | undefined;
    overwrite?: boolean;
    isLocked?: boolean;
    autoValueType?: FeederAutoValueType;
    stringValueType?: FeederStringValueType;
    autoValueState?: FeederAutoValueState;
    autoValue?: string | undefined;
    validationRule?: ValidationRuleFullTreeDTO;
}

export class MStnPairingAssignDTO implements IMStnPairingAssignDTO {
    pairerId?: number;
    levelName?: string | undefined;
    type?: number;

    constructor(data?: IMStnPairingAssignDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pairerId = _data["pairerId"];
            this.levelName = _data["levelName"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): MStnPairingAssignDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MStnPairingAssignDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pairerId"] = this.pairerId;
        data["levelName"] = this.levelName;
        data["type"] = this.type;
        return data;
    }
}

export interface IMStnPairingAssignDTO {
    pairerId?: number;
    levelName?: string | undefined;
    type?: number;
}

export class MStnPairingDTO implements IMStnPairingDTO {
    id?: number;
    levelName?: string | undefined;
    type?: number;
    pairer?: PairerFullTreeDTO;

    constructor(data?: IMStnPairingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.levelName = _data["levelName"];
            this.type = _data["type"];
            this.pairer = _data["pairer"] ? PairerFullTreeDTO.fromJS(_data["pairer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MStnPairingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MStnPairingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["levelName"] = this.levelName;
        data["type"] = this.type;
        data["pairer"] = this.pairer ? this.pairer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMStnPairingDTO {
    id?: number;
    levelName?: string | undefined;
    type?: number;
    pairer?: PairerFullTreeDTO;
}

export class MStnPairingRelevanceDTO implements IMStnPairingRelevanceDTO {
    levelNamePuv?: string | undefined;
    type?: number;
    items?: MStnPairingRelevanceItemsDTO[] | undefined;

    constructor(data?: IMStnPairingRelevanceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.levelNamePuv = _data["levelNamePuv"];
            this.type = _data["type"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MStnPairingRelevanceItemsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MStnPairingRelevanceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MStnPairingRelevanceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelNamePuv"] = this.levelNamePuv;
        data["type"] = this.type;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMStnPairingRelevanceDTO {
    levelNamePuv?: string | undefined;
    type?: number;
    items?: MStnPairingRelevanceItemsDTO[] | undefined;
}

export class MStnPairingRelevanceItemsDTO implements IMStnPairingRelevanceItemsDTO {
    levelName?: string | undefined;
    pairerId?: number;
    pairerName?: string | undefined;
    pairerGroupName?: string | undefined;
    relevance?: number;

    constructor(data?: IMStnPairingRelevanceItemsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.levelName = _data["levelName"];
            this.pairerId = _data["pairerId"];
            this.pairerName = _data["pairerName"];
            this.pairerGroupName = _data["pairerGroupName"];
            this.relevance = _data["relevance"];
        }
    }

    static fromJS(data: any): MStnPairingRelevanceItemsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MStnPairingRelevanceItemsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelName"] = this.levelName;
        data["pairerId"] = this.pairerId;
        data["pairerName"] = this.pairerName;
        data["pairerGroupName"] = this.pairerGroupName;
        data["relevance"] = this.relevance;
        return data;
    }
}

export interface IMStnPairingRelevanceItemsDTO {
    levelName?: string | undefined;
    pairerId?: number;
    pairerName?: string | undefined;
    pairerGroupName?: string | undefined;
    relevance?: number;
}

export class MultiPairerRowDTO implements IMultiPairerRowDTO {
    name?: string | undefined;
    state?: CollectionState;
    gridFilter?: GridFilterModel;
    validationRules?: PairerDetailValidationRuleDTO[] | undefined;
    id?: number;
    rowVersion?: string | undefined;
    ruleStringChanged?: boolean;

    constructor(data?: IMultiPairerRowDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.state = _data["state"];
            this.gridFilter = _data["gridFilter"] ? GridFilterModel.fromJS(_data["gridFilter"]) : <any>undefined;
            if (Array.isArray(_data["validationRules"])) {
                this.validationRules = [] as any;
                for (let item of _data["validationRules"])
                    this.validationRules!.push(PairerDetailValidationRuleDTO.fromJS(item));
            }
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"];
            this.ruleStringChanged = _data["ruleStringChanged"];
        }
    }

    static fromJS(data: any): MultiPairerRowDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MultiPairerRowDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["state"] = this.state;
        data["gridFilter"] = this.gridFilter ? this.gridFilter.toJSON() : <any>undefined;
        if (Array.isArray(this.validationRules)) {
            data["validationRules"] = [];
            for (let item of this.validationRules)
                data["validationRules"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion;
        data["ruleStringChanged"] = this.ruleStringChanged;
        return data;
    }
}

export interface IMultiPairerRowDTO {
    name?: string | undefined;
    state?: CollectionState;
    gridFilter?: GridFilterModel;
    validationRules?: PairerDetailValidationRuleDTO[] | undefined;
    id?: number;
    rowVersion?: string | undefined;
    ruleStringChanged?: boolean;
}

export class OutputRowDTO implements IOutputRowDTO {
    order?: number | undefined;
    zp?: number | undefined;
    zo?: number | undefined;
    ko?: number | undefined;
    kp?: number | undefined;
    zO_ZP?: number | undefined;
    kO_KP?: number | undefined;
    r?: number | undefined;
    li?: number | undefined;
    d?: number | undefined;
    lvz1?: number | undefined;
    lvzm?: number | undefined;
    lvz2?: number | undefined;
    rowType?: RowType;
    v100?: number | undefined;
    v100max?: number | undefined;
    l100?: number | undefined;
    v100n1?: number | undefined;
    v100n2?: number | undefined;
    v130?: number | undefined;
    v130max?: number | undefined;
    l130?: number | undefined;
    v130n1?: number | undefined;
    v130n2?: number | undefined;
    vk?: number | undefined;
    vkmax?: number | undefined;
    lk?: number | undefined;
    vkn1?: number | undefined;
    vkn2?: number | undefined;
    v150?: number | undefined;
    v150max?: number | undefined;
    l150?: number | undefined;
    v150n1?: number | undefined;
    v150n2?: number | undefined;
    v150ni?: number | undefined;
    v150i?: number | undefined;
    v150deltai?: number | undefined;

    constructor(data?: IOutputRowDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.zp = _data["zp"];
            this.zo = _data["zo"];
            this.ko = _data["ko"];
            this.kp = _data["kp"];
            this.zO_ZP = _data["zO_ZP"];
            this.kO_KP = _data["kO_KP"];
            this.r = _data["r"];
            this.li = _data["li"];
            this.d = _data["d"];
            this.lvz1 = _data["lvz1"];
            this.lvzm = _data["lvzm"];
            this.lvz2 = _data["lvz2"];
            this.rowType = _data["rowType"];
            this.v100 = _data["v100"];
            this.v100max = _data["v100max"];
            this.l100 = _data["l100"];
            this.v100n1 = _data["v100n1"];
            this.v100n2 = _data["v100n2"];
            this.v130 = _data["v130"];
            this.v130max = _data["v130max"];
            this.l130 = _data["l130"];
            this.v130n1 = _data["v130n1"];
            this.v130n2 = _data["v130n2"];
            this.vk = _data["vk"];
            this.vkmax = _data["vkmax"];
            this.lk = _data["lk"];
            this.vkn1 = _data["vkn1"];
            this.vkn2 = _data["vkn2"];
            this.v150 = _data["v150"];
            this.v150max = _data["v150max"];
            this.l150 = _data["l150"];
            this.v150n1 = _data["v150n1"];
            this.v150n2 = _data["v150n2"];
            this.v150ni = _data["v150ni"];
            this.v150i = _data["v150i"];
            this.v150deltai = _data["v150deltai"];
        }
    }

    static fromJS(data: any): OutputRowDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OutputRowDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["zp"] = this.zp;
        data["zo"] = this.zo;
        data["ko"] = this.ko;
        data["kp"] = this.kp;
        data["zO_ZP"] = this.zO_ZP;
        data["kO_KP"] = this.kO_KP;
        data["r"] = this.r;
        data["li"] = this.li;
        data["d"] = this.d;
        data["lvz1"] = this.lvz1;
        data["lvzm"] = this.lvzm;
        data["lvz2"] = this.lvz2;
        data["rowType"] = this.rowType;
        data["v100"] = this.v100;
        data["v100max"] = this.v100max;
        data["l100"] = this.l100;
        data["v100n1"] = this.v100n1;
        data["v100n2"] = this.v100n2;
        data["v130"] = this.v130;
        data["v130max"] = this.v130max;
        data["l130"] = this.l130;
        data["v130n1"] = this.v130n1;
        data["v130n2"] = this.v130n2;
        data["vk"] = this.vk;
        data["vkmax"] = this.vkmax;
        data["lk"] = this.lk;
        data["vkn1"] = this.vkn1;
        data["vkn2"] = this.vkn2;
        data["v150"] = this.v150;
        data["v150max"] = this.v150max;
        data["l150"] = this.l150;
        data["v150n1"] = this.v150n1;
        data["v150n2"] = this.v150n2;
        data["v150ni"] = this.v150ni;
        data["v150i"] = this.v150i;
        data["v150deltai"] = this.v150deltai;
        return data;
    }
}

export interface IOutputRowDTO {
    order?: number | undefined;
    zp?: number | undefined;
    zo?: number | undefined;
    ko?: number | undefined;
    kp?: number | undefined;
    zO_ZP?: number | undefined;
    kO_KP?: number | undefined;
    r?: number | undefined;
    li?: number | undefined;
    d?: number | undefined;
    lvz1?: number | undefined;
    lvzm?: number | undefined;
    lvz2?: number | undefined;
    rowType?: RowType;
    v100?: number | undefined;
    v100max?: number | undefined;
    l100?: number | undefined;
    v100n1?: number | undefined;
    v100n2?: number | undefined;
    v130?: number | undefined;
    v130max?: number | undefined;
    l130?: number | undefined;
    v130n1?: number | undefined;
    v130n2?: number | undefined;
    vk?: number | undefined;
    vkmax?: number | undefined;
    lk?: number | undefined;
    vkn1?: number | undefined;
    vkn2?: number | undefined;
    v150?: number | undefined;
    v150max?: number | undefined;
    l150?: number | undefined;
    v150n1?: number | undefined;
    v150n2?: number | undefined;
    v150ni?: number | undefined;
    v150i?: number | undefined;
    v150deltai?: number | undefined;
}

export class PairerDetailValidationRuleDTO implements IPairerDetailValidationRuleDTO {
    id?: number;
    namePrefix?: string | undefined;
    name?: string | undefined;
    field?: string | undefined;
    rowVersion?: string | undefined;
    isNullable?: boolean;
    dataType?: DataTypeValidation;
    groupId?: number | undefined;
    groupName?: string | undefined;
    groupIndex?: number | undefined;
    serializedString?: string | undefined;
    hasCondition?: boolean;
    condition?: string | undefined;
    isCCI?: boolean;
    decimalPlaces?: number | undefined;
    valueCondition?: ValueConditionModelDTO;
    enumConditions?: ValueConditionEnumerationDTO[] | undefined;

    constructor(data?: IPairerDetailValidationRuleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.namePrefix = _data["namePrefix"];
            this.name = _data["name"];
            this.field = _data["field"];
            this.rowVersion = _data["rowVersion"];
            this.isNullable = _data["isNullable"];
            this.dataType = _data["dataType"];
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            this.groupIndex = _data["groupIndex"];
            this.serializedString = _data["serializedString"];
            this.hasCondition = _data["hasCondition"];
            this.condition = _data["condition"];
            this.isCCI = _data["isCCI"];
            this.decimalPlaces = _data["decimalPlaces"];
            this.valueCondition = _data["valueCondition"] ? ValueConditionModelDTO.fromJS(_data["valueCondition"]) : <any>undefined;
            if (Array.isArray(_data["enumConditions"])) {
                this.enumConditions = [] as any;
                for (let item of _data["enumConditions"])
                    this.enumConditions!.push(ValueConditionEnumerationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PairerDetailValidationRuleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PairerDetailValidationRuleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["namePrefix"] = this.namePrefix;
        data["name"] = this.name;
        data["field"] = this.field;
        data["rowVersion"] = this.rowVersion;
        data["isNullable"] = this.isNullable;
        data["dataType"] = this.dataType;
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        data["groupIndex"] = this.groupIndex;
        data["serializedString"] = this.serializedString;
        data["hasCondition"] = this.hasCondition;
        data["condition"] = this.condition;
        data["isCCI"] = this.isCCI;
        data["decimalPlaces"] = this.decimalPlaces;
        data["valueCondition"] = this.valueCondition ? this.valueCondition.toJSON() : <any>undefined;
        if (Array.isArray(this.enumConditions)) {
            data["enumConditions"] = [];
            for (let item of this.enumConditions)
                data["enumConditions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPairerDetailValidationRuleDTO {
    id?: number;
    namePrefix?: string | undefined;
    name?: string | undefined;
    field?: string | undefined;
    rowVersion?: string | undefined;
    isNullable?: boolean;
    dataType?: DataTypeValidation;
    groupId?: number | undefined;
    groupName?: string | undefined;
    groupIndex?: number | undefined;
    serializedString?: string | undefined;
    hasCondition?: boolean;
    condition?: string | undefined;
    isCCI?: boolean;
    decimalPlaces?: number | undefined;
    valueCondition?: ValueConditionModelDTO;
    enumConditions?: ValueConditionEnumerationDTO[] | undefined;
}

export class PairerDTO implements IPairerDTO {
    id?: number;
    name?: string | undefined;
    filter?: string | undefined;
    groupId?: number;
    rowVersion?: string | undefined;

    constructor(data?: IPairerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.filter = _data["filter"];
            this.groupId = _data["groupId"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): PairerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PairerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["filter"] = this.filter;
        data["groupId"] = this.groupId;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IPairerDTO {
    id?: number;
    name?: string | undefined;
    filter?: string | undefined;
    groupId?: number;
    rowVersion?: string | undefined;
}

export class PairerFullDTO implements IPairerFullDTO {
    id?: number;
    name?: string | undefined;
    filter?: string | undefined;
    groupId?: number;
    levels?: PairerLevelDTO[] | undefined;
    elements?: MStnElementDTO[] | undefined;

    constructor(data?: IPairerFullDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.filter = _data["filter"];
            this.groupId = _data["groupId"];
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(PairerLevelDTO.fromJS(item));
            }
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(MStnElementDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PairerFullDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PairerFullDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["filter"] = this.filter;
        data["groupId"] = this.groupId;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item.toJSON());
        }
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPairerFullDTO {
    id?: number;
    name?: string | undefined;
    filter?: string | undefined;
    groupId?: number;
    levels?: PairerLevelDTO[] | undefined;
    elements?: MStnElementDTO[] | undefined;
}

export class PairerFullTreeDTO implements IPairerFullTreeDTO {
    id?: number;
    name?: string | undefined;
    groupName?: string | undefined;
    validationRules?: ValidationRuleFullTreeDTO[] | undefined;

    constructor(data?: IPairerFullTreeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["validationRules"])) {
                this.validationRules = [] as any;
                for (let item of _data["validationRules"])
                    this.validationRules!.push(ValidationRuleFullTreeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PairerFullTreeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PairerFullTreeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["groupName"] = this.groupName;
        if (Array.isArray(this.validationRules)) {
            data["validationRules"] = [];
            for (let item of this.validationRules)
                data["validationRules"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPairerFullTreeDTO {
    id?: number;
    name?: string | undefined;
    groupName?: string | undefined;
    validationRules?: ValidationRuleFullTreeDTO[] | undefined;
}

export class PairerGroupDTO implements IPairerGroupDTO {
    id?: number;
    name?: string | undefined;
    rowVersion?: string | undefined;
    standardId?: number;

    constructor(data?: IPairerGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.rowVersion = _data["rowVersion"];
            this.standardId = _data["standardId"];
        }
    }

    static fromJS(data: any): PairerGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PairerGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["rowVersion"] = this.rowVersion;
        data["standardId"] = this.standardId;
        return data;
    }
}

export interface IPairerGroupDTO {
    id?: number;
    name?: string | undefined;
    rowVersion?: string | undefined;
    standardId?: number;
}

export class PairerGroupFullDTO implements IPairerGroupFullDTO {
    id?: number;
    name?: string | undefined;
    standardId?: number;
    pairers?: PairerFullDTO[] | undefined;

    constructor(data?: IPairerGroupFullDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.standardId = _data["standardId"];
            if (Array.isArray(_data["pairers"])) {
                this.pairers = [] as any;
                for (let item of _data["pairers"])
                    this.pairers!.push(PairerFullDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PairerGroupFullDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PairerGroupFullDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["standardId"] = this.standardId;
        if (Array.isArray(this.pairers)) {
            data["pairers"] = [];
            for (let item of this.pairers)
                data["pairers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPairerGroupFullDTO {
    id?: number;
    name?: string | undefined;
    standardId?: number;
    pairers?: PairerFullDTO[] | undefined;
}

export class PairerGroupFullTreeDTO implements IPairerGroupFullTreeDTO {
    id?: number;
    name?: string | undefined;
    pairers?: PairerFullTreeDTO[] | undefined;

    constructor(data?: IPairerGroupFullTreeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["pairers"])) {
                this.pairers = [] as any;
                for (let item of _data["pairers"])
                    this.pairers!.push(PairerFullTreeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PairerGroupFullTreeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PairerGroupFullTreeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.pairers)) {
            data["pairers"] = [];
            for (let item of this.pairers)
                data["pairers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPairerGroupFullTreeDTO {
    id?: number;
    name?: string | undefined;
    pairers?: PairerFullTreeDTO[] | undefined;
}

export class PairerLevelDTO implements IPairerLevelDTO {
    pairerId?: number;
    levelName?: string | undefined;
    type?: number;

    constructor(data?: IPairerLevelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pairerId = _data["pairerId"];
            this.levelName = _data["levelName"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): PairerLevelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PairerLevelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pairerId"] = this.pairerId;
        data["levelName"] = this.levelName;
        data["type"] = this.type;
        return data;
    }
}

export interface IPairerLevelDTO {
    pairerId?: number;
    levelName?: string | undefined;
    type?: number;
}

export class PairerValRulesDTO implements IPairerValRulesDTO {
    pairerId?: number;
    pairerGroupId?: number;
    filterItems?: FilterItem[] | undefined;
    validationRules?: ValidationRuleFullTreeDTO[] | undefined;

    constructor(data?: IPairerValRulesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pairerId = _data["pairerId"];
            this.pairerGroupId = _data["pairerGroupId"];
            if (Array.isArray(_data["filterItems"])) {
                this.filterItems = [] as any;
                for (let item of _data["filterItems"])
                    this.filterItems!.push(FilterItem.fromJS(item));
            }
            if (Array.isArray(_data["validationRules"])) {
                this.validationRules = [] as any;
                for (let item of _data["validationRules"])
                    this.validationRules!.push(ValidationRuleFullTreeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PairerValRulesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PairerValRulesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pairerId"] = this.pairerId;
        data["pairerGroupId"] = this.pairerGroupId;
        if (Array.isArray(this.filterItems)) {
            data["filterItems"] = [];
            for (let item of this.filterItems)
                data["filterItems"].push(item.toJSON());
        }
        if (Array.isArray(this.validationRules)) {
            data["validationRules"] = [];
            for (let item of this.validationRules)
                data["validationRules"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPairerValRulesDTO {
    pairerId?: number;
    pairerGroupId?: number;
    filterItems?: FilterItem[] | undefined;
    validationRules?: ValidationRuleFullTreeDTO[] | undefined;
}

export class Point3dServer implements IPoint3dServer {
    x?: number;
    y?: number;
    z?: number;

    constructor(data?: IPoint3dServer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
        }
    }

    static fromJS(data: any): Point3dServer {
        data = typeof data === 'object' ? data : {};
        let result = new Point3dServer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        return data;
    }
}

export interface IPoint3dServer {
    x?: number;
    y?: number;
    z?: number;
}

export class ProjectDataDTO implements IProjectDataDTO {
    projectName?: string | undefined;
    description?: string | undefined;
    projectManager?: string | undefined;
    authorizedPersons?: string | undefined;
    otherFeatures?: string | undefined;
    projectType?: ProjectType;

    constructor(data?: IProjectDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectName = _data["projectName"];
            this.description = _data["description"];
            this.projectManager = _data["projectManager"];
            this.authorizedPersons = _data["authorizedPersons"];
            this.otherFeatures = _data["otherFeatures"];
            this.projectType = _data["projectType"];
        }
    }

    static fromJS(data: any): ProjectDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["description"] = this.description;
        data["projectManager"] = this.projectManager;
        data["authorizedPersons"] = this.authorizedPersons;
        data["otherFeatures"] = this.otherFeatures;
        data["projectType"] = this.projectType;
        return data;
    }
}

export interface IProjectDataDTO {
    projectName?: string | undefined;
    description?: string | undefined;
    projectManager?: string | undefined;
    authorizedPersons?: string | undefined;
    otherFeatures?: string | undefined;
    projectType?: ProjectType;
}

export class ProjectDTO implements IProjectDTO {
    id?: number;
    name?: string | undefined;
    type?: ProjectType;

    constructor(data?: IProjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ProjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface IProjectDTO {
    id?: number;
    name?: string | undefined;
    type?: ProjectType;
}

export enum ProjectType {
    None = "None",
    Road = "Road",
    Railway = "Railway",
    RoadBridge = "RoadBridge",
    RailwayBridge = "RailwayBridge",
}

export class Property implements IProperty {
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Property {
        data = typeof data === 'object' ? data : {};
        let result = new Property();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IProperty {
    name?: string | undefined;
    value?: string | undefined;
}

export class PropertySet implements IPropertySet {
    name?: string | undefined;
    properties?: Property[] | undefined;

    constructor(data?: IPropertySet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(Property.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertySet {
        data = typeof data === 'object' ? data : {};
        let result = new PropertySet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPropertySet {
    name?: string | undefined;
    properties?: Property[] | undefined;
}

export class RefreshTokenRequest implements IRefreshTokenRequest {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;

    constructor(data?: IRefreshTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshTokenRequest {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
}

export class RefreshTokenResponse implements IRefreshTokenResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expireAt?: Date;

    constructor(data?: IRefreshTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.expireAt = _data["expireAt"] ? new Date(_data["expireAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RefreshTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["expireAt"] = this.expireAt ? this.expireAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRefreshTokenResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expireAt?: Date;
}

export class RemoveUserFromTenantRequest implements IRemoveUserFromTenantRequest {
    userId?: number;
    tenantId?: number;

    constructor(data?: IRemoveUserFromTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): RemoveUserFromTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveUserFromTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IRemoveUserFromTenantRequest {
    userId?: number;
    tenantId?: number;
}

export class RemoveUserFromTenantResponse implements IRemoveUserFromTenantResponse {
    ok?: boolean;

    constructor(data?: IRemoveUserFromTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): RemoveUserFromTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveUserFromTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IRemoveUserFromTenantResponse {
    ok?: boolean;
}

export class RenameTenantRequest implements IRenameTenantRequest {
    tenantId?: number;
    name?: string | undefined;

    constructor(data?: IRenameTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RenameTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RenameTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        return data;
    }
}

export interface IRenameTenantRequest {
    tenantId?: number;
    name?: string | undefined;
}

export class RenameTenantResponse implements IRenameTenantResponse {
    ok?: boolean;

    constructor(data?: IRenameTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): RenameTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RenameTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IRenameTenantResponse {
    ok?: boolean;
}

export class ResetPasswordUserRequest implements IResetPasswordUserRequest {
    id?: number;

    constructor(data?: IResetPasswordUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ResetPasswordUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IResetPasswordUserRequest {
    id?: number;
}

export class ResetPasswordUserResponse implements IResetPasswordUserResponse {
    ok?: boolean;
    newPassword?: string | undefined;

    constructor(data?: IResetPasswordUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IResetPasswordUserResponse {
    ok?: boolean;
    newPassword?: string | undefined;
}

export class ResetUserPasswordSendMailResponse implements IResetUserPasswordSendMailResponse {
    ok?: boolean;
    msLogin?: boolean;

    constructor(data?: IResetUserPasswordSendMailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.msLogin = _data["msLogin"];
        }
    }

    static fromJS(data: any): ResetUserPasswordSendMailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetUserPasswordSendMailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["msLogin"] = this.msLogin;
        return data;
    }
}

export interface IResetUserPasswordSendMailResponse {
    ok?: boolean;
    msLogin?: boolean;
}

export class ResultStatsDTO implements IResultStatsDTO {
    expressId?: number;
    modelId?: string | undefined;
    ok?: boolean;
    error?: boolean;
    warning?: boolean;

    constructor(data?: IResultStatsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressId = _data["expressId"];
            this.modelId = _data["modelId"];
            this.ok = _data["ok"];
            this.error = _data["error"];
            this.warning = _data["warning"];
        }
    }

    static fromJS(data: any): ResultStatsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResultStatsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expressId"] = this.expressId;
        data["modelId"] = this.modelId;
        data["ok"] = this.ok;
        data["error"] = this.error;
        data["warning"] = this.warning;
        return data;
    }
}

export interface IResultStatsDTO {
    expressId?: number;
    modelId?: string | undefined;
    ok?: boolean;
    error?: boolean;
    warning?: boolean;
}

export class RouteDTO implements IRouteDTO {
    id?: number;
    name?: string | undefined;
    state?: number;

    constructor(data?: IRouteDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): RouteDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RouteDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["state"] = this.state;
        return data;
    }
}

export interface IRouteDTO {
    id?: number;
    name?: string | undefined;
    state?: number;
}

export enum RowType {
    Curve = "Curve",
    Inflexion = "Inflexion",
    Intermediate = "Intermediate",
}

export class SaveBlobToUpdateRequest implements ISaveBlobToUpdateRequest {
    updateId?: number;
    password?: string | undefined;

    constructor(data?: ISaveBlobToUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updateId = _data["updateId"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): SaveBlobToUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBlobToUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateId"] = this.updateId;
        data["password"] = this.password;
        return data;
    }
}

export interface ISaveBlobToUpdateRequest {
    updateId?: number;
    password?: string | undefined;
}

export class SaveMultiPairerRequest implements ISaveMultiPairerRequest {
    deletedIds?: number[] | undefined;
    pairers?: MultiPairerRowDTO[] | undefined;
    groupId?: number;

    constructor(data?: ISaveMultiPairerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deletedIds"])) {
                this.deletedIds = [] as any;
                for (let item of _data["deletedIds"])
                    this.deletedIds!.push(item);
            }
            if (Array.isArray(_data["pairers"])) {
                this.pairers = [] as any;
                for (let item of _data["pairers"])
                    this.pairers!.push(MultiPairerRowDTO.fromJS(item));
            }
            this.groupId = _data["groupId"];
        }
    }

    static fromJS(data: any): SaveMultiPairerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMultiPairerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deletedIds)) {
            data["deletedIds"] = [];
            for (let item of this.deletedIds)
                data["deletedIds"].push(item);
        }
        if (Array.isArray(this.pairers)) {
            data["pairers"] = [];
            for (let item of this.pairers)
                data["pairers"].push(item.toJSON());
        }
        data["groupId"] = this.groupId;
        return data;
    }
}

export interface ISaveMultiPairerRequest {
    deletedIds?: number[] | undefined;
    pairers?: MultiPairerRowDTO[] | undefined;
    groupId?: number;
}

export class SaveMultiPairerResponse implements ISaveMultiPairerResponse {
    pairers?: PairerDTO[] | undefined;
    ok?: boolean;

    constructor(data?: ISaveMultiPairerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pairers"])) {
                this.pairers = [] as any;
                for (let item of _data["pairers"])
                    this.pairers!.push(PairerDTO.fromJS(item));
            }
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SaveMultiPairerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMultiPairerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairers)) {
            data["pairers"] = [];
            for (let item of this.pairers)
                data["pairers"].push(item.toJSON());
        }
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISaveMultiPairerResponse {
    pairers?: PairerDTO[] | undefined;
    ok?: boolean;
}

export class SaveUserDataRequest implements ISaveUserDataRequest {
    id?: number;
    name?: string | undefined;
    surname?: string | undefined;
    isAdmin?: boolean;
    canCreateUsers?: boolean;
    canCreateTenant?: boolean;

    constructor(data?: ISaveUserDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.isAdmin = _data["isAdmin"];
            this.canCreateUsers = _data["canCreateUsers"];
            this.canCreateTenant = _data["canCreateTenant"];
        }
    }

    static fromJS(data: any): SaveUserDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["isAdmin"] = this.isAdmin;
        data["canCreateUsers"] = this.canCreateUsers;
        data["canCreateTenant"] = this.canCreateTenant;
        return data;
    }
}

export interface ISaveUserDataRequest {
    id?: number;
    name?: string | undefined;
    surname?: string | undefined;
    isAdmin?: boolean;
    canCreateUsers?: boolean;
    canCreateTenant?: boolean;
}

export class SaveUserDataResponse implements ISaveUserDataResponse {
    ok?: boolean;

    constructor(data?: ISaveUserDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SaveUserDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISaveUserDataResponse {
    ok?: boolean;
}

export class SelectorItemDTO implements ISelectorItemDTO {
    id?: number;
    label?: string | undefined;

    constructor(data?: ISelectorItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): SelectorItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SelectorItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        return data;
    }
}

export interface ISelectorItemDTO {
    id?: number;
    label?: string | undefined;
}

export class SelectorListDTO implements ISelectorListDTO {
    id?: number;
    label?: string | undefined;
    type?: SelectorType;
    options?: SelectorOptionDTO;

    constructor(data?: ISelectorListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.type = _data["type"];
            this.options = _data["options"] ? SelectorOptionDTO.fromJS(_data["options"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SelectorListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SelectorListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["type"] = this.type;
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISelectorListDTO {
    id?: number;
    label?: string | undefined;
    type?: SelectorType;
    options?: SelectorOptionDTO;
}

export class SelectorOptionDTO implements ISelectorOptionDTO {
    dataType?: DataTypeValidation;

    constructor(data?: ISelectorOptionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataType = _data["dataType"];
        }
    }

    static fromJS(data: any): SelectorOptionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SelectorOptionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataType"] = this.dataType;
        return data;
    }
}

export interface ISelectorOptionDTO {
    dataType?: DataTypeValidation;
}

export enum SelectorType {
    Enumerations = "Enumerations",
}

export class SetUserPasswordResponse implements ISetUserPasswordResponse {
    ok?: boolean;
    email?: string | undefined;

    constructor(data?: ISetUserPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SetUserPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["email"] = this.email;
        return data;
    }
}

export interface ISetUserPasswordResponse {
    ok?: boolean;
    email?: string | undefined;
}

export enum SGProductType {
    Updater = "Updater",
    PowerTools = "PowerTools",
    OpenTools = "OpenTools",
    Bimloader = "Bimloader",
}

export class SignupMicrosoftRequest implements ISignupMicrosoftRequest {
    tenant?: string | undefined;
    token?: string | undefined;

    constructor(data?: ISignupMicrosoftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenant = _data["tenant"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): SignupMicrosoftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignupMicrosoftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant;
        data["token"] = this.token;
        return data;
    }
}

export interface ISignupMicrosoftRequest {
    tenant?: string | undefined;
    token?: string | undefined;
}

export class SignupResponse implements ISignupResponse {
    id?: number;
    microsoftId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenants?: TenantLoginDTO[] | undefined;

    constructor(data?: ISignupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.microsoftId = _data["microsoftId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.token = _data["token"];
            this.tokenExpiration = _data["tokenExpiration"] ? new Date(_data["tokenExpiration"].toString()) : <any>undefined;
            this.refreshToken = _data["refreshToken"];
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantLoginDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SignupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SignupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["microsoftId"] = this.microsoftId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["token"] = this.token;
        data["tokenExpiration"] = this.tokenExpiration ? this.tokenExpiration.toISOString() : <any>undefined;
        data["refreshToken"] = this.refreshToken;
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISignupResponse {
    id?: number;
    microsoftId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenants?: TenantLoginDTO[] | undefined;
}

export class SignupUserMicrosoftRequest implements ISignupUserMicrosoftRequest {
    userId?: number;
    msToken?: string | undefined;
    signupToken?: string | undefined;

    constructor(data?: ISignupUserMicrosoftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.msToken = _data["msToken"];
            this.signupToken = _data["signupToken"];
        }
    }

    static fromJS(data: any): SignupUserMicrosoftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignupUserMicrosoftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["msToken"] = this.msToken;
        data["signupToken"] = this.signupToken;
        return data;
    }
}

export interface ISignupUserMicrosoftRequest {
    userId?: number;
    msToken?: string | undefined;
    signupToken?: string | undefined;
}

export class SignupUserMicrosoftResponse implements ISignupUserMicrosoftResponse {
    ok?: boolean;

    constructor(data?: ISignupUserMicrosoftResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SignupUserMicrosoftResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SignupUserMicrosoftResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISignupUserMicrosoftResponse {
    ok?: boolean;
}

export class TenantDTO implements ITenantDTO {
    id?: number;
    name?: string | undefined;
    users?: TenantUserDTO[] | undefined;

    constructor(data?: ITenantDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(TenantUserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITenantDTO {
    id?: number;
    name?: string | undefined;
    users?: TenantUserDTO[] | undefined;
}

export class TenantListDTO implements ITenantListDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: ITenantListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITenantListDTO {
    id?: number;
    name?: string | undefined;
}

export class TenantLoginDTO implements ITenantLoginDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: ITenantLoginDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITenantLoginDTO {
    id?: number;
    name?: string | undefined;
}

export class TenantUserDTO implements ITenantUserDTO {
    id?: number;
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    isAdmin?: boolean;
    canCreateUsers?: boolean;
    canCreateTenants?: boolean;
    identityProvider?: string | undefined;

    constructor(data?: ITenantUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.isAdmin = _data["isAdmin"];
            this.canCreateUsers = _data["canCreateUsers"];
            this.canCreateTenants = _data["canCreateTenants"];
            this.identityProvider = _data["identityProvider"];
        }
    }

    static fromJS(data: any): TenantUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["isAdmin"] = this.isAdmin;
        data["canCreateUsers"] = this.canCreateUsers;
        data["canCreateTenants"] = this.canCreateTenants;
        data["identityProvider"] = this.identityProvider;
        return data;
    }
}

export interface ITenantUserDTO {
    id?: number;
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    isAdmin?: boolean;
    canCreateUsers?: boolean;
    canCreateTenants?: boolean;
    identityProvider?: string | undefined;
}

export class TestVideoValidationSlopeRequest implements ITestVideoValidationSlopeRequest {

    constructor(data?: ITestVideoValidationSlopeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): TestVideoValidationSlopeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TestVideoValidationSlopeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITestVideoValidationSlopeRequest {
}

export class TiltValidationLine implements ITiltValidationLine {
    tiltValidationLineParts?: TiltValidationLinePart[] | undefined;
    perpendiculars?: TiltValidationLinePart[] | undefined;

    constructor(data?: ITiltValidationLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tiltValidationLineParts"])) {
                this.tiltValidationLineParts = [] as any;
                for (let item of _data["tiltValidationLineParts"])
                    this.tiltValidationLineParts!.push(TiltValidationLinePart.fromJS(item));
            }
            if (Array.isArray(_data["perpendiculars"])) {
                this.perpendiculars = [] as any;
                for (let item of _data["perpendiculars"])
                    this.perpendiculars!.push(TiltValidationLinePart.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TiltValidationLine {
        data = typeof data === 'object' ? data : {};
        let result = new TiltValidationLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tiltValidationLineParts)) {
            data["tiltValidationLineParts"] = [];
            for (let item of this.tiltValidationLineParts)
                data["tiltValidationLineParts"].push(item.toJSON());
        }
        if (Array.isArray(this.perpendiculars)) {
            data["perpendiculars"] = [];
            for (let item of this.perpendiculars)
                data["perpendiculars"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITiltValidationLine {
    tiltValidationLineParts?: TiltValidationLinePart[] | undefined;
    perpendiculars?: TiltValidationLinePart[] | undefined;
}

export class TiltValidationLinePart implements ITiltValidationLinePart {
    entityType?: ValidationDesignEntityType;
    startPoint?: Point3dServer;
    endPoint?: Point3dServer;
    perpendicularPointLeft?: Point3dServer;
    perpendicularPointRight?: Point3dServer;
    perpendicularCrossId?: string | undefined;

    constructor(data?: ITiltValidationLinePart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.startPoint = _data["startPoint"] ? Point3dServer.fromJS(_data["startPoint"]) : <any>undefined;
            this.endPoint = _data["endPoint"] ? Point3dServer.fromJS(_data["endPoint"]) : <any>undefined;
            this.perpendicularPointLeft = _data["perpendicularPointLeft"] ? Point3dServer.fromJS(_data["perpendicularPointLeft"]) : <any>undefined;
            this.perpendicularPointRight = _data["perpendicularPointRight"] ? Point3dServer.fromJS(_data["perpendicularPointRight"]) : <any>undefined;
            this.perpendicularCrossId = _data["perpendicularCrossId"];
        }
    }

    static fromJS(data: any): TiltValidationLinePart {
        data = typeof data === 'object' ? data : {};
        let result = new TiltValidationLinePart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["startPoint"] = this.startPoint ? this.startPoint.toJSON() : <any>undefined;
        data["endPoint"] = this.endPoint ? this.endPoint.toJSON() : <any>undefined;
        data["perpendicularPointLeft"] = this.perpendicularPointLeft ? this.perpendicularPointLeft.toJSON() : <any>undefined;
        data["perpendicularPointRight"] = this.perpendicularPointRight ? this.perpendicularPointRight.toJSON() : <any>undefined;
        data["perpendicularCrossId"] = this.perpendicularCrossId;
        return data;
    }
}

export interface ITiltValidationLinePart {
    entityType?: ValidationDesignEntityType;
    startPoint?: Point3dServer;
    endPoint?: Point3dServer;
    perpendicularPointLeft?: Point3dServer;
    perpendicularPointRight?: Point3dServer;
    perpendicularCrossId?: string | undefined;
}

export class TiltValidationPluginResponse implements ITiltValidationPluginResponse {
    data?: ValidationDesignSlopeResponse;

    constructor(data?: ITiltValidationPluginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ValidationDesignSlopeResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TiltValidationPluginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TiltValidationPluginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITiltValidationPluginResponse {
    data?: ValidationDesignSlopeResponse;
}

export class TiltValidationResponse implements ITiltValidationResponse {
    tiltId?: number;
    tiltName?: string | undefined;
    projectId?: number;
    projectName?: string | undefined;
    polyLine?: TiltValidationLine;
    polyLine2?: TiltValidationLine;
    hectos?: ValidationDesignHectoServer[] | undefined;
    gridLines?: ValidationDesignDataGridSectionDTO[] | undefined;

    constructor(data?: ITiltValidationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tiltId = _data["tiltId"];
            this.tiltName = _data["tiltName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.polyLine = _data["polyLine"] ? TiltValidationLine.fromJS(_data["polyLine"]) : <any>undefined;
            this.polyLine2 = _data["polyLine2"] ? TiltValidationLine.fromJS(_data["polyLine2"]) : <any>undefined;
            if (Array.isArray(_data["hectos"])) {
                this.hectos = [] as any;
                for (let item of _data["hectos"])
                    this.hectos!.push(ValidationDesignHectoServer.fromJS(item));
            }
            if (Array.isArray(_data["gridLines"])) {
                this.gridLines = [] as any;
                for (let item of _data["gridLines"])
                    this.gridLines!.push(ValidationDesignDataGridSectionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TiltValidationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TiltValidationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tiltId"] = this.tiltId;
        data["tiltName"] = this.tiltName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["polyLine"] = this.polyLine ? this.polyLine.toJSON() : <any>undefined;
        data["polyLine2"] = this.polyLine2 ? this.polyLine2.toJSON() : <any>undefined;
        if (Array.isArray(this.hectos)) {
            data["hectos"] = [];
            for (let item of this.hectos)
                data["hectos"].push(item.toJSON());
        }
        if (Array.isArray(this.gridLines)) {
            data["gridLines"] = [];
            for (let item of this.gridLines)
                data["gridLines"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITiltValidationResponse {
    tiltId?: number;
    tiltName?: string | undefined;
    projectId?: number;
    projectName?: string | undefined;
    polyLine?: TiltValidationLine;
    polyLine2?: TiltValidationLine;
    hectos?: ValidationDesignHectoServer[] | undefined;
    gridLines?: ValidationDesignDataGridSectionDTO[] | undefined;
}

export class TiltValidationVersionResponse implements ITiltValidationVersionResponse {
    tiltId?: number;
    tiltName?: string | undefined;
    projectId?: number;
    projectName?: string | undefined;
    polyLine?: TiltValidationLine;
    polyLine2?: TiltValidationLine;
    hectos?: ValidationDesignHectoServer[] | undefined;
    gridLines?: ValidationDesignDataGridSectionDTO[] | undefined;

    constructor(data?: ITiltValidationVersionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tiltId = _data["tiltId"];
            this.tiltName = _data["tiltName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.polyLine = _data["polyLine"] ? TiltValidationLine.fromJS(_data["polyLine"]) : <any>undefined;
            this.polyLine2 = _data["polyLine2"] ? TiltValidationLine.fromJS(_data["polyLine2"]) : <any>undefined;
            if (Array.isArray(_data["hectos"])) {
                this.hectos = [] as any;
                for (let item of _data["hectos"])
                    this.hectos!.push(ValidationDesignHectoServer.fromJS(item));
            }
            if (Array.isArray(_data["gridLines"])) {
                this.gridLines = [] as any;
                for (let item of _data["gridLines"])
                    this.gridLines!.push(ValidationDesignDataGridSectionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TiltValidationVersionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TiltValidationVersionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tiltId"] = this.tiltId;
        data["tiltName"] = this.tiltName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["polyLine"] = this.polyLine ? this.polyLine.toJSON() : <any>undefined;
        data["polyLine2"] = this.polyLine2 ? this.polyLine2.toJSON() : <any>undefined;
        if (Array.isArray(this.hectos)) {
            data["hectos"] = [];
            for (let item of this.hectos)
                data["hectos"].push(item.toJSON());
        }
        if (Array.isArray(this.gridLines)) {
            data["gridLines"] = [];
            for (let item of this.gridLines)
                data["gridLines"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITiltValidationVersionResponse {
    tiltId?: number;
    tiltName?: string | undefined;
    projectId?: number;
    projectName?: string | undefined;
    polyLine?: TiltValidationLine;
    polyLine2?: TiltValidationLine;
    hectos?: ValidationDesignHectoServer[] | undefined;
    gridLines?: ValidationDesignDataGridSectionDTO[] | undefined;
}

export class UncheckedElementDTO implements IUncheckedElementDTO {
    expressId?: number;
    modelId?: string | undefined;

    constructor(data?: IUncheckedElementDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressId = _data["expressId"];
            this.modelId = _data["modelId"];
        }
    }

    static fromJS(data: any): UncheckedElementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UncheckedElementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expressId"] = this.expressId;
        data["modelId"] = this.modelId;
        return data;
    }
}

export interface IUncheckedElementDTO {
    expressId?: number;
    modelId?: string | undefined;
}

export class Unit implements IUnit {

    constructor(data?: IUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Unit {
        data = typeof data === 'object' ? data : {};
        let result = new Unit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUnit {
}

export class UpdateDataStandardRequest implements IUpdateDataStandardRequest {
    id?: number;
    name?: string | undefined;
    classifierName?: string | undefined;
    timestamp?: string | undefined;
    stage?: DocumentationStage;

    constructor(data?: IUpdateDataStandardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.classifierName = _data["classifierName"];
            this.timestamp = _data["timestamp"];
            this.stage = _data["stage"];
        }
    }

    static fromJS(data: any): UpdateDataStandardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataStandardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["classifierName"] = this.classifierName;
        data["timestamp"] = this.timestamp;
        data["stage"] = this.stage;
        return data;
    }
}

export interface IUpdateDataStandardRequest {
    id?: number;
    name?: string | undefined;
    classifierName?: string | undefined;
    timestamp?: string | undefined;
    stage?: DocumentationStage;
}

export class UpdateDataStandardResponse implements IUpdateDataStandardResponse {
    ok?: boolean;
    isConcurrency?: boolean;
    newTimestamp?: string | undefined;
    dataStandard?: DataStandardDTO;

    constructor(data?: IUpdateDataStandardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.isConcurrency = _data["isConcurrency"];
            this.newTimestamp = _data["newTimestamp"];
            this.dataStandard = _data["dataStandard"] ? DataStandardDTO.fromJS(_data["dataStandard"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateDataStandardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataStandardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["isConcurrency"] = this.isConcurrency;
        data["newTimestamp"] = this.newTimestamp;
        data["dataStandard"] = this.dataStandard ? this.dataStandard.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateDataStandardResponse {
    ok?: boolean;
    isConcurrency?: boolean;
    newTimestamp?: string | undefined;
    dataStandard?: DataStandardDTO;
}

export class UpdateGroupForStandardRequest implements IUpdateGroupForStandardRequest {
    groupId?: number;
    name?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IUpdateGroupForStandardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.name = _data["name"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): UpdateGroupForStandardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGroupForStandardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["name"] = this.name;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IUpdateGroupForStandardRequest {
    groupId?: number;
    name?: string | undefined;
    rowVersion?: string | undefined;
}

export class UpdateInfoResponse implements IUpdateInfoResponse {
    version?: string | undefined;
    updateUri?: string | undefined;
    updateId?: number;

    constructor(data?: IUpdateInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.updateUri = _data["updateUri"];
            this.updateId = _data["updateId"];
        }
    }

    static fromJS(data: any): UpdateInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["updateUri"] = this.updateUri;
        data["updateId"] = this.updateId;
        return data;
    }
}

export interface IUpdateInfoResponse {
    version?: string | undefined;
    updateUri?: string | undefined;
    updateId?: number;
}

export class UpdateMicrostationPairingRequest implements IUpdateMicrostationPairingRequest {
    id?: number;
    projectId?: number;
    name?: string | undefined;

    constructor(data?: IUpdateMicrostationPairingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateMicrostationPairingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMicrostationPairingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateMicrostationPairingRequest {
    id?: number;
    projectId?: number;
    name?: string | undefined;
}

export class UpdateMicrostationPairingResponse implements IUpdateMicrostationPairingResponse {
    ok?: boolean;

    constructor(data?: IUpdateMicrostationPairingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateMicrostationPairingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMicrostationPairingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateMicrostationPairingResponse {
    ok?: boolean;
}

export class UpdateMStnFeederAutoValuesRequest implements IUpdateMStnFeederAutoValuesRequest {
    mStnPairingId?: number;
    feederAutoValues?: MStnFeederAutoValueDTO[] | undefined;

    constructor(data?: IUpdateMStnFeederAutoValuesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            if (Array.isArray(_data["feederAutoValues"])) {
                this.feederAutoValues = [] as any;
                for (let item of _data["feederAutoValues"])
                    this.feederAutoValues!.push(MStnFeederAutoValueDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateMStnFeederAutoValuesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederAutoValuesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        if (Array.isArray(this.feederAutoValues)) {
            data["feederAutoValues"] = [];
            for (let item of this.feederAutoValues)
                data["feederAutoValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateMStnFeederAutoValuesRequest {
    mStnPairingId?: number;
    feederAutoValues?: MStnFeederAutoValueDTO[] | undefined;
}

export class UpdateMStnFeederAutoValuesResponse implements IUpdateMStnFeederAutoValuesResponse {
    ok?: boolean;

    constructor(data?: IUpdateMStnFeederAutoValuesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateMStnFeederAutoValuesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederAutoValuesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateMStnFeederAutoValuesResponse {
    ok?: boolean;
}

export class UpdateMStnFeederFromDGNRequest implements IUpdateMStnFeederFromDGNRequest {
    mStnPairingId?: number;
    feederItems?: MStnFeederFromDGNDTO[] | undefined;

    constructor(data?: IUpdateMStnFeederFromDGNRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            if (Array.isArray(_data["feederItems"])) {
                this.feederItems = [] as any;
                for (let item of _data["feederItems"])
                    this.feederItems!.push(MStnFeederFromDGNDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateMStnFeederFromDGNRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederFromDGNRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        if (Array.isArray(this.feederItems)) {
            data["feederItems"] = [];
            for (let item of this.feederItems)
                data["feederItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateMStnFeederFromDGNRequest {
    mStnPairingId?: number;
    feederItems?: MStnFeederFromDGNDTO[] | undefined;
}

export class UpdateMStnFeederFromDGNResponse implements IUpdateMStnFeederFromDGNResponse {
    ok?: boolean;

    constructor(data?: IUpdateMStnFeederFromDGNResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateMStnFeederFromDGNResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederFromDGNResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateMStnFeederFromDGNResponse {
    ok?: boolean;
}

export class UpdateMStnFeederItemsRequest implements IUpdateMStnFeederItemsRequest {
    ids?: number[] | undefined;
    value?: string | undefined;
    overwrite?: boolean;
    isLocked?: boolean;
    autoValueType?: FeederAutoValueType;
    stringValueType?: FeederStringValueType;
    autoValueState?: FeederAutoValueState;
    autoValue?: string | undefined;

    constructor(data?: IUpdateMStnFeederItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.value = _data["value"];
            this.overwrite = _data["overwrite"];
            this.isLocked = _data["isLocked"];
            this.autoValueType = _data["autoValueType"];
            this.stringValueType = _data["stringValueType"];
            this.autoValueState = _data["autoValueState"];
            this.autoValue = _data["autoValue"];
        }
    }

    static fromJS(data: any): UpdateMStnFeederItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["value"] = this.value;
        data["overwrite"] = this.overwrite;
        data["isLocked"] = this.isLocked;
        data["autoValueType"] = this.autoValueType;
        data["stringValueType"] = this.stringValueType;
        data["autoValueState"] = this.autoValueState;
        data["autoValue"] = this.autoValue;
        return data;
    }
}

export interface IUpdateMStnFeederItemsRequest {
    ids?: number[] | undefined;
    value?: string | undefined;
    overwrite?: boolean;
    isLocked?: boolean;
    autoValueType?: FeederAutoValueType;
    stringValueType?: FeederStringValueType;
    autoValueState?: FeederAutoValueState;
    autoValue?: string | undefined;
}

export class UpdateMStnFeederItemsResponse implements IUpdateMStnFeederItemsResponse {
    ok?: boolean;

    constructor(data?: IUpdateMStnFeederItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateMStnFeederItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateMStnFeederItemsResponse {
    ok?: boolean;
}

export class UpdateOrGroupRequest implements IUpdateOrGroupRequest {
    id?: number;
    name?: string | undefined;

    constructor(data?: IUpdateOrGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateOrGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateOrGroupRequest {
    id?: number;
    name?: string | undefined;
}

export class UpdateOrGroupResponse implements IUpdateOrGroupResponse {
    ok?: boolean;

    constructor(data?: IUpdateOrGroupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateOrGroupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrGroupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateOrGroupResponse {
    ok?: boolean;
}

export class UpdatePairerRequest implements IUpdatePairerRequest {
    id?: number;
    name?: string | undefined;
    filter?: string | undefined;
    groupId?: number;
    rowVersion?: string | undefined;

    constructor(data?: IUpdatePairerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.filter = _data["filter"];
            this.groupId = _data["groupId"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): UpdatePairerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePairerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["filter"] = this.filter;
        data["groupId"] = this.groupId;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IUpdatePairerRequest {
    id?: number;
    name?: string | undefined;
    filter?: string | undefined;
    groupId?: number;
    rowVersion?: string | undefined;
}

export class UpdateProjectDataRequest implements IUpdateProjectDataRequest {
    projectId?: number;
    projectName?: string | undefined;
    description?: string | undefined;
    projectManager?: string | undefined;
    authorizedPersons?: string | undefined;
    otherFeatures?: string | undefined;

    constructor(data?: IUpdateProjectDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.description = _data["description"];
            this.projectManager = _data["projectManager"];
            this.authorizedPersons = _data["authorizedPersons"];
            this.otherFeatures = _data["otherFeatures"];
        }
    }

    static fromJS(data: any): UpdateProjectDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["description"] = this.description;
        data["projectManager"] = this.projectManager;
        data["authorizedPersons"] = this.authorizedPersons;
        data["otherFeatures"] = this.otherFeatures;
        return data;
    }
}

export interface IUpdateProjectDataRequest {
    projectId?: number;
    projectName?: string | undefined;
    description?: string | undefined;
    projectManager?: string | undefined;
    authorizedPersons?: string | undefined;
    otherFeatures?: string | undefined;
}

export class UpdateProjectDataResponse implements IUpdateProjectDataResponse {
    ok?: boolean;

    constructor(data?: IUpdateProjectDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateProjectDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateProjectDataResponse {
    ok?: boolean;
}

export class UpdateProjectRequest implements IUpdateProjectRequest {
    id?: number;
    name?: string | undefined;
    type?: number;

    constructor(data?: IUpdateProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): UpdateProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface IUpdateProjectRequest {
    id?: number;
    name?: string | undefined;
    type?: number;
}

export class UpdateProjectResponse implements IUpdateProjectResponse {
    ok?: boolean;

    constructor(data?: IUpdateProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateProjectResponse {
    ok?: boolean;
}

export class UpdateResponse implements IUpdateResponse {
    ok?: boolean;
    isConcurrency?: boolean;
    newTimestamp?: string | undefined;

    constructor(data?: IUpdateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.isConcurrency = _data["isConcurrency"];
            this.newTimestamp = _data["newTimestamp"];
        }
    }

    static fromJS(data: any): UpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["isConcurrency"] = this.isConcurrency;
        data["newTimestamp"] = this.newTimestamp;
        return data;
    }
}

export interface IUpdateResponse {
    ok?: boolean;
    isConcurrency?: boolean;
    newTimestamp?: string | undefined;
}

export class UpdateRouteRequest implements IUpdateRouteRequest {
    id?: number;
    name?: string | undefined;
    state?: number;

    constructor(data?: IUpdateRouteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): UpdateRouteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRouteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["state"] = this.state;
        return data;
    }
}

export interface IUpdateRouteRequest {
    id?: number;
    name?: string | undefined;
    state?: number;
}

export class UpdateRouteResponse implements IUpdateRouteResponse {
    ok?: boolean;

    constructor(data?: IUpdateRouteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateRouteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRouteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateRouteResponse {
    ok?: boolean;
}

export class UpdateValidationsRuleRequest implements IUpdateValidationsRuleRequest {
    id?: number;
    namePrefix?: string | undefined;
    name?: string | undefined;
    field?: string | undefined;
    nullable?: boolean;
    isCCI?: boolean;
    decimalPlaces?: number | undefined;
    condition?: string | undefined;
    valueCondition?: ValueConditionModelDTO;
    dataType?: DataTypeValidation;
    enumConditions?: ValueConditionEnumerationDTO[] | undefined;
    timestamp?: string | undefined;

    constructor(data?: IUpdateValidationsRuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.namePrefix = _data["namePrefix"];
            this.name = _data["name"];
            this.field = _data["field"];
            this.nullable = _data["nullable"];
            this.isCCI = _data["isCCI"];
            this.decimalPlaces = _data["decimalPlaces"];
            this.condition = _data["condition"];
            this.valueCondition = _data["valueCondition"] ? ValueConditionModelDTO.fromJS(_data["valueCondition"]) : <any>undefined;
            this.dataType = _data["dataType"];
            if (Array.isArray(_data["enumConditions"])) {
                this.enumConditions = [] as any;
                for (let item of _data["enumConditions"])
                    this.enumConditions!.push(ValueConditionEnumerationDTO.fromJS(item));
            }
            this.timestamp = _data["timestamp"];
        }
    }

    static fromJS(data: any): UpdateValidationsRuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateValidationsRuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["namePrefix"] = this.namePrefix;
        data["name"] = this.name;
        data["field"] = this.field;
        data["nullable"] = this.nullable;
        data["isCCI"] = this.isCCI;
        data["decimalPlaces"] = this.decimalPlaces;
        data["condition"] = this.condition;
        data["valueCondition"] = this.valueCondition ? this.valueCondition.toJSON() : <any>undefined;
        data["dataType"] = this.dataType;
        if (Array.isArray(this.enumConditions)) {
            data["enumConditions"] = [];
            for (let item of this.enumConditions)
                data["enumConditions"].push(item.toJSON());
        }
        data["timestamp"] = this.timestamp;
        return data;
    }
}

export interface IUpdateValidationsRuleRequest {
    id?: number;
    namePrefix?: string | undefined;
    name?: string | undefined;
    field?: string | undefined;
    nullable?: boolean;
    isCCI?: boolean;
    decimalPlaces?: number | undefined;
    condition?: string | undefined;
    valueCondition?: ValueConditionModelDTO;
    dataType?: DataTypeValidation;
    enumConditions?: ValueConditionEnumerationDTO[] | undefined;
    timestamp?: string | undefined;
}

export class UploadIdsImportFileResponse implements IUploadIdsImportFileResponse {
    ok?: boolean;
    done?: boolean;

    constructor(data?: IUploadIdsImportFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.done = _data["done"];
        }
    }

    static fromJS(data: any): UploadIdsImportFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadIdsImportFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["done"] = this.done;
        return data;
    }
}

export interface IUploadIdsImportFileResponse {
    ok?: boolean;
    done?: boolean;
}

export class ValidateModelAndReturnByPairersRequest implements IValidateModelAndReturnByPairersRequest {
    standardId?: number;
    modelData?: string | undefined;
    onlySomeGroups?: boolean;
    validateConditions?: boolean;
    validateNonStandard?: boolean;
    selectedGroupIds?: number[] | undefined;

    constructor(data?: IValidateModelAndReturnByPairersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardId = _data["standardId"];
            this.modelData = _data["modelData"];
            this.onlySomeGroups = _data["onlySomeGroups"];
            this.validateConditions = _data["validateConditions"];
            this.validateNonStandard = _data["validateNonStandard"];
            if (Array.isArray(_data["selectedGroupIds"])) {
                this.selectedGroupIds = [] as any;
                for (let item of _data["selectedGroupIds"])
                    this.selectedGroupIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ValidateModelAndReturnByPairersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateModelAndReturnByPairersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardId"] = this.standardId;
        data["modelData"] = this.modelData;
        data["onlySomeGroups"] = this.onlySomeGroups;
        data["validateConditions"] = this.validateConditions;
        data["validateNonStandard"] = this.validateNonStandard;
        if (Array.isArray(this.selectedGroupIds)) {
            data["selectedGroupIds"] = [];
            for (let item of this.selectedGroupIds)
                data["selectedGroupIds"].push(item);
        }
        return data;
    }
}

export interface IValidateModelAndReturnByPairersRequest {
    standardId?: number;
    modelData?: string | undefined;
    onlySomeGroups?: boolean;
    validateConditions?: boolean;
    validateNonStandard?: boolean;
    selectedGroupIds?: number[] | undefined;
}

export class ValidateModelAndReturnByPairersResponse implements IValidateModelAndReturnByPairersResponse {
    validationsResult?: ValidationTreeResultDTO[] | undefined;
    elapsedTimeMilliseconds?: number;
    elementsCount?: number;
    okPercentage?: number;
    okCount?: number;
    warningPercentage?: number;
    warningCount?: number;
    errorPercentage?: number;
    errorCount?: number;
    missingFieldErrorsCount?: number;
    nullableErrorsCount?: number;
    dataTypeErrorsCount?: number;
    conditionErrorsCount?: number;
    elementsCheckedCount?: number;
    invalidFieldErrorsCount?: number;
    stats?: ResultStatsDTO[] | undefined;
    uncheckedElements?: UncheckedElementDTO[] | undefined;
    unusedPairers?: PairerDTO[] | undefined;
    validationServerTime?: Date;

    constructor(data?: IValidateModelAndReturnByPairersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["validationsResult"])) {
                this.validationsResult = [] as any;
                for (let item of _data["validationsResult"])
                    this.validationsResult!.push(ValidationTreeResultDTO.fromJS(item));
            }
            this.elapsedTimeMilliseconds = _data["elapsedTimeMilliseconds"];
            this.elementsCount = _data["elementsCount"];
            this.okPercentage = _data["okPercentage"];
            this.okCount = _data["okCount"];
            this.warningPercentage = _data["warningPercentage"];
            this.warningCount = _data["warningCount"];
            this.errorPercentage = _data["errorPercentage"];
            this.errorCount = _data["errorCount"];
            this.missingFieldErrorsCount = _data["missingFieldErrorsCount"];
            this.nullableErrorsCount = _data["nullableErrorsCount"];
            this.dataTypeErrorsCount = _data["dataTypeErrorsCount"];
            this.conditionErrorsCount = _data["conditionErrorsCount"];
            this.elementsCheckedCount = _data["elementsCheckedCount"];
            this.invalidFieldErrorsCount = _data["invalidFieldErrorsCount"];
            if (Array.isArray(_data["stats"])) {
                this.stats = [] as any;
                for (let item of _data["stats"])
                    this.stats!.push(ResultStatsDTO.fromJS(item));
            }
            if (Array.isArray(_data["uncheckedElements"])) {
                this.uncheckedElements = [] as any;
                for (let item of _data["uncheckedElements"])
                    this.uncheckedElements!.push(UncheckedElementDTO.fromJS(item));
            }
            if (Array.isArray(_data["unusedPairers"])) {
                this.unusedPairers = [] as any;
                for (let item of _data["unusedPairers"])
                    this.unusedPairers!.push(PairerDTO.fromJS(item));
            }
            this.validationServerTime = _data["validationServerTime"] ? new Date(_data["validationServerTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ValidateModelAndReturnByPairersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateModelAndReturnByPairersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.validationsResult)) {
            data["validationsResult"] = [];
            for (let item of this.validationsResult)
                data["validationsResult"].push(item.toJSON());
        }
        data["elapsedTimeMilliseconds"] = this.elapsedTimeMilliseconds;
        data["elementsCount"] = this.elementsCount;
        data["okPercentage"] = this.okPercentage;
        data["okCount"] = this.okCount;
        data["warningPercentage"] = this.warningPercentage;
        data["warningCount"] = this.warningCount;
        data["errorPercentage"] = this.errorPercentage;
        data["errorCount"] = this.errorCount;
        data["missingFieldErrorsCount"] = this.missingFieldErrorsCount;
        data["nullableErrorsCount"] = this.nullableErrorsCount;
        data["dataTypeErrorsCount"] = this.dataTypeErrorsCount;
        data["conditionErrorsCount"] = this.conditionErrorsCount;
        data["elementsCheckedCount"] = this.elementsCheckedCount;
        data["invalidFieldErrorsCount"] = this.invalidFieldErrorsCount;
        if (Array.isArray(this.stats)) {
            data["stats"] = [];
            for (let item of this.stats)
                data["stats"].push(item.toJSON());
        }
        if (Array.isArray(this.uncheckedElements)) {
            data["uncheckedElements"] = [];
            for (let item of this.uncheckedElements)
                data["uncheckedElements"].push(item.toJSON());
        }
        if (Array.isArray(this.unusedPairers)) {
            data["unusedPairers"] = [];
            for (let item of this.unusedPairers)
                data["unusedPairers"].push(item.toJSON());
        }
        data["validationServerTime"] = this.validationServerTime ? this.validationServerTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IValidateModelAndReturnByPairersResponse {
    validationsResult?: ValidationTreeResultDTO[] | undefined;
    elapsedTimeMilliseconds?: number;
    elementsCount?: number;
    okPercentage?: number;
    okCount?: number;
    warningPercentage?: number;
    warningCount?: number;
    errorPercentage?: number;
    errorCount?: number;
    missingFieldErrorsCount?: number;
    nullableErrorsCount?: number;
    dataTypeErrorsCount?: number;
    conditionErrorsCount?: number;
    elementsCheckedCount?: number;
    invalidFieldErrorsCount?: number;
    stats?: ResultStatsDTO[] | undefined;
    uncheckedElements?: UncheckedElementDTO[] | undefined;
    unusedPairers?: PairerDTO[] | undefined;
    validationServerTime?: Date;
}

export class ValidateModelRequest implements IValidateModelRequest {
    standardId?: number;
    modelData?: string | undefined;
    validateConditions?: boolean;

    constructor(data?: IValidateModelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardId = _data["standardId"];
            this.modelData = _data["modelData"];
            this.validateConditions = _data["validateConditions"];
        }
    }

    static fromJS(data: any): ValidateModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardId"] = this.standardId;
        data["modelData"] = this.modelData;
        data["validateConditions"] = this.validateConditions;
        return data;
    }
}

export interface IValidateModelRequest {
    standardId?: number;
    modelData?: string | undefined;
    validateConditions?: boolean;
}

export class ValidateModelResponse implements IValidateModelResponse {
    validationsResult?: ValidationRowResultDTO[] | undefined;
    elapsedTimeMilliseconds?: number;

    constructor(data?: IValidateModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["validationsResult"])) {
                this.validationsResult = [] as any;
                for (let item of _data["validationsResult"])
                    this.validationsResult!.push(ValidationRowResultDTO.fromJS(item));
            }
            this.elapsedTimeMilliseconds = _data["elapsedTimeMilliseconds"];
        }
    }

    static fromJS(data: any): ValidateModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.validationsResult)) {
            data["validationsResult"] = [];
            for (let item of this.validationsResult)
                data["validationsResult"].push(item.toJSON());
        }
        data["elapsedTimeMilliseconds"] = this.elapsedTimeMilliseconds;
        return data;
    }
}

export interface IValidateModelResponse {
    validationsResult?: ValidationRowResultDTO[] | undefined;
    elapsedTimeMilliseconds?: number;
}

export class ValidateTiltTreeDataRequest implements IValidateTiltTreeDataRequest {
    projectId?: number;

    constructor(data?: IValidateTiltTreeDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): ValidateTiltTreeDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateTiltTreeDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IValidateTiltTreeDataRequest {
    projectId?: number;
}

export class ValidateTiltTreeDataResponse implements IValidateTiltTreeDataResponse {
    projectId?: number;
    projectData?: ProjectDataDTO;
    corridors?: CorridorDTO[] | undefined;

    constructor(data?: IValidateTiltTreeDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectData = _data["projectData"] ? ProjectDataDTO.fromJS(_data["projectData"]) : <any>undefined;
            if (Array.isArray(_data["corridors"])) {
                this.corridors = [] as any;
                for (let item of _data["corridors"])
                    this.corridors!.push(CorridorDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidateTiltTreeDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateTiltTreeDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectData"] = this.projectData ? this.projectData.toJSON() : <any>undefined;
        if (Array.isArray(this.corridors)) {
            data["corridors"] = [];
            for (let item of this.corridors)
                data["corridors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidateTiltTreeDataResponse {
    projectId?: number;
    projectData?: ProjectDataDTO;
    corridors?: CorridorDTO[] | undefined;
}

export class ValidationDesignCrossSectionRequestDTO implements IValidationDesignCrossSectionRequestDTO {
    id?: string | undefined;
    vertexName?: string | undefined;
    isEndStation?: boolean;
    station?: number;
    vn?: number;
    basePoint?: Point3dServer;
    crossSlopeLeftPoint?: Point3dServer;
    crossSlopeRightPoint?: Point3dServer;
    longitudinalSlopeLeftPoint?: Point3dServer;
    longitudinalSlopeLeftPointTo?: Point3dServer;
    longitudinalSlopeRightPoint?: Point3dServer;
    longitudinalSlopeRightPointTo?: Point3dServer;
    crossSlopeLeft?: number | undefined;
    crossSlopeRight?: number | undefined;
    longitudinalSlopeLeft?: number | undefined;
    longitudinalSlopeRight?: number | undefined;
    finalSlopeLeft?: number | undefined;
    finalSlopeRight?: number | undefined;
    crossSlopeLeftInCurve?: number | undefined;
    crossSlopeRightInCurve?: number | undefined;
    paveWidthLeft?: number | undefined;
    paveWidthRight?: number | undefined;
    deltaSLeftPointFrom?: Point3dServer;
    deltaSLeftPointTo?: Point3dServer;
    deltaSRightPointFrom?: Point3dServer;
    deltaSRightPointTo?: Point3dServer;
    aLeftPointFrom?: Point3dServer;
    aRightPointFrom?: Point3dServer;
    deltaSLeft?: number | undefined;
    deltaSRight?: number | undefined;
    aLeft?: number | undefined;
    aRight?: number | undefined;
    spMinLeft?: number | undefined;
    spMinRight?: number | undefined;

    constructor(data?: IValidationDesignCrossSectionRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vertexName = _data["vertexName"];
            this.isEndStation = _data["isEndStation"];
            this.station = _data["station"];
            this.vn = _data["vn"];
            this.basePoint = _data["basePoint"] ? Point3dServer.fromJS(_data["basePoint"]) : <any>undefined;
            this.crossSlopeLeftPoint = _data["crossSlopeLeftPoint"] ? Point3dServer.fromJS(_data["crossSlopeLeftPoint"]) : <any>undefined;
            this.crossSlopeRightPoint = _data["crossSlopeRightPoint"] ? Point3dServer.fromJS(_data["crossSlopeRightPoint"]) : <any>undefined;
            this.longitudinalSlopeLeftPoint = _data["longitudinalSlopeLeftPoint"] ? Point3dServer.fromJS(_data["longitudinalSlopeLeftPoint"]) : <any>undefined;
            this.longitudinalSlopeLeftPointTo = _data["longitudinalSlopeLeftPointTo"] ? Point3dServer.fromJS(_data["longitudinalSlopeLeftPointTo"]) : <any>undefined;
            this.longitudinalSlopeRightPoint = _data["longitudinalSlopeRightPoint"] ? Point3dServer.fromJS(_data["longitudinalSlopeRightPoint"]) : <any>undefined;
            this.longitudinalSlopeRightPointTo = _data["longitudinalSlopeRightPointTo"] ? Point3dServer.fromJS(_data["longitudinalSlopeRightPointTo"]) : <any>undefined;
            this.crossSlopeLeft = _data["crossSlopeLeft"];
            this.crossSlopeRight = _data["crossSlopeRight"];
            this.longitudinalSlopeLeft = _data["longitudinalSlopeLeft"];
            this.longitudinalSlopeRight = _data["longitudinalSlopeRight"];
            this.finalSlopeLeft = _data["finalSlopeLeft"];
            this.finalSlopeRight = _data["finalSlopeRight"];
            this.crossSlopeLeftInCurve = _data["crossSlopeLeftInCurve"];
            this.crossSlopeRightInCurve = _data["crossSlopeRightInCurve"];
            this.paveWidthLeft = _data["paveWidthLeft"];
            this.paveWidthRight = _data["paveWidthRight"];
            this.deltaSLeftPointFrom = _data["deltaSLeftPointFrom"] ? Point3dServer.fromJS(_data["deltaSLeftPointFrom"]) : <any>undefined;
            this.deltaSLeftPointTo = _data["deltaSLeftPointTo"] ? Point3dServer.fromJS(_data["deltaSLeftPointTo"]) : <any>undefined;
            this.deltaSRightPointFrom = _data["deltaSRightPointFrom"] ? Point3dServer.fromJS(_data["deltaSRightPointFrom"]) : <any>undefined;
            this.deltaSRightPointTo = _data["deltaSRightPointTo"] ? Point3dServer.fromJS(_data["deltaSRightPointTo"]) : <any>undefined;
            this.aLeftPointFrom = _data["aLeftPointFrom"] ? Point3dServer.fromJS(_data["aLeftPointFrom"]) : <any>undefined;
            this.aRightPointFrom = _data["aRightPointFrom"] ? Point3dServer.fromJS(_data["aRightPointFrom"]) : <any>undefined;
            this.deltaSLeft = _data["deltaSLeft"];
            this.deltaSRight = _data["deltaSRight"];
            this.aLeft = _data["aLeft"];
            this.aRight = _data["aRight"];
            this.spMinLeft = _data["spMinLeft"];
            this.spMinRight = _data["spMinRight"];
        }
    }

    static fromJS(data: any): ValidationDesignCrossSectionRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationDesignCrossSectionRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vertexName"] = this.vertexName;
        data["isEndStation"] = this.isEndStation;
        data["station"] = this.station;
        data["vn"] = this.vn;
        data["basePoint"] = this.basePoint ? this.basePoint.toJSON() : <any>undefined;
        data["crossSlopeLeftPoint"] = this.crossSlopeLeftPoint ? this.crossSlopeLeftPoint.toJSON() : <any>undefined;
        data["crossSlopeRightPoint"] = this.crossSlopeRightPoint ? this.crossSlopeRightPoint.toJSON() : <any>undefined;
        data["longitudinalSlopeLeftPoint"] = this.longitudinalSlopeLeftPoint ? this.longitudinalSlopeLeftPoint.toJSON() : <any>undefined;
        data["longitudinalSlopeLeftPointTo"] = this.longitudinalSlopeLeftPointTo ? this.longitudinalSlopeLeftPointTo.toJSON() : <any>undefined;
        data["longitudinalSlopeRightPoint"] = this.longitudinalSlopeRightPoint ? this.longitudinalSlopeRightPoint.toJSON() : <any>undefined;
        data["longitudinalSlopeRightPointTo"] = this.longitudinalSlopeRightPointTo ? this.longitudinalSlopeRightPointTo.toJSON() : <any>undefined;
        data["crossSlopeLeft"] = this.crossSlopeLeft;
        data["crossSlopeRight"] = this.crossSlopeRight;
        data["longitudinalSlopeLeft"] = this.longitudinalSlopeLeft;
        data["longitudinalSlopeRight"] = this.longitudinalSlopeRight;
        data["finalSlopeLeft"] = this.finalSlopeLeft;
        data["finalSlopeRight"] = this.finalSlopeRight;
        data["crossSlopeLeftInCurve"] = this.crossSlopeLeftInCurve;
        data["crossSlopeRightInCurve"] = this.crossSlopeRightInCurve;
        data["paveWidthLeft"] = this.paveWidthLeft;
        data["paveWidthRight"] = this.paveWidthRight;
        data["deltaSLeftPointFrom"] = this.deltaSLeftPointFrom ? this.deltaSLeftPointFrom.toJSON() : <any>undefined;
        data["deltaSLeftPointTo"] = this.deltaSLeftPointTo ? this.deltaSLeftPointTo.toJSON() : <any>undefined;
        data["deltaSRightPointFrom"] = this.deltaSRightPointFrom ? this.deltaSRightPointFrom.toJSON() : <any>undefined;
        data["deltaSRightPointTo"] = this.deltaSRightPointTo ? this.deltaSRightPointTo.toJSON() : <any>undefined;
        data["aLeftPointFrom"] = this.aLeftPointFrom ? this.aLeftPointFrom.toJSON() : <any>undefined;
        data["aRightPointFrom"] = this.aRightPointFrom ? this.aRightPointFrom.toJSON() : <any>undefined;
        data["deltaSLeft"] = this.deltaSLeft;
        data["deltaSRight"] = this.deltaSRight;
        data["aLeft"] = this.aLeft;
        data["aRight"] = this.aRight;
        data["spMinLeft"] = this.spMinLeft;
        data["spMinRight"] = this.spMinRight;
        return data;
    }
}

export interface IValidationDesignCrossSectionRequestDTO {
    id?: string | undefined;
    vertexName?: string | undefined;
    isEndStation?: boolean;
    station?: number;
    vn?: number;
    basePoint?: Point3dServer;
    crossSlopeLeftPoint?: Point3dServer;
    crossSlopeRightPoint?: Point3dServer;
    longitudinalSlopeLeftPoint?: Point3dServer;
    longitudinalSlopeLeftPointTo?: Point3dServer;
    longitudinalSlopeRightPoint?: Point3dServer;
    longitudinalSlopeRightPointTo?: Point3dServer;
    crossSlopeLeft?: number | undefined;
    crossSlopeRight?: number | undefined;
    longitudinalSlopeLeft?: number | undefined;
    longitudinalSlopeRight?: number | undefined;
    finalSlopeLeft?: number | undefined;
    finalSlopeRight?: number | undefined;
    crossSlopeLeftInCurve?: number | undefined;
    crossSlopeRightInCurve?: number | undefined;
    paveWidthLeft?: number | undefined;
    paveWidthRight?: number | undefined;
    deltaSLeftPointFrom?: Point3dServer;
    deltaSLeftPointTo?: Point3dServer;
    deltaSRightPointFrom?: Point3dServer;
    deltaSRightPointTo?: Point3dServer;
    aLeftPointFrom?: Point3dServer;
    aRightPointFrom?: Point3dServer;
    deltaSLeft?: number | undefined;
    deltaSRight?: number | undefined;
    aLeft?: number | undefined;
    aRight?: number | undefined;
    spMinLeft?: number | undefined;
    spMinRight?: number | undefined;
}

export class ValidationDesignCrossSectionResponseDTO implements IValidationDesignCrossSectionResponseDTO {
    id?: string | undefined;
    finalSlopeLeftCorrectState?: ValidationSlopeState;
    finalSlopeRightCorrectState?: ValidationSlopeState;
    tooltipFinalSlopeLeft?: string | undefined;
    tooltipFinalSlopeRight?: string | undefined;
    isCrossSlopeLeftInCurveCorrect?: boolean;
    isCrossSlopeRightInCurveCorrect?: boolean;
    tooltipCrossSlopeLeftInCurve?: string | undefined;
    tooltipCrossSlopeRightInCurve?: string | undefined;
    spminLeftCorrectState?: ValidationSlopeState;
    spminLeftTooltip?: string | undefined;
    spminRightCorrectState?: ValidationSlopeState;
    spminRightTooltip?: string | undefined;
    deltaSLeftCorrectState?: ValidationSlopeState;
    deltaSLeftTooltip?: string | undefined;
    deltaSRightCorrectState?: ValidationSlopeState;
    deltaSRightTooltip?: string | undefined;

    constructor(data?: IValidationDesignCrossSectionResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.finalSlopeLeftCorrectState = _data["finalSlopeLeftCorrectState"];
            this.finalSlopeRightCorrectState = _data["finalSlopeRightCorrectState"];
            this.tooltipFinalSlopeLeft = _data["tooltipFinalSlopeLeft"];
            this.tooltipFinalSlopeRight = _data["tooltipFinalSlopeRight"];
            this.isCrossSlopeLeftInCurveCorrect = _data["isCrossSlopeLeftInCurveCorrect"];
            this.isCrossSlopeRightInCurveCorrect = _data["isCrossSlopeRightInCurveCorrect"];
            this.tooltipCrossSlopeLeftInCurve = _data["tooltipCrossSlopeLeftInCurve"];
            this.tooltipCrossSlopeRightInCurve = _data["tooltipCrossSlopeRightInCurve"];
            this.spminLeftCorrectState = _data["spminLeftCorrectState"];
            this.spminLeftTooltip = _data["spminLeftTooltip"];
            this.spminRightCorrectState = _data["spminRightCorrectState"];
            this.spminRightTooltip = _data["spminRightTooltip"];
            this.deltaSLeftCorrectState = _data["deltaSLeftCorrectState"];
            this.deltaSLeftTooltip = _data["deltaSLeftTooltip"];
            this.deltaSRightCorrectState = _data["deltaSRightCorrectState"];
            this.deltaSRightTooltip = _data["deltaSRightTooltip"];
        }
    }

    static fromJS(data: any): ValidationDesignCrossSectionResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationDesignCrossSectionResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["finalSlopeLeftCorrectState"] = this.finalSlopeLeftCorrectState;
        data["finalSlopeRightCorrectState"] = this.finalSlopeRightCorrectState;
        data["tooltipFinalSlopeLeft"] = this.tooltipFinalSlopeLeft;
        data["tooltipFinalSlopeRight"] = this.tooltipFinalSlopeRight;
        data["isCrossSlopeLeftInCurveCorrect"] = this.isCrossSlopeLeftInCurveCorrect;
        data["isCrossSlopeRightInCurveCorrect"] = this.isCrossSlopeRightInCurveCorrect;
        data["tooltipCrossSlopeLeftInCurve"] = this.tooltipCrossSlopeLeftInCurve;
        data["tooltipCrossSlopeRightInCurve"] = this.tooltipCrossSlopeRightInCurve;
        data["spminLeftCorrectState"] = this.spminLeftCorrectState;
        data["spminLeftTooltip"] = this.spminLeftTooltip;
        data["spminRightCorrectState"] = this.spminRightCorrectState;
        data["spminRightTooltip"] = this.spminRightTooltip;
        data["deltaSLeftCorrectState"] = this.deltaSLeftCorrectState;
        data["deltaSLeftTooltip"] = this.deltaSLeftTooltip;
        data["deltaSRightCorrectState"] = this.deltaSRightCorrectState;
        data["deltaSRightTooltip"] = this.deltaSRightTooltip;
        return data;
    }
}

export interface IValidationDesignCrossSectionResponseDTO {
    id?: string | undefined;
    finalSlopeLeftCorrectState?: ValidationSlopeState;
    finalSlopeRightCorrectState?: ValidationSlopeState;
    tooltipFinalSlopeLeft?: string | undefined;
    tooltipFinalSlopeRight?: string | undefined;
    isCrossSlopeLeftInCurveCorrect?: boolean;
    isCrossSlopeRightInCurveCorrect?: boolean;
    tooltipCrossSlopeLeftInCurve?: string | undefined;
    tooltipCrossSlopeRightInCurve?: string | undefined;
    spminLeftCorrectState?: ValidationSlopeState;
    spminLeftTooltip?: string | undefined;
    spminRightCorrectState?: ValidationSlopeState;
    spminRightTooltip?: string | undefined;
    deltaSLeftCorrectState?: ValidationSlopeState;
    deltaSLeftTooltip?: string | undefined;
    deltaSRightCorrectState?: ValidationSlopeState;
    deltaSRightTooltip?: string | undefined;
}

export class ValidationDesignDataGridSectionDTO implements IValidationDesignDataGridSectionDTO {
    id?: string | undefined;
    vertexName?: string | undefined;
    station?: number;
    station_km?: number;
    vn?: number;
    crossSlopeLeft?: number | undefined;
    crossSlopeRight?: number | undefined;
    longitudinalSlopeLeft?: number | undefined;
    longitudinalSlopeRight?: number | undefined;
    finalSlopeLeft?: number | undefined;
    finalSlopeRight?: number | undefined;
    limitFinalSlope?: number | undefined;
    crossSlopeLeftInCurve?: number | undefined;
    crossSlopeRightInCurve?: number | undefined;
    paveWidthLeft?: number | undefined;
    paveWidthRight?: number | undefined;
    deltaSLeft?: number | undefined;
    deltaSRight?: number | undefined;
    aLeft?: number | undefined;
    aRight?: number | undefined;
    spMinLeft?: number | undefined;
    spMinRight?: number | undefined;
    finalSlopeLeftCorrectState?: ValidationSlopeState;
    finalSlopeRightCorrectState?: ValidationSlopeState;
    tooltipFinalSlopeLeft?: string | undefined;
    tooltipFinalSlopeRight?: string | undefined;
    isCrossSlopeLeftInCurveCorrect?: boolean;
    isCrossSlopeRightInCurveCorrect?: boolean;
    tooltipCrossSlopeLeftInCurve?: string | undefined;
    tooltipCrossSlopeRightInCurve?: string | undefined;
    spminLeftCorrectState?: ValidationSlopeState;
    spminLeftTooltip?: string | undefined;
    spminRightCorrectState?: ValidationSlopeState;
    spminRightTooltip?: string | undefined;
    deltaSLeftCorrectState?: ValidationSlopeState;
    deltaSLeftTooltip?: string | undefined;
    deltaSRightCorrectState?: ValidationSlopeState;
    deltaSRightTooltip?: string | undefined;

    constructor(data?: IValidationDesignDataGridSectionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vertexName = _data["vertexName"];
            this.station = _data["station"];
            this.station_km = _data["station_km"];
            this.vn = _data["vn"];
            this.crossSlopeLeft = _data["crossSlopeLeft"];
            this.crossSlopeRight = _data["crossSlopeRight"];
            this.longitudinalSlopeLeft = _data["longitudinalSlopeLeft"];
            this.longitudinalSlopeRight = _data["longitudinalSlopeRight"];
            this.finalSlopeLeft = _data["finalSlopeLeft"];
            this.finalSlopeRight = _data["finalSlopeRight"];
            this.limitFinalSlope = _data["limitFinalSlope"];
            this.crossSlopeLeftInCurve = _data["crossSlopeLeftInCurve"];
            this.crossSlopeRightInCurve = _data["crossSlopeRightInCurve"];
            this.paveWidthLeft = _data["paveWidthLeft"];
            this.paveWidthRight = _data["paveWidthRight"];
            this.deltaSLeft = _data["deltaSLeft"];
            this.deltaSRight = _data["deltaSRight"];
            this.aLeft = _data["aLeft"];
            this.aRight = _data["aRight"];
            this.spMinLeft = _data["spMinLeft"];
            this.spMinRight = _data["spMinRight"];
            this.finalSlopeLeftCorrectState = _data["finalSlopeLeftCorrectState"];
            this.finalSlopeRightCorrectState = _data["finalSlopeRightCorrectState"];
            this.tooltipFinalSlopeLeft = _data["tooltipFinalSlopeLeft"];
            this.tooltipFinalSlopeRight = _data["tooltipFinalSlopeRight"];
            this.isCrossSlopeLeftInCurveCorrect = _data["isCrossSlopeLeftInCurveCorrect"];
            this.isCrossSlopeRightInCurveCorrect = _data["isCrossSlopeRightInCurveCorrect"];
            this.tooltipCrossSlopeLeftInCurve = _data["tooltipCrossSlopeLeftInCurve"];
            this.tooltipCrossSlopeRightInCurve = _data["tooltipCrossSlopeRightInCurve"];
            this.spminLeftCorrectState = _data["spminLeftCorrectState"];
            this.spminLeftTooltip = _data["spminLeftTooltip"];
            this.spminRightCorrectState = _data["spminRightCorrectState"];
            this.spminRightTooltip = _data["spminRightTooltip"];
            this.deltaSLeftCorrectState = _data["deltaSLeftCorrectState"];
            this.deltaSLeftTooltip = _data["deltaSLeftTooltip"];
            this.deltaSRightCorrectState = _data["deltaSRightCorrectState"];
            this.deltaSRightTooltip = _data["deltaSRightTooltip"];
        }
    }

    static fromJS(data: any): ValidationDesignDataGridSectionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationDesignDataGridSectionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vertexName"] = this.vertexName;
        data["station"] = this.station;
        data["station_km"] = this.station_km;
        data["vn"] = this.vn;
        data["crossSlopeLeft"] = this.crossSlopeLeft;
        data["crossSlopeRight"] = this.crossSlopeRight;
        data["longitudinalSlopeLeft"] = this.longitudinalSlopeLeft;
        data["longitudinalSlopeRight"] = this.longitudinalSlopeRight;
        data["finalSlopeLeft"] = this.finalSlopeLeft;
        data["finalSlopeRight"] = this.finalSlopeRight;
        data["limitFinalSlope"] = this.limitFinalSlope;
        data["crossSlopeLeftInCurve"] = this.crossSlopeLeftInCurve;
        data["crossSlopeRightInCurve"] = this.crossSlopeRightInCurve;
        data["paveWidthLeft"] = this.paveWidthLeft;
        data["paveWidthRight"] = this.paveWidthRight;
        data["deltaSLeft"] = this.deltaSLeft;
        data["deltaSRight"] = this.deltaSRight;
        data["aLeft"] = this.aLeft;
        data["aRight"] = this.aRight;
        data["spMinLeft"] = this.spMinLeft;
        data["spMinRight"] = this.spMinRight;
        data["finalSlopeLeftCorrectState"] = this.finalSlopeLeftCorrectState;
        data["finalSlopeRightCorrectState"] = this.finalSlopeRightCorrectState;
        data["tooltipFinalSlopeLeft"] = this.tooltipFinalSlopeLeft;
        data["tooltipFinalSlopeRight"] = this.tooltipFinalSlopeRight;
        data["isCrossSlopeLeftInCurveCorrect"] = this.isCrossSlopeLeftInCurveCorrect;
        data["isCrossSlopeRightInCurveCorrect"] = this.isCrossSlopeRightInCurveCorrect;
        data["tooltipCrossSlopeLeftInCurve"] = this.tooltipCrossSlopeLeftInCurve;
        data["tooltipCrossSlopeRightInCurve"] = this.tooltipCrossSlopeRightInCurve;
        data["spminLeftCorrectState"] = this.spminLeftCorrectState;
        data["spminLeftTooltip"] = this.spminLeftTooltip;
        data["spminRightCorrectState"] = this.spminRightCorrectState;
        data["spminRightTooltip"] = this.spminRightTooltip;
        data["deltaSLeftCorrectState"] = this.deltaSLeftCorrectState;
        data["deltaSLeftTooltip"] = this.deltaSLeftTooltip;
        data["deltaSRightCorrectState"] = this.deltaSRightCorrectState;
        data["deltaSRightTooltip"] = this.deltaSRightTooltip;
        return data;
    }
}

export interface IValidationDesignDataGridSectionDTO {
    id?: string | undefined;
    vertexName?: string | undefined;
    station?: number;
    station_km?: number;
    vn?: number;
    crossSlopeLeft?: number | undefined;
    crossSlopeRight?: number | undefined;
    longitudinalSlopeLeft?: number | undefined;
    longitudinalSlopeRight?: number | undefined;
    finalSlopeLeft?: number | undefined;
    finalSlopeRight?: number | undefined;
    limitFinalSlope?: number | undefined;
    crossSlopeLeftInCurve?: number | undefined;
    crossSlopeRightInCurve?: number | undefined;
    paveWidthLeft?: number | undefined;
    paveWidthRight?: number | undefined;
    deltaSLeft?: number | undefined;
    deltaSRight?: number | undefined;
    aLeft?: number | undefined;
    aRight?: number | undefined;
    spMinLeft?: number | undefined;
    spMinRight?: number | undefined;
    finalSlopeLeftCorrectState?: ValidationSlopeState;
    finalSlopeRightCorrectState?: ValidationSlopeState;
    tooltipFinalSlopeLeft?: string | undefined;
    tooltipFinalSlopeRight?: string | undefined;
    isCrossSlopeLeftInCurveCorrect?: boolean;
    isCrossSlopeRightInCurveCorrect?: boolean;
    tooltipCrossSlopeLeftInCurve?: string | undefined;
    tooltipCrossSlopeRightInCurve?: string | undefined;
    spminLeftCorrectState?: ValidationSlopeState;
    spminLeftTooltip?: string | undefined;
    spminRightCorrectState?: ValidationSlopeState;
    spminRightTooltip?: string | undefined;
    deltaSLeftCorrectState?: ValidationSlopeState;
    deltaSLeftTooltip?: string | undefined;
    deltaSRightCorrectState?: ValidationSlopeState;
    deltaSRightTooltip?: string | undefined;
}

export class ValidationDesignEntityRequestDTO implements IValidationDesignEntityRequestDTO {
    entityType?: ValidationDesignEntityType;
    crossSections?: ValidationDesignCrossSectionRequestDTO[] | undefined;
    startStation?: number;
    endStation?: number;
    startPoint?: Point3dServer;
    endPoint?: Point3dServer;

    constructor(data?: IValidationDesignEntityRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            if (Array.isArray(_data["crossSections"])) {
                this.crossSections = [] as any;
                for (let item of _data["crossSections"])
                    this.crossSections!.push(ValidationDesignCrossSectionRequestDTO.fromJS(item));
            }
            this.startStation = _data["startStation"];
            this.endStation = _data["endStation"];
            this.startPoint = _data["startPoint"] ? Point3dServer.fromJS(_data["startPoint"]) : <any>undefined;
            this.endPoint = _data["endPoint"] ? Point3dServer.fromJS(_data["endPoint"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ValidationDesignEntityRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationDesignEntityRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        if (Array.isArray(this.crossSections)) {
            data["crossSections"] = [];
            for (let item of this.crossSections)
                data["crossSections"].push(item.toJSON());
        }
        data["startStation"] = this.startStation;
        data["endStation"] = this.endStation;
        data["startPoint"] = this.startPoint ? this.startPoint.toJSON() : <any>undefined;
        data["endPoint"] = this.endPoint ? this.endPoint.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValidationDesignEntityRequestDTO {
    entityType?: ValidationDesignEntityType;
    crossSections?: ValidationDesignCrossSectionRequestDTO[] | undefined;
    startStation?: number;
    endStation?: number;
    startPoint?: Point3dServer;
    endPoint?: Point3dServer;
}

export enum ValidationDesignEntityType {
    None = "None",
    Tangent = "Tangent",
    Spiral = "Spiral",
    Curve = "Curve",
    Perpendicular = "Perpendicular",
}

export class ValidationDesignHectoServer implements IValidationDesignHectoServer {
    station?: number;
    basePoint?: Point3dServer;
    crossPoint?: Point3dServer;

    constructor(data?: IValidationDesignHectoServer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.station = _data["station"];
            this.basePoint = _data["basePoint"] ? Point3dServer.fromJS(_data["basePoint"]) : <any>undefined;
            this.crossPoint = _data["crossPoint"] ? Point3dServer.fromJS(_data["crossPoint"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ValidationDesignHectoServer {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationDesignHectoServer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["station"] = this.station;
        data["basePoint"] = this.basePoint ? this.basePoint.toJSON() : <any>undefined;
        data["crossPoint"] = this.crossPoint ? this.crossPoint.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValidationDesignHectoServer {
    station?: number;
    basePoint?: Point3dServer;
    crossPoint?: Point3dServer;
}

export class ValidationDesignSlopePluginRequest implements IValidationDesignSlopePluginRequest {
    projectId?: number;
    data?: ValidationDesignSlopeRequest;

    constructor(data?: IValidationDesignSlopePluginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.data = _data["data"] ? ValidationDesignSlopeRequest.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ValidationDesignSlopePluginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationDesignSlopePluginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValidationDesignSlopePluginRequest {
    projectId?: number;
    data?: ValidationDesignSlopeRequest;
}

export class ValidationDesignSlopeRequest implements IValidationDesignSlopeRequest {
    isHighway?: boolean;
    projectId?: number;
    corridorName?: string | undefined;
    baseLineName?: string | undefined;
    startStation?: number;
    endStation?: number;
    entities?: ValidationDesignEntityRequestDTO[] | undefined;
    hectos?: ValidationDesignHectoServer[] | undefined;

    constructor(data?: IValidationDesignSlopeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isHighway = _data["isHighway"];
            this.projectId = _data["projectId"];
            this.corridorName = _data["corridorName"];
            this.baseLineName = _data["baseLineName"];
            this.startStation = _data["startStation"];
            this.endStation = _data["endStation"];
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(ValidationDesignEntityRequestDTO.fromJS(item));
            }
            if (Array.isArray(_data["hectos"])) {
                this.hectos = [] as any;
                for (let item of _data["hectos"])
                    this.hectos!.push(ValidationDesignHectoServer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationDesignSlopeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationDesignSlopeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isHighway"] = this.isHighway;
        data["projectId"] = this.projectId;
        data["corridorName"] = this.corridorName;
        data["baseLineName"] = this.baseLineName;
        data["startStation"] = this.startStation;
        data["endStation"] = this.endStation;
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        if (Array.isArray(this.hectos)) {
            data["hectos"] = [];
            for (let item of this.hectos)
                data["hectos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidationDesignSlopeRequest {
    isHighway?: boolean;
    projectId?: number;
    corridorName?: string | undefined;
    baseLineName?: string | undefined;
    startStation?: number;
    endStation?: number;
    entities?: ValidationDesignEntityRequestDTO[] | undefined;
    hectos?: ValidationDesignHectoServer[] | undefined;
}

export class ValidationDesignSlopeResponse implements IValidationDesignSlopeResponse {
    serverURL?: string | undefined;
    crossSections?: ValidationDesignCrossSectionResponseDTO[] | undefined;

    constructor(data?: IValidationDesignSlopeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverURL = _data["serverURL"];
            if (Array.isArray(_data["crossSections"])) {
                this.crossSections = [] as any;
                for (let item of _data["crossSections"])
                    this.crossSections!.push(ValidationDesignCrossSectionResponseDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationDesignSlopeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationDesignSlopeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverURL"] = this.serverURL;
        if (Array.isArray(this.crossSections)) {
            data["crossSections"] = [];
            for (let item of this.crossSections)
                data["crossSections"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidationDesignSlopeResponse {
    serverURL?: string | undefined;
    crossSections?: ValidationDesignCrossSectionResponseDTO[] | undefined;
}

export class ValidationElementDTO implements IValidationElementDTO {
    expressId?: number;
    modelId?: number;

    constructor(data?: IValidationElementDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressId = _data["expressId"];
            this.modelId = _data["modelId"];
        }
    }

    static fromJS(data: any): ValidationElementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationElementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expressId"] = this.expressId;
        data["modelId"] = this.modelId;
        return data;
    }
}

export interface IValidationElementDTO {
    expressId?: number;
    modelId?: number;
}

export class ValidationOrGroupDTO implements IValidationOrGroupDTO {
    groupId?: number;
    groupName?: string | undefined;
    orGroupItems?: PairerDetailValidationRuleDTO[] | undefined;

    constructor(data?: IValidationOrGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["orGroupItems"])) {
                this.orGroupItems = [] as any;
                for (let item of _data["orGroupItems"])
                    this.orGroupItems!.push(PairerDetailValidationRuleDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationOrGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationOrGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        if (Array.isArray(this.orGroupItems)) {
            data["orGroupItems"] = [];
            for (let item of this.orGroupItems)
                data["orGroupItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidationOrGroupDTO {
    groupId?: number;
    groupName?: string | undefined;
    orGroupItems?: PairerDetailValidationRuleDTO[] | undefined;
}

export class ValidationResponse implements IValidationResponse {
    elements?: ValidationElementDTO[] | undefined;

    constructor(data?: IValidationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ValidationElementDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidationResponse {
    elements?: ValidationElementDTO[] | undefined;
}

export class ValidationResultDTO implements IValidationResultDTO {
    pairerId?: number;
    pairerName?: string | undefined;
    expressId?: number;
    resultItems?: ValidationResultItemDTO[] | undefined;
    resultGroups?: ValidationResultGroupDTO[] | undefined;

    constructor(data?: IValidationResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pairerId = _data["pairerId"];
            this.pairerName = _data["pairerName"];
            this.expressId = _data["expressId"];
            if (Array.isArray(_data["resultItems"])) {
                this.resultItems = [] as any;
                for (let item of _data["resultItems"])
                    this.resultItems!.push(ValidationResultItemDTO.fromJS(item));
            }
            if (Array.isArray(_data["resultGroups"])) {
                this.resultGroups = [] as any;
                for (let item of _data["resultGroups"])
                    this.resultGroups!.push(ValidationResultGroupDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pairerId"] = this.pairerId;
        data["pairerName"] = this.pairerName;
        data["expressId"] = this.expressId;
        if (Array.isArray(this.resultItems)) {
            data["resultItems"] = [];
            for (let item of this.resultItems)
                data["resultItems"].push(item.toJSON());
        }
        if (Array.isArray(this.resultGroups)) {
            data["resultGroups"] = [];
            for (let item of this.resultGroups)
                data["resultGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidationResultDTO {
    pairerId?: number;
    pairerName?: string | undefined;
    expressId?: number;
    resultItems?: ValidationResultItemDTO[] | undefined;
    resultGroups?: ValidationResultGroupDTO[] | undefined;
}

export class ValidationResultGroupDTO implements IValidationResultGroupDTO {
    ok?: boolean;
    groupId?: number;
    groupName?: string | undefined;
    resultGroupsItems?: ValidationResultItemDTO[] | undefined;

    constructor(data?: IValidationResultGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["resultGroupsItems"])) {
                this.resultGroupsItems = [] as any;
                for (let item of _data["resultGroupsItems"])
                    this.resultGroupsItems!.push(ValidationResultItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationResultGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationResultGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        if (Array.isArray(this.resultGroupsItems)) {
            data["resultGroupsItems"] = [];
            for (let item of this.resultGroupsItems)
                data["resultGroupsItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidationResultGroupDTO {
    ok?: boolean;
    groupId?: number;
    groupName?: string | undefined;
    resultGroupsItems?: ValidationResultItemDTO[] | undefined;
}

export class ValidationResultItemDTO implements IValidationResultItemDTO {
    ok?: boolean;
    message?: string | undefined;
    propertyName?: string | undefined;
    expressId?: number;
    modelId?: string | undefined;
    invalidityReason?: InvalidFieldReasons;
    dataTypeValidation?: DataTypeValidation;
    isNullable?: boolean;
    pairerId?: number;
    groupIndex?: number | undefined;
    orGroupId?: number | undefined;
    orGroupName?: string | undefined;
    isOrGroupOk?: boolean | undefined;

    constructor(data?: IValidationResultItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.message = _data["message"];
            this.propertyName = _data["propertyName"];
            this.expressId = _data["expressId"];
            this.modelId = _data["modelId"];
            this.invalidityReason = _data["invalidityReason"];
            this.dataTypeValidation = _data["dataTypeValidation"];
            this.isNullable = _data["isNullable"];
            this.pairerId = _data["pairerId"];
            this.groupIndex = _data["groupIndex"];
            this.orGroupId = _data["orGroupId"];
            this.orGroupName = _data["orGroupName"];
            this.isOrGroupOk = _data["isOrGroupOk"];
        }
    }

    static fromJS(data: any): ValidationResultItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationResultItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["message"] = this.message;
        data["propertyName"] = this.propertyName;
        data["expressId"] = this.expressId;
        data["modelId"] = this.modelId;
        data["invalidityReason"] = this.invalidityReason;
        data["dataTypeValidation"] = this.dataTypeValidation;
        data["isNullable"] = this.isNullable;
        data["pairerId"] = this.pairerId;
        data["groupIndex"] = this.groupIndex;
        data["orGroupId"] = this.orGroupId;
        data["orGroupName"] = this.orGroupName;
        data["isOrGroupOk"] = this.isOrGroupOk;
        return data;
    }
}

export interface IValidationResultItemDTO {
    ok?: boolean;
    message?: string | undefined;
    propertyName?: string | undefined;
    expressId?: number;
    modelId?: string | undefined;
    invalidityReason?: InvalidFieldReasons;
    dataTypeValidation?: DataTypeValidation;
    isNullable?: boolean;
    pairerId?: number;
    groupIndex?: number | undefined;
    orGroupId?: number | undefined;
    orGroupName?: string | undefined;
    isOrGroupOk?: boolean | undefined;
}

export class ValidationRowResultDTO implements IValidationRowResultDTO {
    expressId?: number;
    isCompletelyValid?: boolean;
    validationsResults?: ValidationResultDTO[] | undefined;

    constructor(data?: IValidationRowResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressId = _data["expressId"];
            this.isCompletelyValid = _data["isCompletelyValid"];
            if (Array.isArray(_data["validationsResults"])) {
                this.validationsResults = [] as any;
                for (let item of _data["validationsResults"])
                    this.validationsResults!.push(ValidationResultDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationRowResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationRowResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expressId"] = this.expressId;
        data["isCompletelyValid"] = this.isCompletelyValid;
        if (Array.isArray(this.validationsResults)) {
            data["validationsResults"] = [];
            for (let item of this.validationsResults)
                data["validationsResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidationRowResultDTO {
    expressId?: number;
    isCompletelyValid?: boolean;
    validationsResults?: ValidationResultDTO[] | undefined;
}

export class ValidationRuleEnumDTO implements IValidationRuleEnumDTO {
    value?: string | undefined;

    constructor(data?: IValidationRuleEnumDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ValidationRuleEnumDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationRuleEnumDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IValidationRuleEnumDTO {
    value?: string | undefined;
}

export class ValidationRuleFullTreeDTO implements IValidationRuleFullTreeDTO {
    id?: number;
    field?: string | undefined;
    namePrefix?: string | undefined;
    dataType?: DataTypeValidation;
    decimalPlaces?: number | undefined;
    validationRuleEnums?: ValidationRuleEnumDTO[] | undefined;

    constructor(data?: IValidationRuleFullTreeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.field = _data["field"];
            this.namePrefix = _data["namePrefix"];
            this.dataType = _data["dataType"];
            this.decimalPlaces = _data["decimalPlaces"];
            if (Array.isArray(_data["validationRuleEnums"])) {
                this.validationRuleEnums = [] as any;
                for (let item of _data["validationRuleEnums"])
                    this.validationRuleEnums!.push(ValidationRuleEnumDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationRuleFullTreeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationRuleFullTreeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["field"] = this.field;
        data["namePrefix"] = this.namePrefix;
        data["dataType"] = this.dataType;
        data["decimalPlaces"] = this.decimalPlaces;
        if (Array.isArray(this.validationRuleEnums)) {
            data["validationRuleEnums"] = [];
            for (let item of this.validationRuleEnums)
                data["validationRuleEnums"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidationRuleFullTreeDTO {
    id?: number;
    field?: string | undefined;
    namePrefix?: string | undefined;
    dataType?: DataTypeValidation;
    decimalPlaces?: number | undefined;
    validationRuleEnums?: ValidationRuleEnumDTO[] | undefined;
}

export enum ValidationSlopeState {
    None = "None",
    Correct = "Correct",
    Error = "Error",
    Warning = "Warning",
}

export class ValidationTreeResultDTO implements IValidationTreeResultDTO {
    pairerId?: number;
    pairerName?: string | undefined;
    countElementsValidated?: number;
    isCompletelyValid?: boolean;
    validationsResultElements?: ValidationTreeResultElementsDTO[] | undefined;
    rules?: PairerDetailValidationRuleDTO[] | undefined;
    isExpanded?: boolean;

    constructor(data?: IValidationTreeResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pairerId = _data["pairerId"];
            this.pairerName = _data["pairerName"];
            this.countElementsValidated = _data["countElementsValidated"];
            this.isCompletelyValid = _data["isCompletelyValid"];
            if (Array.isArray(_data["validationsResultElements"])) {
                this.validationsResultElements = [] as any;
                for (let item of _data["validationsResultElements"])
                    this.validationsResultElements!.push(ValidationTreeResultElementsDTO.fromJS(item));
            }
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(PairerDetailValidationRuleDTO.fromJS(item));
            }
            this.isExpanded = _data["isExpanded"];
        }
    }

    static fromJS(data: any): ValidationTreeResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationTreeResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pairerId"] = this.pairerId;
        data["pairerName"] = this.pairerName;
        data["countElementsValidated"] = this.countElementsValidated;
        data["isCompletelyValid"] = this.isCompletelyValid;
        if (Array.isArray(this.validationsResultElements)) {
            data["validationsResultElements"] = [];
            for (let item of this.validationsResultElements)
                data["validationsResultElements"].push(item.toJSON());
        }
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        data["isExpanded"] = this.isExpanded;
        return data;
    }
}

export interface IValidationTreeResultDTO {
    pairerId?: number;
    pairerName?: string | undefined;
    countElementsValidated?: number;
    isCompletelyValid?: boolean;
    validationsResultElements?: ValidationTreeResultElementsDTO[] | undefined;
    rules?: PairerDetailValidationRuleDTO[] | undefined;
    isExpanded?: boolean;
}

export class ValidationTreeResultElementsDTO implements IValidationTreeResultElementsDTO {
    expressId?: number;
    pairerId?: number;
    modelId?: string | undefined;
    isCompletelyValid?: boolean;
    resultItems?: ValidationResultItemDTO[] | undefined;

    constructor(data?: IValidationTreeResultElementsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressId = _data["expressId"];
            this.pairerId = _data["pairerId"];
            this.modelId = _data["modelId"];
            this.isCompletelyValid = _data["isCompletelyValid"];
            if (Array.isArray(_data["resultItems"])) {
                this.resultItems = [] as any;
                for (let item of _data["resultItems"])
                    this.resultItems!.push(ValidationResultItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationTreeResultElementsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationTreeResultElementsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expressId"] = this.expressId;
        data["pairerId"] = this.pairerId;
        data["modelId"] = this.modelId;
        data["isCompletelyValid"] = this.isCompletelyValid;
        if (Array.isArray(this.resultItems)) {
            data["resultItems"] = [];
            for (let item of this.resultItems)
                data["resultItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidationTreeResultElementsDTO {
    expressId?: number;
    pairerId?: number;
    modelId?: string | undefined;
    isCompletelyValid?: boolean;
    resultItems?: ValidationResultItemDTO[] | undefined;
}

export class ValueConditionEnumerationDTO implements IValueConditionEnumerationDTO {
    id?: number;
    value?: string | undefined;
    dataType?: DataTypeValidation;

    constructor(data?: IValueConditionEnumerationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.dataType = _data["dataType"];
        }
    }

    static fromJS(data: any): ValueConditionEnumerationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValueConditionEnumerationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["dataType"] = this.dataType;
        return data;
    }
}

export interface IValueConditionEnumerationDTO {
    id?: number;
    value?: string | undefined;
    dataType?: DataTypeValidation;
}

export class ValueConditionModelDTO implements IValueConditionModelDTO {
    conditionType?: ValueConditionType;
    value1?: string | undefined;
    value2?: string | undefined;
    numberOfDecimalPlaces?: number | undefined;

    constructor(data?: IValueConditionModelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conditionType = _data["conditionType"];
            this.value1 = _data["value1"];
            this.value2 = _data["value2"];
            this.numberOfDecimalPlaces = _data["numberOfDecimalPlaces"];
        }
    }

    static fromJS(data: any): ValueConditionModelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValueConditionModelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conditionType"] = this.conditionType;
        data["value1"] = this.value1;
        data["value2"] = this.value2;
        data["numberOfDecimalPlaces"] = this.numberOfDecimalPlaces;
        return data;
    }
}

export interface IValueConditionModelDTO {
    conditionType?: ValueConditionType;
    value1?: string | undefined;
    value2?: string | undefined;
    numberOfDecimalPlaces?: number | undefined;
}

export enum ValueConditionType {
    EqualsValue = "EqualsValue",
    LessThan = "LessThan",
    LessThanOrEqual = "LessThanOrEqual",
    GreaterThan = "GreaterThan",
    GreaterThanOrEqual = "GreaterThanOrEqual",
    Between = "Between",
    Enumeration = "Enumeration",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}